<template>
    <div class="col-md-12 col-lg-12 mobile_pl_15 review_and_pay_page">
        <!-- <div class="cart_summary h-100 white_box py_52 px_52 cart-shipping-address">
        <div class="thankyou_submited_block">
            <div class="thankyou_icon_wrapper">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white"/>
                </svg>
            </div>
            <h2 class="thankyou_title">Thank you!</h2>
            <p class="thankyou_message">
                Your Order Has Been Placed, View Your Order <a href="#" class="order_number">4416933</a>
            </p>
            <button type="button" class="continue_shopping_btn" @click="handleContinueShopping">
                CONTINUE SHOPPING
            </button>
        </div>
    </div> -->

        <!-- <h4
                class="font_size_30 d-flex mb_28 cart_summary_heading_h4"
                v-if="is_reviewpay"
            >
                Product Summary
                <router-link
                    v-show="cartNotEmpty"
                    :to="{ path: '/cart/v3' }"
                    class="ml-auto"
                    title="Edit Cart"
                    ><img src="/maincss/images/edit.svg" alt=" "
                /></router-link>
            </h4> -->
        <!-- <h4 class="font_size_30 d-flex mb_28 cart_summary_heading_h4" v-else>
        4. Review & pay
        <router-link
          v-show="cartNotEmpty"
          :to="{ path: '/cart/v3' }"
          class="ml-auto"
          title="Edit Cart"
          ><img src="/maincss/images/edit.svg" alt=" "
        /></router-link>
      </h4> -->
        <!-- <div class="review_and_pay_page_content">
          <div>
              <h3 class="r_and_p_heading mb_20">Billing & Shipping Addresss 
                <button type="button" class="rp_edit_btn">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_6501_108990)">
                      <path d="M15.5519 2.59289L13.3732 0.412323C12.8242 -0.137089 11.8693 -0.138145 11.3182 0.413379L1.5579 10.27C1.51464 10.3136 1.48342 10.3672 1.4664 10.4261L0.0139372 15.5141C-0.02225 15.6409 0.0132223 15.7775 0.106499 15.8708C0.175639 15.9401 0.268201 15.9773 0.363248 15.9773C0.396576 15.9773 0.430278 15.9727 0.46289 15.9635L5.54657 14.5098C5.60543 14.4927 5.65898 14.4615 5.70258 14.4182L15.5519 4.64854C15.8264 4.37386 15.9774 4.00899 15.9774 3.62073C15.9774 3.23248 15.8264 2.86757 15.5519 2.59289ZM9.73581 3.05481L11.0725 4.39146L4.09387 11.3701L3.59304 10.3681C3.53132 10.245 3.4058 10.1674 3.2682 10.1674H2.68669L9.73581 3.05481ZM0.891963 15.0854L1.36495 13.4297L2.54766 14.6124L0.891963 15.0854ZM5.08379 13.8879L3.34643 14.3842L1.59314 12.6309L2.08944 10.8936H3.04369L3.66956 12.1454C3.70466 12.2156 3.76175 12.2727 3.83198 12.3078L5.08379 12.9337V13.8879ZM5.81006 13.2907V12.7092C5.81006 12.5716 5.73241 12.4461 5.60934 12.3844L4.60733 11.8835L11.5859 4.90495L12.9226 6.2416L5.81006 13.2907ZM15.0395 4.14359L13.4383 5.73042L10.247 2.53903L11.8327 0.938996C12.1072 0.664511 12.5852 0.664511 12.8597 0.938996L15.0384 3.11772C15.1756 3.25494 15.2512 3.43721 15.2512 3.63118C15.2512 3.82516 15.1756 4.00742 15.0395 4.14359Z" fill="#333333"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_6501_108990">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>
                    </button>
              </h3>
              <div class="company_card_rp">
                  <div class="company_card_name">
                      <strong>Company Name:</strong> Delaware Office
                  </div>
                  <div class="company_card_address">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.9375 5.6875C10.9375 4.64321 10.5227 3.64169 9.78423 2.90327C9.04581 2.16484 8.04429 1.75 7 1.75C5.95571 1.75 4.95419 2.16484 4.21577 2.90327C3.47734 3.64169 3.0625 4.64321 3.0625 5.6875C3.0625 7.30275 4.35488 9.408 7 11.9297C9.64512 9.408 10.9375 7.30275 10.9375 5.6875ZM7 13.125C3.79137 10.2086 2.1875 7.72888 2.1875 5.6875C2.1875 4.41115 2.69453 3.18707 3.59705 2.28455C4.49957 1.38203 5.72365 0.875 7 0.875C8.27635 0.875 9.50043 1.38203 10.403 2.28455C11.3055 3.18707 11.8125 4.41115 11.8125 5.6875C11.8125 7.72888 10.2086 10.2086 7 13.125Z" fill="#414141" stroke="#414141" stroke-width="0.416667"/>
                      <path d="M7 7C7.3481 7 7.68194 6.86172 7.92808 6.61558C8.17422 6.36944 8.3125 6.0356 8.3125 5.6875C8.3125 5.3394 8.17422 5.00556 7.92808 4.75942C7.68194 4.51328 7.3481 4.375 7 4.375C6.6519 4.375 6.31806 4.51328 6.07192 4.75942C5.82578 5.00556 5.6875 5.3394 5.6875 5.6875C5.6875 6.0356 5.82578 6.36944 6.07192 6.61558C6.31806 6.86172 6.6519 7 7 7ZM7 7.875C6.41984 7.875 5.86344 7.64453 5.4532 7.2343C5.04297 6.82406 4.8125 6.26766 4.8125 5.6875C4.8125 5.10734 5.04297 4.55094 5.4532 4.1407C5.86344 3.73047 6.41984 3.5 7 3.5C7.58016 3.5 8.13656 3.73047 8.5468 4.1407C8.95703 4.55094 9.1875 5.10734 9.1875 5.6875C9.1875 6.26766 8.95703 6.82406 8.5468 7.2343C8.13656 7.64453 7.58016 7.875 7 7.875Z" fill="#414141" stroke="#414141" stroke-width="0.416667"/>
                      </svg>
                      <span>Albert Flores, 6391 Elgin St. Celina, Delaware 10299</span>
                  </div>
                  <div class="company_card_contact">
                      <div class="company_card_phone">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.821 10.6938C12.821 10.9038 12.7744 11.1196 12.6752 11.3296C12.576 11.5396 12.4477 11.738 12.2785 11.9246C11.9927 12.2396 11.6777 12.4671 11.3219 12.613C10.9719 12.7588 10.5927 12.8346 10.1844 12.8346C9.58938 12.8346 8.95354 12.6946 8.28271 12.4088C7.61187 12.123 6.94104 11.738 6.27604 11.2538C5.60521 10.7638 4.96937 10.2213 4.36271 9.62047C3.76187 9.0138 3.21937 8.37797 2.73521 7.71297C2.25687 7.04797 1.87187 6.38297 1.59188 5.7238C1.31188 5.0588 1.17188 4.42297 1.17188 3.8163C1.17188 3.41964 1.24187 3.04047 1.38187 2.69047C1.52187 2.33464 1.74354 2.00797 2.05271 1.7163C2.42604 1.3488 2.83438 1.16797 3.26604 1.16797C3.42938 1.16797 3.59271 1.20297 3.73854 1.27297C3.89021 1.34297 4.02437 1.44797 4.12937 1.59964L5.48271 3.50714C5.58771 3.65297 5.66354 3.78714 5.71604 3.91547C5.76854 4.03797 5.79771 4.16047 5.79771 4.2713C5.79771 4.4113 5.75687 4.5513 5.67521 4.68547C5.59938 4.81964 5.48854 4.95964 5.34854 5.09964L4.90521 5.56047C4.84104 5.62464 4.81187 5.70047 4.81187 5.7938C4.81187 5.84047 4.81771 5.8813 4.82938 5.92797C4.84688 5.97464 4.86438 6.00964 4.87604 6.04464C4.98104 6.23714 5.16187 6.48797 5.41854 6.7913C5.68104 7.09464 5.96104 7.4038 6.26437 7.71297C6.57937 8.02214 6.88271 8.30797 7.19187 8.57047C7.49521 8.82714 7.74604 9.00214 7.94437 9.10714C7.97354 9.1188 8.00854 9.1363 8.04937 9.1538C8.09604 9.1713 8.14271 9.17714 8.19521 9.17714C8.29437 9.17714 8.37021 9.14214 8.43437 9.07797L8.87771 8.64047C9.02354 8.49464 9.16354 8.3838 9.29771 8.3138C9.43187 8.23214 9.56604 8.1913 9.71187 8.1913C9.82271 8.1913 9.93937 8.21464 10.0677 8.26714C10.196 8.31964 10.3302 8.39547 10.476 8.49464L12.4069 9.86547C12.5585 9.97047 12.6635 10.093 12.7277 10.2388C12.786 10.3846 12.821 10.5305 12.821 10.6938Z" stroke="#414141" stroke-width="1.2" stroke-miterlimit="10"/>
                        </svg>
                          <span>(123) 456-7890</span>
                      </div>
                      <div class="company_card_email">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.8385 4.07812L7.59379 7.41888C7.41581 7.52225 7.21366 7.5767 7.00783 7.5767C6.80201 7.5767 6.59985 7.52225 6.42188 7.41888L1.17188 4.07812" stroke="#414141" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M11.6719 2.32812H2.33854C1.69421 2.32812 1.17188 2.85046 1.17188 3.49479V10.4948C1.17188 11.1391 1.69421 11.6615 2.33854 11.6615H11.6719C12.3162 11.6615 12.8385 11.1391 12.8385 10.4948V3.49479C12.8385 2.85046 12.3162 2.32812 11.6719 2.32812Z" stroke="#414141" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span>Albertflores@gmail.com</span>
                      </div>
                  </div>
              </div>
          </div>

          <div class="mt_32">
              <h3 class="r_and_p_heading mb_16">Payment Method 
                  <button type="button" class="rp_edit_btn">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_6501_108990)">
                      <path d="M15.5519 2.59289L13.3732 0.412323C12.8242 -0.137089 11.8693 -0.138145 11.3182 0.413379L1.5579 10.27C1.51464 10.3136 1.48342 10.3672 1.4664 10.4261L0.0139372 15.5141C-0.02225 15.6409 0.0132223 15.7775 0.106499 15.8708C0.175639 15.9401 0.268201 15.9773 0.363248 15.9773C0.396576 15.9773 0.430278 15.9727 0.46289 15.9635L5.54657 14.5098C5.60543 14.4927 5.65898 14.4615 5.70258 14.4182L15.5519 4.64854C15.8264 4.37386 15.9774 4.00899 15.9774 3.62073C15.9774 3.23248 15.8264 2.86757 15.5519 2.59289ZM9.73581 3.05481L11.0725 4.39146L4.09387 11.3701L3.59304 10.3681C3.53132 10.245 3.4058 10.1674 3.2682 10.1674H2.68669L9.73581 3.05481ZM0.891963 15.0854L1.36495 13.4297L2.54766 14.6124L0.891963 15.0854ZM5.08379 13.8879L3.34643 14.3842L1.59314 12.6309L2.08944 10.8936H3.04369L3.66956 12.1454C3.70466 12.2156 3.76175 12.2727 3.83198 12.3078L5.08379 12.9337V13.8879ZM5.81006 13.2907V12.7092C5.81006 12.5716 5.73241 12.4461 5.60934 12.3844L4.60733 11.8835L11.5859 4.90495L12.9226 6.2416L5.81006 13.2907ZM15.0395 4.14359L13.4383 5.73042L10.247 2.53903L11.8327 0.938996C12.1072 0.664511 12.5852 0.664511 12.8597 0.938996L15.0384 3.11772C15.1756 3.25494 15.2512 3.43721 15.2512 3.63118C15.2512 3.82516 15.1756 4.00742 15.0395 4.14359Z" fill="#333333"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_6501_108990">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>
                    </button>
                </h3>
                <p class="rp_prefield_state">Pay via terms</p>
            </div>
            <div class="mt_32">
              <h3 class="r_and_p_heading mb_16">Shipping carrier
                  <button type="button" class="rp_edit_btn">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_6501_108990)">
                      <path d="M15.5519 2.59289L13.3732 0.412323C12.8242 -0.137089 11.8693 -0.138145 11.3182 0.413379L1.5579 10.27C1.51464 10.3136 1.48342 10.3672 1.4664 10.4261L0.0139372 15.5141C-0.02225 15.6409 0.0132223 15.7775 0.106499 15.8708C0.175639 15.9401 0.268201 15.9773 0.363248 15.9773C0.396576 15.9773 0.430278 15.9727 0.46289 15.9635L5.54657 14.5098C5.60543 14.4927 5.65898 14.4615 5.70258 14.4182L15.5519 4.64854C15.8264 4.37386 15.9774 4.00899 15.9774 3.62073C15.9774 3.23248 15.8264 2.86757 15.5519 2.59289ZM9.73581 3.05481L11.0725 4.39146L4.09387 11.3701L3.59304 10.3681C3.53132 10.245 3.4058 10.1674 3.2682 10.1674H2.68669L9.73581 3.05481ZM0.891963 15.0854L1.36495 13.4297L2.54766 14.6124L0.891963 15.0854ZM5.08379 13.8879L3.34643 14.3842L1.59314 12.6309L2.08944 10.8936H3.04369L3.66956 12.1454C3.70466 12.2156 3.76175 12.2727 3.83198 12.3078L5.08379 12.9337V13.8879ZM5.81006 13.2907V12.7092C5.81006 12.5716 5.73241 12.4461 5.60934 12.3844L4.60733 11.8835L11.5859 4.90495L12.9226 6.2416L5.81006 13.2907ZM15.0395 4.14359L13.4383 5.73042L10.247 2.53903L11.8327 0.938996C12.1072 0.664511 12.5852 0.664511 12.8597 0.938996L15.0384 3.11772C15.1756 3.25494 15.2512 3.43721 15.2512 3.63118C15.2512 3.82516 15.1756 4.00742 15.0395 4.14359Z" fill="#333333"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_6501_108990">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>
                    </button>
                </h3>
                <p class="rp_prefield_state">
                  <img src="/maincss/images/fedex.png" alt="carrier" class="carrier_img">
                </p>
            </div>
            <div class="mt_32">
              <h3 class="r_and_p_heading mb_16">Shipping Methods
                  <button type="button" class="rp_edit_btn">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_6501_108990)">
                      <path d="M15.5519 2.59289L13.3732 0.412323C12.8242 -0.137089 11.8693 -0.138145 11.3182 0.413379L1.5579 10.27C1.51464 10.3136 1.48342 10.3672 1.4664 10.4261L0.0139372 15.5141C-0.02225 15.6409 0.0132223 15.7775 0.106499 15.8708C0.175639 15.9401 0.268201 15.9773 0.363248 15.9773C0.396576 15.9773 0.430278 15.9727 0.46289 15.9635L5.54657 14.5098C5.60543 14.4927 5.65898 14.4615 5.70258 14.4182L15.5519 4.64854C15.8264 4.37386 15.9774 4.00899 15.9774 3.62073C15.9774 3.23248 15.8264 2.86757 15.5519 2.59289ZM9.73581 3.05481L11.0725 4.39146L4.09387 11.3701L3.59304 10.3681C3.53132 10.245 3.4058 10.1674 3.2682 10.1674H2.68669L9.73581 3.05481ZM0.891963 15.0854L1.36495 13.4297L2.54766 14.6124L0.891963 15.0854ZM5.08379 13.8879L3.34643 14.3842L1.59314 12.6309L2.08944 10.8936H3.04369L3.66956 12.1454C3.70466 12.2156 3.76175 12.2727 3.83198 12.3078L5.08379 12.9337V13.8879ZM5.81006 13.2907V12.7092C5.81006 12.5716 5.73241 12.4461 5.60934 12.3844L4.60733 11.8835L11.5859 4.90495L12.9226 6.2416L5.81006 13.2907ZM15.0395 4.14359L13.4383 5.73042L10.247 2.53903L11.8327 0.938996C12.1072 0.664511 12.5852 0.664511 12.8597 0.938996L15.0384 3.11772C15.1756 3.25494 15.2512 3.43721 15.2512 3.63118C15.2512 3.82516 15.1756 4.00742 15.0395 4.14359Z" fill="#333333"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_6501_108990">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>
                    </button>
                </h3>
                <p class="rp_prefield_state">FedEx Ground®</p>
            </div>
          </div> -->

        <!-- <div class="cart_sum_overflow-y overflow_pop_y">
        <div
          class="cart_summary_custome_div"
          v-show="cartNotEmpty"
          v-for="(item, key) in cart_items"
          :key="item.id + key"
        >
          <div class="cart_items media cart_image">
            <DisplayProductImage
              :whateverActivatesThisLink="false"
              :product="item.main_new_product"
              :designImage="item.design_image"
              :colorProductImage="item.product_image"
              :color="item.color_id"
              :classValue="'mr-auto'"

            />

            <div class="media-body">
              <div v-if="item.OrderBuild && item.front_art_url">
                Build: {{ item.OrderBuild.name }}
              </div>
              <h4 class="font_size_20 d-md-flex mb-0 h4_dropdown_box_custom">
               <div>
                    {{ item.main_new_product.name }}
              
               </div>


              


                <div class="d-flex justify-content-end align-items-flex-start new_span_price">
                <span class="font_size_22 ml-auto pr-2">
                  {{ icPriceFormat(getItemTotal(item)) }}
                </span>

                <div v-if="item.design_fee>0 || item.discount>0" class="dropdown">
                  <a href="#" class="dropdown-toggle m-0 d-block" :id="'dropdownMenuButtonLocations' + item.item_id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                    <img src="/maincss/images/information.svg" />
                  </a>
                  <div class="dropdown-menu drop-show drop-ex-menu" aria-labelledby="dropdownMenuButtonLocations">
                    <h4 class="font_size_16 text_primary_blue py_2 px_20 d-flex justify-content-between">
                      Cost
                      <span class="cross_ic"> <img src="/maincss/images/cross.svg" /></span>
                    </h4>
                    <div class="scroll">
                      <div class="dropdown-item d-flex align-items-center justify-content-between">
                        <p class="font-weight-bold">Base:</p>
                        <p class="ml-auto custom_margin_p"> {{ icPriceFormat(parseFloat(item.subtotal_price) + totalDiscount(item.CartChildItems)) }} </p>
                      </div>
                      <div v-if="item.discount>0" class="dropdown-item d-flex align-items-center justify-content-between">
                        <p class="font-weight-bold">Discount:</p>
                        <p class="ml-auto custom_margin_p"> - {{ icPriceFormat(item.discount) }} </p>
                      </div>
                      <div v-if="item.design_fee>0" class="dropdown-item d-flex align-items-center justify-content-between">
                        <p class="font-weight-bold">Design Fee:</p>
                        <p class="ml-auto custom_margin_p"> {{ icPriceFormat(item.design_fee) }} </p>
                      </div>
                      <div class="dropdown-item d-flex align-items-center justify-content-between" v-for="(child_item, child_item_index) in item.CartChildItems.filter(item => (item.discount>0) && (item.quantity > 0) && item.main_new_sub_product && item.main_new_sub_product.Size && item.main_new_sub_product.Size.size)" :key="child_item_index">
                        <p class="font-weight-bold">{{ child_item.main_new_sub_product.Size.size }} (Discount):</p>
                        <p class="ml-auto custom_margin_p">- {{ icPriceFormat(child_item.discount) }} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              </h4>
             
              <p class="font_size_16 mt_8 mb-0 text_light_grey">
                {{ item.main_new_product.Category ? item.main_new_product.Category.title : "" }}
              </p>
              <p class="font_size_16 mb-0 text_light_grey">
                {{ showSizes(item.CartChildItems) }}
              </p>

              <p v-if="item.design_fee > 0" class="font_size_16 mb-0 text_light_grey">
                Design Fee: <b> {{ icPriceFormat(item.design_fee) }}</b>
              </p>
              <ul v-if="item.decoration_colors.length > 0" class="standard_colors">
                    <li 
                        v-for="( color, index ) in item.decoration_colors"
                        :style="'background-color:' + color.hex + ';'" 
                        :key="index" 
                        v-tooltip = "{
                            'content': color.name ? `${color.name}<br/>${color.hex}` : color.hex,
                            'html': true
                        }"
                    >
                    </li>
                </ul>

                <small v-if="item.t_shirt_24_hour">24 Hours T-Shirt</small>
            </div>
          </div>
        </div>
      </div> -->

        <!-- <div class="">

      </div> -->

        <!-- <div v-show="!cartNotEmpty" class="d-none">
        <p class="font_size_16 mt_8 mb-0">No item added yet.</p>
      </div>

      <div class="total_coast text-right d-none">
        <h5>Total:</h5>
        <h3 v-show="cartNotEmpty">{{ icPriceFormat(grand_total) || 0.0 }}</h3>
        <h3 v-show="!cartNotEmpty">0.00</h3>
      </div>
      <div class="total_coast d-flex text-right"  v-if="total_imprint_locations_price > 0">
        <h5>Colors Fee:</h5>
        <h3 v-show="cartNotEmpty">{{ icPriceFormat(total_imprint_locations_price) || 0.0 }}</h3>
        <h3 v-show="!cartNotEmpty">0.00</h3>
      </div>
      <div class="total_coast d-flex text-right" v-if="total_setup_fee > 0">
        <h5>Setup Fee:</h5>
        <h3 v-show="cartNotEmpty">{{ icPriceFormat(total_setup_fee) || 0.0 }}</h3>
        <h3 v-show="!cartNotEmpty">0.00</h3>
      </div> -->
        <!-- <div class="total_coast d-flex text-right" v-if="order_data.total_non_standard_fees">
        <h5 class="d-flex align-items-center">Custom Ink Mix Fee <ul v-if="total_non_standard_colors.length > 0" class="standard_colors">
            <div class="more_color_link dropdown">
                <a 
                    href="#" id="dropdownMenuButton551"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
                    class="dropdown-toggle checkout_toggle d-flex align-items-center"
                >
                    <img src="/maincss/images/information.svg" class="ml_6">
                </a>
                <div aria-labelledby="dropdownMenuButton" class="dropdown-menu drop-cart-menu">
                    <h4 class="font_size_16 text_primary_blue py_2 px_20">
                        Custom Ink Mix Colors
                        <span class="cross_ic"><img src="/maincss/images/cross.svg"></span>
                    </h4>
                    <div class="dropdown-item d-flex align-items-center">
                    
                        <p class="mb-0">
                            <ul>
                                <li class="w-15" v-for="(color, index) in total_non_standard_colors"
                                    :style="'background-color:' + color + ';'"
                                    :key="index" v-tooltip="color">
                                </li>
                            </ul>
                        </p>
                      
                    </div>
                </div>
            </div>
        </ul>:</h5>
        <h3 v-show="cartNotEmpty">{{ icPriceFormat(order_data.total_non_standard_fees) }}</h3>
        <h3 v-show="!cartNotEmpty">0.00</h3>
        
      </div> -->
        <!-- <div class="total_coast d-flex text-right" v-if="order_data.sales_tax">
        <h5>Sales Tax:</h5>
        <h3 v-show="cartNotEmpty">{{ icPriceFormat(order_data.sales_tax) || 0.0 }}</h3>
        <h3 v-show="!cartNotEmpty">0.00</h3>
      </div>
    <div class="total_coast d-flex text-right shipping" v-if="shippment_charge()">
        <h5>Shipping Charges :</h5>
        <h3 v-show="cartNotEmpty">{{ icPriceFormat(shippment_charge()) }}</h3>
      </div>
      <div class="total_coast grand-total text-right d-none">
        <h5 class="mb_0">Grand Total:</h5>
        <h3 v-show="cartNotEmpty" class="mb_0">
          {{
            grand_total ? icPriceFormat( 
                parseFloat(grand_total) + 
                shippment_charge() + 
                parseFloat(order_data.sales_tax) + 
                parseFloat(order_data.total_non_standard_fees) +
                parseFloat(total_imprint_locations_price) +
                parseFloat(total_setup_fee)
            ) : 0.0
          }}
        </h3>
        <h3 v-show="!cartNotEmpty">0.00</h3>
      </div> -->

        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
        <div class="drawer_option">
            <div class="fixed_b_order_total_block">
                <div class="order-total-container">
                    <div class="left-section">
                        <button
                            type="button"
                            class="btn btn-back"
                            @click="handleBackClick"
                        >
                            BACK
                        </button>
                    </div>

                    <div class="right-section">
                        <div
                            class="order-total-info"
                            @click="showOrdersDrawer = !showOrdersDrawer"
                        >
                            <span class="chevron-icon">
                                <svg
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 1L6 6L11 1"
                                        stroke="#808080"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                            <span class="order-total-label" style="width: 78px"
                                >Order Total</span
                            >
                            <span class="order-total-amount">
                                {{
                                    cartNotEmpty && calculatedGrandTotal
                                        ? icPriceFormat(calculatedGrandTotal)
                                        : "$0.00"
                                }}
                            </span>
                        </div>

                        <button
                            v-if="!is_reviewpay && !(isSplitShipment && split_shipment_step === 'review')"
                            type="button"
                            class="btn btn-next"
                            @click="handleNextClick"
                            :disabled="isSplitShipment && split_shipment_step === 'split_items' && isSummaryScreen && !allItemsAssignedInSummary"
                        >
                            NEXT
                        </button>
                        <button
                            v-if="is_reviewpay || (isSplitShipment && split_shipment_step === 'review')"
                            type="button"
                            class="btn btn_orange bg_primary_orange text_white d-block"
                            style="width: 100%; margin: 0 auto"
                            @click="handlePlaceOrder"
                        >
                            {{
                                isAdminLoggedIn
                                    ? "Proceed To Checkout"
                                    : "Proceed To Pay"
                            }}
                        </button>
                    </div>
                </div>
            </div>
            <!-- Order Summary Drawer -->
            <transition name="drawer-overlay">
                <div
                    v-if="showOrdersDrawer"
                    class="order-drawer-overlay"
                    @click="showOrdersDrawer = false"
                ></div>
            </transition>
            <transition name="drawer-slide">
                <div v-if="showOrdersDrawer" class="order-summary-drawer">
                    <div class="drawer-header">
                        <h3 class="drawer-title">Cart Summary</h3>
                        <a href="/cart/v3" class="drawer-edit-btn">
                            <button type="button" class="drawer-edit-btn">
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clip-path="url(#clip0_6501_108001)">
                                        <g clip-path="url(#clip1_6501_108001)">
                                            <g
                                                clip-path="url(#clip2_6501_108001)"
                                            >
                                                <path
                                                    d="M17.7002 0.801351C17.1838 0.285714 16.4839 -0.00390625 15.7542 -0.00390625C15.0244 -0.00390625 14.3245 0.285714 13.8082 0.801351L12.8342 1.78135L2.46815 12.1464L2.44615 12.1684C2.44115 12.1734 2.44115 12.1794 2.43515 12.1794C2.42415 12.1964 2.40715 12.2124 2.39715 12.2284C2.38715 12.2444 2.39115 12.2344 2.39115 12.2394C2.39115 12.2444 2.37515 12.2674 2.36315 12.2834C2.35115 12.2994 2.35815 12.2944 2.35215 12.3004C2.34615 12.3063 2.34115 12.3284 2.33515 12.3444C2.32915 12.3604 2.33015 12.3494 2.33015 12.3554L0.029152 19.2754C-0.00383067 19.3718 -0.00894095 19.4756 0.014408 19.5749C0.0377569 19.6741 0.0886183 19.7647 0.161152 19.8364C0.265235 19.9392 0.405801 19.9968 0.552152 19.9964C0.611826 19.9951 0.671049 19.9857 0.728152 19.9684L7.64215 17.6614C7.64715 17.6614 7.64715 17.6614 7.65315 17.6564C7.6704 17.6513 7.68688 17.6439 7.70215 17.6343C7.70627 17.6339 7.71013 17.6322 7.71315 17.6294C7.72915 17.6184 7.75115 17.6073 7.76815 17.5963C7.78515 17.5854 7.80115 17.5694 7.81815 17.5584C7.83515 17.5474 7.82915 17.5523 7.82915 17.5473C7.82915 17.5424 7.84615 17.5364 7.85115 17.5254L19.2002 6.17935C19.7158 5.66299 20.0054 4.96308 20.0054 4.23335C20.0054 3.50362 19.7158 2.80371 19.2002 2.28735L17.7002 0.801351ZM7.46615 16.3684L3.63515 12.5374L13.2242 2.94835L17.0552 6.77935L7.46615 16.3684ZM3.10015 13.5554L6.44715 16.9024L1.41615 18.5753L3.10015 13.5554ZM18.4212 5.40835L17.8372 5.99735L14.0062 2.16635L14.5952 1.57735C14.9047 1.26799 15.3245 1.09422 15.7622 1.09422C16.1998 1.09422 16.6196 1.26799 16.9292 1.57735L18.4292 3.07735C18.7351 3.38863 18.9058 3.80805 18.9043 4.24449C18.9028 4.68094 18.7292 5.09917 18.4212 5.40835Z"
                                                    fill="black"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_6501_108001">
                                            <rect
                                                width="20"
                                                height="20"
                                                fill="white"
                                            />
                                        </clipPath>
                                        <clipPath id="clip1_6501_108001">
                                            <rect
                                                width="20"
                                                height="19.99"
                                                fill="white"
                                            />
                                        </clipPath>
                                        <clipPath id="clip2_6501_108001">
                                            <rect
                                                width="20.002"
                                                height="20"
                                                fill="white"
                                                transform="translate(0 -0.00390625)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg></button
                        ></a>
                        <button
                            type="button"
                            class="drawer-close-btn"
                            @click="showOrdersDrawer = false"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="24"
                                    height="24"
                                    rx="12"
                                    fill="white"
                                />
                                <path
                                    d="M7 7L17 17M7 17L17 7"
                                    stroke="#606060"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>
                    </div>

                    <div class="drawer-content">
                        <div
                            class="order_prod_list"
                            v-if="cartNotEmpty && cart_items.length > 0"
                        >
                            <div
                                class="order_prod_item"
                                v-for="(item, key) in cart_items"
                                :key="item.id + key"
                            >
                                <div class="order_prod_item_img_flex">
                                    <DisplayProductImage
                                        :whateverActivatesThisLink="false"
                                        :product="item.main_new_product"
                                        :designImage="item.design_image"
                                        :colorProductImage="item.product_image"
                                        :color="item.color_id"
                                        :classValue="'order_prod_item_img'"
                                    />
                                    <div class="order_prod_item_details">
                                        <div class="order_prod_name_content">
                                            <h3 class="order_prod_item_title">
                                                {{ item.main_new_product.name }}
                                            </h3>
                                            <p class="order_prod_item_category">
                                                {{
                                                    item.main_new_product
                                                        .Category
                                                        ? item.main_new_product
                                                              .Category.title
                                                        : ""
                                                }}
                                            </p>
                                            <p class="order_prod_item_OSFA">
                                                {{
                                                    showSizes(
                                                        item.CartChildItems
                                                    )
                                                }}
                                            </p>
                                            <p
                                                v-if="
                                                    item.displayData &&
                                                    item.displayData
                                                        .masterService &&
                                                    item.displayData
                                                        .masterService.name
                                                "
                                                class="order_prod_item_service d-none"
                                                style="
                                                    margin-top: 4px;
                                                    font-size: 14px;
                                                    color: #666;
                                                "
                                            >
                                                {{
                                                    item.displayData
                                                        .masterService.name
                                                }}
                                            </p>
                                            <p
                                                v-if="
                                                    getEstimatedShippingDate(
                                                        item
                                                    )
                                                "
                                                class="order_prod_item_service"
                                                style="
                                                    margin-top: 4px;
                                                    font-size: 14px;
                                                    color: #666;
                                                "
                                            >
                                                Est. Ship Date:
                                                {{
                                                    getEstimatedShippingDate(
                                                        item
                                                    )
                                                }}
                                            </p>
                                            <!-- color boxes -->
                                            <div
                                                class="color-boxes"
                                                v-if="
                                                    getAllArtworkColors(item)
                                                        .length > 0
                                                "
                                            >
                                                <div
                                                    class="color-box"
                                                    v-for="(
                                                        color, index
                                                    ) in getAllArtworkColors(
                                                        item
                                                    )"
                                                    :key="index"
                                                >
                                                    <div
                                                        class="color-box-inner"
                                                        :style="
                                                            'background-color:' +
                                                            (color.hex ||
                                                                color) +
                                                            ';'
                                                        "
                                                    >
                                                        <div
                                                            class="color-box-inner-inner"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Cost Breakdown Section -->
                                        <div
                                            class="order_prod_item_cost_breakdown"
                                        >
                                            <div class="cost-breakdown">
                                                <!-- Base Fee -->
                                                <div
                                                    class="cost-item d-none"
                                                    v-if="
                                                        item.displayData &&
                                                        item.displayData
                                                            .baseFeeTotal > 0
                                                    "
                                                >
                                                    <ToolTip
                                                        :label="'Base Fee'"
                                                        :title="'Base Fee Breakdown'"
                                                        :base-price="
                                                            Number(
                                                                item.subtotal_price ||
                                                                    0
                                                            )
                                                        "
                                                        :base-unit-price="
                                                            item.displayData
                                                                .baseUnitPrice
                                                        "
                                                        :quantity="
                                                            item.displayData
                                                                .quantity
                                                        "
                                                        :services="
                                                            item.displayData
                                                                .baseFeeServices
                                                        "
                                                        :color-size-combinations="
                                                            getColorSizeCombinationsForDisplay(
                                                                item
                                                            )
                                                        "
                                                        :discount-config="
                                                            getActiveProductDiscount(
                                                                item
                                                            )
                                                        "
                                                        :format-price="
                                                            icPriceFormat
                                                        "
                                                    />
                                                    <div class="cost-value">
                                                        {{
                                                            icPriceFormat(
                                                                item.displayData
                                                                    .baseFeeTotal
                                                            )
                                                        }}
                                                    </div>
                                                </div>

                                                <!-- Run Charge -->
                                                <div
                                                    class="cost-item d-none"
                                                    v-if="
                                                        item.displayData &&
                                                        item.decoration_type !==
                                                            undefined &&
                                                        (item.decoration_type ==
                                                            0 ||
                                                            item.decoration_type ==
                                                                1 ||
                                                            item.decoration_type ==
                                                                2) &&
                                                        item.displayData
                                                            .runChargeTotal > 0
                                                    "
                                                >
                                                    <ToolTip
                                                        :label="'Run Charge'"
                                                        :title="'Run Charge Breakdown'"
                                                        :base-price="0"
                                                        :quantity="
                                                            item.displayData
                                                                .quantity
                                                        "
                                                        :services="
                                                            item.displayData
                                                                .runChargeServices
                                                        "
                                                        :run-charge-breakdown="
                                                            item.displayData
                                                                .runChargeBreakdown
                                                        "
                                                        :format-price="
                                                            icPriceFormat
                                                        "
                                                    />
                                                    <div class="cost-value">
                                                        {{
                                                            icPriceFormat(
                                                                item.displayData
                                                                    .runChargeTotal
                                                            )
                                                        }}
                                                    </div>
                                                </div>

                                                <!-- Color Mix Fee for single items -->
                                                <div
                                                    class="cost-item d-none"
                                                    v-if="
                                                        item.displayData &&
                                                        (item.decoration_type ==
                                                            0 ||
                                                            item.decoration_type ==
                                                                1 ||
                                                            item.decoration_type ==
                                                                2) &&
                                                        (item.displayData
                                                            .colorMixFeeData ||
                                                            (item.displayData
                                                                .colorMixFeeServices &&
                                                                item.displayData
                                                                    .colorMixFeeServices
                                                                    .length >
                                                                    0)) &&
                                                        item.displayData
                                                            .colorMixFeeTotal >
                                                            0 &&
                                                        !isGroupedDecorationType0(
                                                            item
                                                        )
                                                    "
                                                >
                                                    <ToolTip
                                                        label="Custom Color Fee"
                                                        title="Custom Color Fee Breakdown"
                                                        :base-price="0"
                                                        :quantity="
                                                            item.displayData
                                                                .quantity
                                                        "
                                                        :services="
                                                            item.displayData
                                                                .colorMixFeeServices
                                                        "
                                                        :color-mix-fee-data="
                                                            item.displayData
                                                                .colorMixFeeData
                                                        "
                                                        :decoration-type="
                                                            item.decoration_type
                                                        "
                                                        :master-service="
                                                            item.displayData
                                                                .masterService
                                                        "
                                                        :format-price="
                                                            icPriceFormat
                                                        "
                                                    />
                                                    <div class="cost-value">
                                                        {{
                                                            icPriceFormat(
                                                                item.displayData
                                                                    .colorMixFeeTotal
                                                            )
                                                        }}
                                                    </div>
                                                </div>

                                                <!-- Combined Color Mix Fee for grouped items (show in parent item only) -->
                                                <div
                                                    class="cost-item d-none"
                                                    v-if="
                                                        isGroupedDecorationType0(
                                                            item
                                                        ) &&
                                                        item.subItems &&
                                                        item.subItems.length >
                                                            0 &&
                                                        (getCombinedColorMixFeeData(
                                                            item
                                                        ) ||
                                                            hasCombinedColorMixFeeServices(
                                                                item
                                                            )) &&
                                                        getCombinedColorMixFeeTotal(
                                                            item
                                                        ) > 0
                                                    "
                                                >
                                                    <ToolTip
                                                        label="Custom Color Fee"
                                                        title="Custom Color Fee Breakdown"
                                                        :base-price="0"
                                                        :quantity="0"
                                                        :services="
                                                            getCombinedColorMixFeeServices(
                                                                item
                                                            )
                                                        "
                                                        :color-mix-fee-data="
                                                            getCombinedColorMixFeeData(
                                                                item
                                                            )
                                                        "
                                                        :decoration-type="
                                                            item.decoration_type
                                                        "
                                                        :master-service="
                                                            item.decoration &&
                                                            item.decoration
                                                                .master_service
                                                                ? item
                                                                      .decoration
                                                                      .master_service
                                                                : null
                                                        "
                                                        :format-price="
                                                            icPriceFormat
                                                        "
                                                    />
                                                    <div class="cost-value">
                                                        {{
                                                            icPriceFormat(
                                                                getCombinedColorMixFeeTotal(
                                                                    item
                                                                )
                                                            )
                                                        }}
                                                    </div>
                                                </div>

                                                <!-- Setup Fee -->
                                                <div
                                                    class="cost-item d-none"
                                                    v-if="
                                                        item.displayData &&
                                                        item.setup_fees_details &&
                                                        item.displayData
                                                            .setupFeeTotal >
                                                            0 &&
                                                        (item.decoration_type ==
                                                            0 ||
                                                            item.decoration_type ==
                                                                1 ||
                                                            item.decoration_type ==
                                                                2)
                                                    "
                                                >
                                                    <ToolTip
                                                        :label="'Set Up Fees'"
                                                        :title="'Setup Fee Breakdown'"
                                                        :base-price="0"
                                                        :quantity="
                                                            item.displayData
                                                                .quantity
                                                        "
                                                        :services="
                                                            item.displayData
                                                                .setupFeeServices
                                                        "
                                                        :setup-fee-details="
                                                            item.setup_fees_details
                                                        "
                                                        :format-price="
                                                            icPriceFormat
                                                        "
                                                    />
                                                    <div class="cost-value">
                                                        {{
                                                            icPriceFormat(
                                                                item.displayData
                                                                    .setupFeeTotal
                                                            )
                                                        }}
                                                    </div>
                                                </div>

                                                <!-- Rush Fee -->
                                                <div
                                                    class="cost-item d-none"
                                                    v-if="
                                                        item.displayData &&
                                                        item.rush_fee_breakdown &&
                                                        item.displayData
                                                            .rushFeeTotal > 0
                                                    "
                                                >
                                                    <ToolTip
                                                        :label="'Rush Fee'"
                                                        :title="'Rush Fee Breakdown'"
                                                        :base-price="0"
                                                        :quantity="
                                                            item.displayData
                                                                .quantity
                                                        "
                                                        :services="
                                                            item.displayData
                                                                .rushFeeServices
                                                        "
                                                        :rush-fee-breakdown="
                                                            item.displayData
                                                                .rushFeeBreakdown
                                                        "
                                                        :format-price="
                                                            icPriceFormat
                                                        "
                                                    />
                                                    <div class="cost-value">
                                                        {{
                                                            icPriceFormat(
                                                                item.displayData
                                                                    .rushFeeTotal
                                                            )
                                                        }}
                                                    </div>
                                                </div>

                                                <div
                                                    class="cost-separator d-none"
                                                ></div>

                                                <!-- Item Sub Total - show for all items (for grouped items, include combined color mix fee) -->
                                                <div
                                                    class="cost-item cost-total"
                                                >
                                                    <div
                                                        class="cost-label d-none"
                                                    >
                                                        <span
                                                            >Item Sub
                                                            Total</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="cost-value"
                                                        style="
                                                            font-weight: bold;
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                getItemTotal(
                                                                    item
                                                                )
                                                            )
                                                        }}
                                                    </div>
                                                </div>

                                                <!-- Discount and Total rows removed - no longer applying overall discount -->
                                            </div>
                                            <!-- Sub Items (nested under main item) - Inside cost breakdown but with full width -->
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        item.subItems &&
                                        item.subItems.length > 0
                                    "
                                    class="sub-items-wrapper"
                                >
                                    <!-- k_k -->
                                    <div
                                        class="sub-items-container"
                                        style="
                                            border-top: 1px solid #e0e0e0;
                                            padding-top: 20px;
                                        "
                                    >
                                        <div
                                            class="order_prod_item inner_order_prod_item_imp"
                                            v-for="(
                                                subItem, subItemKey
                                            ) in item.subItems"
                                            :key="subItem.id + subItemKey"
                                            :style="
                                                subItemKey > 0
                                                    ? 'border-top: 1px solid #e0e0e0; padding-top: 20px; margin-top: 20px;'
                                                    : ''
                                            "
                                        >
                                            <div
                                                class="order_prod_item_img_flex"
                                            >
                                                <DisplayProductImage
                                                    :whateverActivatesThisLink="
                                                        false
                                                    "
                                                    :product="
                                                        subItem.main_new_product
                                                    "
                                                    :designImage="
                                                        subItem.design_image
                                                    "
                                                    :colorProductImage="
                                                        subItem.product_image
                                                    "
                                                    :color="subItem.color_id"
                                                    :classValue="'order_prod_item_img'"
                                                />
                                                <div
                                                    class="order_prod_item_details"
                                                >
                                                    <div
                                                        class="order_prod_name_content"
                                                    >
                                                        <h3
                                                            class="order_prod_item_title"
                                                        >
                                                            {{
                                                                subItem
                                                                    .main_new_product
                                                                    .name
                                                            }}
                                                        </h3>
                                                        <p
                                                            class="order_prod_item_category"
                                                        >
                                                            {{
                                                                subItem
                                                                    .main_new_product
                                                                    .Category
                                                                    ? subItem
                                                                          .main_new_product
                                                                          .Category
                                                                          .title
                                                                    : ""
                                                            }}
                                                        </p>
                                                        <p
                                                            class="order_prod_item_OSFA"
                                                        >
                                                            {{
                                                                showSizes(
                                                                    subItem.CartChildItems
                                                                )
                                                            }}
                                                        </p>
                                                        <p
                                                            v-if="
                                                                subItem.displayData &&
                                                                subItem
                                                                    .displayData
                                                                    .masterService &&
                                                                subItem
                                                                    .displayData
                                                                    .masterService
                                                                    .name
                                                            "
                                                            class="order_prod_item_service d-none"
                                                            style="
                                                                margin-top: 4px;
                                                                font-size: 14px;
                                                                color: #666;
                                                            "
                                                        >
                                                            {{
                                                                subItem
                                                                    .displayData
                                                                    .masterService
                                                                    .name
                                                            }}
                                                        </p>
                                                        <!-- color boxes -->
                                                        <div
                                                            class="color-boxes"
                                                            v-if="
                                                                getAllArtworkColors(
                                                                    subItem
                                                                ).length > 0
                                                            "
                                                        >
                                                            <div
                                                                class="color-box"
                                                                v-for="(
                                                                    color, index
                                                                ) in getAllArtworkColors(
                                                                    subItem
                                                                )"
                                                                :key="index"
                                                            >
                                                                <div
                                                                    class="color-box-inner"
                                                                    :style="
                                                                        'background-color:' +
                                                                        (color.hex ||
                                                                            color) +
                                                                        ';'
                                                                    "
                                                                >
                                                                    <div
                                                                        class="color-box-inner-inner"
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Cost Breakdown Section for Sub Item -->
                                                    <div
                                                        class="order_prod_item_cost_breakdown"
                                                    >
                                                        <div
                                                            class="cost-breakdown"
                                                        >
                                                            <!-- Base Fee -->
                                                            <div
                                                                class="cost-item d-none"
                                                                v-if="
                                                                    subItem.displayData &&
                                                                    subItem
                                                                        .displayData
                                                                        .baseFeeTotal >
                                                                        0
                                                                "
                                                            >
                                                                <ToolTip
                                                                    :label="'Base Fee'"
                                                                    :title="'Base Fee Breakdown'"
                                                                    :base-price="
                                                                        Number(
                                                                            subItem.subtotal_price ||
                                                                                0
                                                                        )
                                                                    "
                                                                    :base-unit-price="
                                                                        subItem
                                                                            .displayData
                                                                            .baseUnitPrice
                                                                    "
                                                                    :quantity="
                                                                        subItem
                                                                            .displayData
                                                                            .quantity
                                                                    "
                                                                    :services="
                                                                        subItem
                                                                            .displayData
                                                                            .baseFeeServices
                                                                    "
                                                                    :color-size-combinations="
                                                                        subItem
                                                                            .displayData
                                                                            .colorSizeCombinations
                                                                    "
                                                                    :discount-config="
                                                                        getActiveProductDiscount(
                                                                            subItem
                                                                        )
                                                                    "
                                                                    :format-price="
                                                                        icPriceFormat
                                                                    "
                                                                />
                                                                <div
                                                                    class="cost-value"
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            subItem
                                                                                .displayData
                                                                                .baseFeeTotal
                                                                        )
                                                                    }}
                                                                </div>
                                                            </div>

                                                            <!-- Run Charge -->
                                                            <div
                                                                class="cost-item d-none"
                                                                v-if="
                                                                    subItem.displayData &&
                                                                    subItem.decoration_type !==
                                                                        undefined &&
                                                                    (subItem.decoration_type ==
                                                                        0 ||
                                                                        subItem.decoration_type ==
                                                                            1 ||
                                                                        subItem.decoration_type ==
                                                                            2) &&
                                                                    subItem
                                                                        .displayData
                                                                        .runChargeTotal >
                                                                        0
                                                                "
                                                            >
                                                                <ToolTip
                                                                    :label="'Run Charge'"
                                                                    :title="'Run Charge Breakdown'"
                                                                    :base-price="
                                                                        0
                                                                    "
                                                                    :quantity="
                                                                        subItem
                                                                            .displayData
                                                                            .quantity
                                                                    "
                                                                    :services="
                                                                        subItem
                                                                            .displayData
                                                                            .runChargeServices
                                                                    "
                                                                    :run-charge-breakdown="
                                                                        subItem
                                                                            .displayData
                                                                            .runChargeBreakdown
                                                                    "
                                                                    :format-price="
                                                                        icPriceFormat
                                                                    "
                                                                />
                                                                <div
                                                                    class="cost-value"
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            subItem
                                                                                .displayData
                                                                                .runChargeTotal
                                                                        )
                                                                    }}
                                                                </div>
                                                            </div>

                                                            <!-- Color Mix Fee (hide for grouped items - shown in parent) -->
                                                            <div
                                                                class="cost-item d-none"
                                                                v-if="
                                                                    subItem.displayData &&
                                                                    (subItem.decoration_type ==
                                                                        0 ||
                                                                        subItem.decoration_type ==
                                                                            1 ||
                                                                        subItem.decoration_type ==
                                                                            2) &&
                                                                    (subItem
                                                                        .displayData
                                                                        .colorMixFeeData ||
                                                                        (subItem
                                                                            .displayData
                                                                            .colorMixFeeServices &&
                                                                            subItem
                                                                                .displayData
                                                                                .colorMixFeeServices
                                                                                .length >
                                                                                0)) &&
                                                                    subItem
                                                                        .displayData
                                                                        .colorMixFeeTotal >
                                                                        0 &&
                                                                    !isGroupedDecorationType0(
                                                                        item
                                                                    )
                                                                "
                                                            >
                                                                <ToolTip
                                                                    label="Custom Color Fee"
                                                                    title="Custom Color Fee Breakdown"
                                                                    :base-price="
                                                                        0
                                                                    "
                                                                    :quantity="
                                                                        subItem
                                                                            .displayData
                                                                            .quantity
                                                                    "
                                                                    :services="
                                                                        subItem
                                                                            .displayData
                                                                            .colorMixFeeServices
                                                                    "
                                                                    :color-mix-fee-data="
                                                                        subItem
                                                                            .displayData
                                                                            .colorMixFeeData
                                                                    "
                                                                    :decoration-type="
                                                                        subItem.decoration_type
                                                                    "
                                                                    :master-service="
                                                                        subItem
                                                                            .displayData
                                                                            .masterService
                                                                    "
                                                                    :format-price="
                                                                        icPriceFormat
                                                                    "
                                                                />
                                                                <div
                                                                    class="cost-value"
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            subItem
                                                                                .displayData
                                                                                .colorMixFeeTotal
                                                                        )
                                                                    }}
                                                                </div>
                                                            </div>

                                                            <!-- Setup Fee -->
                                                            <div
                                                                class="cost-item d-none"
                                                                v-if="
                                                                    subItem.displayData &&
                                                                    subItem.setup_fees_details &&
                                                                    subItem
                                                                        .displayData
                                                                        .setupFeeTotal >
                                                                        0 &&
                                                                    (subItem.decoration_type ==
                                                                        0 ||
                                                                        subItem.decoration_type ==
                                                                            1 ||
                                                                        subItem.decoration_type ==
                                                                            2)
                                                                "
                                                            >
                                                                <ToolTip
                                                                    :label="'Set Up Fees'"
                                                                    :title="'Setup Fee Breakdown'"
                                                                    :base-price="
                                                                        0
                                                                    "
                                                                    :quantity="
                                                                        subItem
                                                                            .displayData
                                                                            .quantity
                                                                    "
                                                                    :services="
                                                                        subItem
                                                                            .displayData
                                                                            .setupFeeServices
                                                                    "
                                                                    :setup-fee-details="
                                                                        subItem.setup_fees_details
                                                                    "
                                                                    :format-price="
                                                                        icPriceFormat
                                                                    "
                                                                />
                                                                <div
                                                                    class="cost-value"
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            subItem
                                                                                .displayData
                                                                                .setupFeeTotal
                                                                        )
                                                                    }}
                                                                </div>
                                                            </div>

                                                            <!-- Rush Fee for Sub Item -->
                                                            <div
                                                                class="cost-item d-none"
                                                                v-if="
                                                                    subItem.displayData &&
                                                                    subItem.rush_fee_breakdown &&
                                                                    subItem
                                                                        .displayData
                                                                        .rushFeeTotal >
                                                                        0
                                                                "
                                                            >
                                                                <ToolTip
                                                                    :label="'Rush Fee'"
                                                                    :title="'Rush Fee Breakdown'"
                                                                    :base-price="
                                                                        0
                                                                    "
                                                                    :quantity="
                                                                        subItem
                                                                            .displayData
                                                                            .quantity
                                                                    "
                                                                    :services="
                                                                        subItem
                                                                            .displayData
                                                                            .rushFeeServices
                                                                    "
                                                                    :rush-fee-breakdown="
                                                                        subItem
                                                                            .displayData
                                                                            .rushFeeBreakdown
                                                                    "
                                                                    :format-price="
                                                                        icPriceFormat
                                                                    "
                                                                />
                                                                <div
                                                                    class="cost-value"
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            subItem
                                                                                .displayData
                                                                                .rushFeeTotal
                                                                        )
                                                                    }}
                                                                </div>
                                                            </div>

                                                            <div
                                                                class="cost-separator d-none"
                                                            ></div>

                                                            <!-- Item Sub Total (for grouped items, exclude color mix fee) -->
                                                            <!-- If discount exists, show Item Sub Total - Discount, otherwise show Item Sub Total -->
                                                            <div
                                                                class="cost-item cost-total"
                                                            >
                                                                <div
                                                                    class="cost-label d-none"
                                                                >
                                                                    <span
                                                                        >Item
                                                                        Sub
                                                                        Total</span
                                                                    >
                                                                </div>
                                                                <div
                                                                    class="cost-value"
                                                                    style="
                                                                        font-weight: bold;
                                                                    "
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            getSubItemTotal(
                                                                                subItem,
                                                                                item
                                                                            )
                                                                        )
                                                                    }}
                                                                </div>
                                                            </div>

                                                            <!-- Discount and Total rows removed - no longer applying overall discount -->

                                                            <!-- Group Sub Total for grouped items (show only on last subItem) -->
                                                            <template
                                                                v-if="
                                                                    isGroupedDecorationType0(
                                                                        item
                                                                    ) &&
                                                                    subItemKey ===
                                                                        item
                                                                            .subItems
                                                                            .length -
                                                                            1
                                                                "
                                                            >
                                                                <div
                                                                    class="cost-separator d-none"
                                                                ></div>
                                                                <div
                                                                    class="cost-item cost-total d-none"
                                                                    style="
                                                                        text-align: right;
                                                                    "
                                                                >
                                                                    <div
                                                                        class="cost-label"
                                                                        style="
                                                                            text-align: right;
                                                                        "
                                                                    >
                                                                        <span
                                                                            >Group
                                                                            Sub
                                                                            Total</span
                                                                        >
                                                                    </div>
                                                                    <div
                                                                        class="cost-value"
                                                                        style="
                                                                            text-align: right;
                                                                        "
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                getGroupSubTotal(
                                                                                    item
                                                                                )
                                                                            )
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </template>

                                                            <!-- For non-grouped items, show individual discount and total only if discount exists -->
                                                            <template v-else>
                                                                <!-- Discount -->
                                                                <div
                                                                    class="cost-item cost-total cost-disocunt-row d-none"
                                                                    v-if="
                                                                        getItemDiscount(
                                                                            subItem,
                                                                            item
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <div
                                                                        class="cost-label"
                                                                    >
                                                                        <span
                                                                            >Discount</span
                                                                        >
                                                                    </div>
                                                                    <div
                                                                        class="cost-value discount-value"
                                                                    >
                                                                        -{{
                                                                            icPriceFormat(
                                                                                getItemDiscount(
                                                                                    subItem,
                                                                                    item
                                                                                )
                                                                            )
                                                                        }}
                                                                    </div>
                                                                </div>

                                                                <!-- Total - only show if discount exists -->
                                                                <div
                                                                    class="cost-item cost-total d-none"
                                                                    v-if="
                                                                        getItemDiscount(
                                                                            subItem,
                                                                            item
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <div
                                                                        class="cost-label"
                                                                    >
                                                                        <span
                                                                            >Total</span
                                                                        >
                                                                    </div>
                                                                    <div
                                                                        class="cost-value"
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                (getItemDisplayData(
                                                                                    subItem,
                                                                                    item
                                                                                )
                                                                                    ? getItemDisplayData(
                                                                                          subItem,
                                                                                          item
                                                                                      )
                                                                                          .itemSubTotal
                                                                                    : 0) -
                                                                                    getItemDiscount(
                                                                                        subItem,
                                                                                        item
                                                                                    )
                                                                            )
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="order_prod_list">
                            <p class="text-center">No items in cart</p>
                        </div>
                        <div class="order-breakdown-section">
                            <div class="breakdown-item">
                                <span class="breakdown-label">Sub Total</span>
                                <span class="breakdown-value">
                                    {{
                                        cartNotEmpty && cartSubTotal
                                            ? icPriceFormat(cartSubTotal)
                                            : "$0.00"
                                    }}
                                </span>
                            </div>

                            <!-- <div
                                class="breakdown-item"
                                v-if="total_imprint_locations_price > 0"
                            >
                                <span class="breakdown-label">Colors Fee</span>
                                <span class="breakdown-value">
                                    {{
                                        icPriceFormat(
                                            total_imprint_locations_price
                                        )
                                    }}
                                </span>
                            </div> -->

                            <!-- <div
                                class="breakdown-item"
                                v-if="total_setup_fee > 0"
                            >
                                <span class="breakdown-label">Setup Fee</span>
                                <span class="breakdown-value">
                                    {{ icPriceFormat(total_setup_fee) }}
                                </span>
                            </div> -->

                            <!-- <div
                                class="breakdown-item"
                                v-if="
                                    order_data &&
                                    order_data.total_non_standard_fees > 0
                                "
                            >
                                <span class="breakdown-label"
                                    >Custom Ink Mix Fee</span
                                >
                                <span class="breakdown-value">
                                    {{
                                        icPriceFormat(
                                            order_data.total_non_standard_fees
                                        )
                                    }}
                                </span>
                            </div> -->

                            <div
                                class="breakdown-item"
                                v-if="getPackagingTotal() > 0"
                            >
                                <ToolTip
                                    :label="'Packaging, Kitting and Handling'"
                                    :title="'Packaging, Kitting and Handling Breakdown'"
                                    :base-price="0"
                                    :quantity="0"
                                    :services="getPackagingServicesForTooltip()"
                                    :shipping-method-charge="0"
                                    :format-price="icPriceFormat"
                                />
                                <span class="breakdown-value">
                                    {{ icPriceFormat(getPackagingTotal()) }}
                                </span>
                            </div>

                            <div
                                class="breakdown-item"
                                v-if="getShippingTotal() > 0"
                            >
                                <ToolTip
                                    :label="'Shipping and Freight'"
                                    :title="'Shipping and Freight Breakdown'"
                                    :base-price="0"
                                    :quantity="0"
                                    :services="getShippingServicesForTooltip()"
                                    :shipping-method-charge="isSplitShipment ? 0 : shippment_charge()"
                                    :format-price="icPriceFormat"
                                />
                                <span class="breakdown-value">
                                    {{ icPriceFormat(getShippingTotal()) }}
                                </span>
                            </div>

                            <div
                                class="breakdown-item"
                                v-if="getSalesTaxTotal() > 0"
                            >
                                <ToolTip
                                    :label="'Sales Tax'"
                                    :title="'Sales Tax Breakdown'"
                                    :base-price="0"
                                    :quantity="0"
                                    :services="getSalesTaxServices()"
                                    :shipping-method-charge="0"
                                    :sales-tax="
                                        parseFloat(
                                            (order_data &&
                                                order_data.sales_tax) ||
                                                0
                                        )
                                    "
                                    :format-price="icPriceFormat"
                                />
                                <span class="breakdown-value">
                                    {{ icPriceFormat(getSalesTaxTotal()) }}
                                </span>
                            </div>

                            <div
                                class="breakdown-item"
                                style="
                                    border-top: 1px solid #e0e0e0;
                                    padding-top: 12px;
                                    margin-top: 8px;
                                "
                            >
                                <span
                                    class="breakdown-label"
                                    style="font-weight: bold"
                                    >Grand Total</span
                                >
                                <span
                                    class="breakdown-value"
                                    style="font-weight: bold"
                                >
                                    {{
                                        cartNotEmpty
                                            ? icPriceFormat(
                                                  calculatedGrandTotal
                                              )
                                            : "$0.00"
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import { resolveTierQuantityForItem } from "@/common/cartPricingTier.service";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import ToolTip from "@/views/frontend/cart_checkout/v3/components/ToolTip.vue";

export default {
    name: "CartSummary",
    props: ["is_reviewpay", "order_data"],
    data() {
        return {
            cartNotEmpty: null,
            cart_items: [],
            isBusy: false,
            grand_total: 0,
            shippingPrice: 0,
            total_quantity: 0,
            total_non_standard_colors: [],
            colors_limit: 6,
            total_imprint_locations_price: 0,
            total_setup_fee: 0,
            showOrdersDrawer: false,
            isUpdatingDisplayData: false, // Flag to prevent infinite loop in watcher
            liveServicesByDecorator: {}, // Store live services by decorator_id
            holidays: [], // Holidays for date calculation
            vendors_list: [], // Vendors list for standard shipping days
            // Bump this when split-shipping methods/costs change to force recomputation
            splitShippingVersion: 0,
            toastCooldownTracker: {},
            markup_tiers: [],
            realtimeTemplateFeeCache: {}
        };
    },
    computed: {
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        },
        split_shipment_step() {
            return this.$parent.split_shipment_step;
        },
        isSummaryScreen() {
            // Check if SplitItemsByAddress component is showing summary screen
            try {
                const splitItemsComponent = this.$parent.$children.find(child => child.$options && child.$options.name === 'SplitItemsByAddress');
                if (splitItemsComponent) {
                    return splitItemsComponent.showSummary === true;
                }
            } catch (e) {}
            return false;
        },
        allItemsAssignedInSummary() {
            // Check if all items are assigned in SplitItemsByAddress component
            try {
                const splitItemsComponent = this.$parent.$children.find(child => child.$options && child.$options.name === 'SplitItemsByAddress');
                if (splitItemsComponent) {
                    return splitItemsComponent.allItemsAssigned === true;
                }
            } catch (e) {}
            return false;
        },
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "adminOptions",
            "isAdminLoggedIn"
        ]),
        tag() {
            return this.$route.params.tag;
        },
        cartSubTotal() {
            if (
                !this.cartNotEmpty ||
                !this.cart_items ||
                this.cart_items.length === 0
            ) {
                return 0.0;
            }

            // Calculate subtotal by summing all items (parent + subItems)
            // Use the same values that are displayed in the UI (Item Sub Total - Discount)
            // For grouped items: Add parent item total + all subItems totals
            // For single items: Add item total
            let subtotal = 0;
            this.cart_items.forEach((item) => {
                // Check if item is grouped
                if (
                    this.isGroupedDecorationType0(item) &&
                    item.subItems &&
                    item.subItems.length > 0
                ) {
                    // For grouped items, add parent item total (Item Sub Total - Discount)
                    const parentTotal = this.getItemTotal(item);
                    subtotal += parentTotal;

                    // Add all sub-items totals (Item Sub Total - Discount)
                    item.subItems.forEach((subItem) => {
                        const subItemTotal = this.getSubItemTotal(
                            subItem,
                            item
                        );
                        subtotal += subItemTotal;
                    });
                } else {
                    // For single items, use getItemTotal (Item Sub Total - Discount)
                    const itemTotal = this.getItemTotal(item);
                    subtotal += itemTotal;
                }
            });
            return subtotal;
        },
        calculatedGrandTotal() {
            if (!this.cartNotEmpty) return 0.0;

            // cartSubTotal already includes color mix fee, setup fee, and non-standard fees in each item's subtotal
            // So we only need to add packaging, shipping and sales tax
            const cartSubTotal = parseFloat(this.cartSubTotal || 0);
            const packaging = parseFloat(this.getPackagingTotal() || 0);
            const shipping = parseFloat(this.getShippingTotal() || 0);
            const salesTax = parseFloat(this.getSalesTaxTotal() || 0);
            const grandTotal = cartSubTotal + packaging + shipping + salesTax;

            return grandTotal;
        }
    },
    watch: {
        calculatedGrandTotal(newVal) {
            if (this.$parent && this.$parent.order_data) {
                this.$parent.order_data.order_price = newVal;
                this.$parent.order_data.grand_total = newVal;
            }
        },
        // When split shipment addresses (including per-address shipping_cost) change,
        // bump splitShippingVersion so shipping + grand total recompute immediately.
        "$store.state.splitShipment.splitAddresses": {
            handler() {
                this.splitShippingVersion += 1;

                // Also resync grand_total on the parent order_data
                const newTotal = this.calculatedGrandTotal;
                if (this.$parent && this.$parent.order_data) {
                    this.$parent.order_data.grand_total = newTotal;
                    this.$parent.order_data.order_price = newTotal;
                }
            },
            deep: true
        },
        cartSubTotal() {
            // Update grand_total when cart subtotal changes
            if (this.$parent && this.$parent.order_data && this.cartNotEmpty) {
                const newGrandTotal = this.calculatedGrandTotal;
                this.$parent.order_data.grand_total = newGrandTotal;
                this.$parent.order_data.order_price = newGrandTotal;
            }
        },
        cart_items: {
            handler(newItems, oldItems) {
                // Prevent infinite loop: skip if we're already updating displayData
                if (this.isUpdatingDisplayData) {
                    return;
                }

                // Refresh displayData when cart_items change (including quantity changes)
                if (newItems && newItems.length > 0) {
                    // Set flag to prevent recursive updates
                    this.isUpdatingDisplayData = true;

                    // Use nextTick to defer the update and avoid triggering watcher during the update
                    this.$nextTick(() => {
                        try {
                            newItems.forEach((item) => {
                                const newDisplayData =
                                    this.getItemDisplayData(item);
                                // Only update if displayData doesn't exist or actually changed
                                if (
                                    !item.displayData ||
                                    JSON.stringify(item.displayData) !==
                                        JSON.stringify(newDisplayData)
                                ) {
                                    this.$set(
                                        item,
                                        "displayData",
                                        newDisplayData
                                    );
                                }
                                // Also refresh subItems
                                if (item.subItems && item.subItems.length > 0) {
                                    item.subItems.forEach((subItem) => {
                                        const newSubDisplayData =
                                            this.getItemDisplayData(
                                                subItem,
                                                item
                                            );
                                        // Only update if displayData doesn't exist or actually changed
                                        if (
                                            !subItem.displayData ||
                                            JSON.stringify(
                                                subItem.displayData
                                            ) !==
                                                JSON.stringify(
                                                    newSubDisplayData
                                                )
                                        ) {
                                            this.$set(
                                                subItem,
                                                "displayData",
                                                newSubDisplayData
                                            );
                                        }
                                    });
                                }
                            });
                        } finally {
                            // Reset flag after update
                            this.isUpdatingDisplayData = false;
                        }
                    });
                }
            },
            deep: true
        },
        showOrdersDrawer(isOpen) {
            // Lock/unlock body scroll when drawer opens/closes
            if (isOpen) {
                // Lock scroll
                document.body.style.overflow = "hidden";
                document.body.style.position = "fixed";
                document.body.style.width = "100%";
            } else {
                // Unlock scroll
                document.body.style.overflow = "";
                document.body.style.position = "";
                document.body.style.width = "";
            }
        }
    },
    components: { DisplayProductImage, ToolTip },
    mounted() {
        var _this = this;
        _this.$parent.isLoader = true;

        _this.order_data = _this.$parent.order_data;
        // Initialize cartNotEmpty from localStorage
        const cartNotEmptyFromStorage = localStorage.getItem("cartNotEmpty");
        if (cartNotEmptyFromStorage !== null) {
            _this.cartNotEmpty = cartNotEmptyFromStorage === "true";
        }
        _this.getAllMarkupTiers();
        _this.getCart();
        _this.fetchHolidays();
        _this.getVendorsList();
    },
    beforeDestroy() {
        // Ensure scroll is unlocked when component is destroyed
        if (this.showOrdersDrawer) {
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.width = "";
        }
    },
    methods: {
        getRealtimeTemplateEndpoint(decorationType, templateId) {
            if (!templateId) return null;
            if (decorationType == 1) return `/printtemplate/${templateId}`;
            if (decorationType == 5) return `/dtf-template/${templateId}`;
            if (decorationType == 2) return `/embroidery/${templateId}`;
            if (decorationType == 4) return `/patch-application/${templateId}`;
            return null;
        },
        normalizeRealtimeTemplateFees(responseData, decorationType) {
            if (!responseData || typeof responseData !== "object") return null;
            let detail = null;
            if (decorationType == 1 || decorationType == 5) {
                detail = responseData.templatedetail || null;
            } else if (decorationType == 2) {
                detail = responseData.embroiderydetail || null;
            } else if (decorationType == 4) {
                detail = responseData.patch_application_detail || null;
            }
            if (!detail) return null;
            return {
                price_dark: parseFloat(detail.price_dark || 0),
                price_light: parseFloat(detail.price_light || 0)
            };
        },
        async fetchRealtimeTemplateFees(decorationType, templateId) {
            const key = `${decorationType}:${templateId}`;
            if (this.realtimeTemplateFeeCache[key]) {
                return this.realtimeTemplateFeeCache[key];
            }
            const endpoint = this.getRealtimeTemplateEndpoint(
                decorationType,
                templateId
            );
            if (!endpoint) return null;
            try {
                const { data } = await ApiService.get(endpoint);
                const fees = this.normalizeRealtimeTemplateFees(
                    data,
                    decorationType
                );
                if (fees) {
                    this.$set(this.realtimeTemplateFeeCache, key, fees);
                }
                return fees;
            } catch (e) {
                return null;
            }
        },
        async applyRealtimeTemplateFees(cartItems) {
            if (!Array.isArray(cartItems) || cartItems.length === 0) return;
            const tasks = [];
            cartItems.forEach((item) => {
                const useTemplatePricing =
                    (item.main_new_product &&
                        item.main_new_product.decoration_price_type ===
                            "global_price") ||
                    (item.decoration &&
                        (item.decoration.use_imprintcity_price_template === 1 ||
                            item.decoration.use_imprintcity_price_template ===
                                "1"));
                if (
                    !item ||
                    !useTemplatePricing ||
                    (item.decoration_type != 1 &&
                        item.decoration_type != 5 &&
                        item.decoration_type != 2 &&
                        item.decoration_type != 4) ||
                    !item.decoration_price_template
                ) {
                    return;
                }
                tasks.push(
                    this.fetchRealtimeTemplateFees(
                        item.decoration_type,
                        item.decoration_price_template
                    ).then((fees) => {
                        if (!fees) return;
                        if (!item.decoration || typeof item.decoration !== "object") {
                            item.decoration = {};
                        }
                        item.decoration.price_dark = fees.price_dark;
                        item.decoration.price_light = fees.price_light;
                    })
                );
            });
            if (tasks.length > 0) {
                await Promise.all(tasks);
            }
        },
        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        this.markup_tiers = Array.isArray(data.markup_tiers)
                            ? data.markup_tiers
                            : [];
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            if (
                !Array.isArray(this.markup_tiers) ||
                !this.markup_tiers.length ||
                price === undefined ||
                price === null ||
                decoration_type === undefined ||
                decoration_type === null ||
                decoration_price_template === undefined ||
                decoration_price_template === null
            ) {
                return null;
            }

            const normalizedPrice = parseFloat(price);
            const tier = this.markup_tiers.find(
                (row) =>
                    decoration_type == row.decoration_id &&
                    decoration_price_template == row.template_id &&
                    parseFloat(row.start_price) <= normalizedPrice &&
                    parseFloat(row.end_price) >= normalizedPrice
            );

            return tier ? parseFloat(tier.markup) : null;
        },
        getResolvedMarkupPercentage(
            price,
            decoration_type,
            decoration_price_template
        ) {
            const tierMarkup = this.getMarkupFromTier(
                price,
                decoration_type,
                decoration_price_template
            );
            if (tierMarkup !== null) {
                return tierMarkup;
            }
            // Realtime-only behavior: no fallback from saved DB/product markup.
            return 0;
        },
        getChildMarkupPrice(item, childItem) {
            const basePrice = parseFloat(childItem.case_price || 0);
            const decorationType =
                item.decoration_type !== undefined &&
                item.decoration_type !== null
                    ? item.decoration_type
                    : item.main_new_product
                    ? item.main_new_product.decoration_type
                    : null;
            const decorationTemplate =
                item.decoration_price_template !== undefined &&
                item.decoration_price_template !== null
                    ? item.decoration_price_template
                    : item.main_new_product
                    ? item.main_new_product.decoration_price_template
                    : null;
            const markupPercentage = this.getResolvedMarkupPercentage(
                basePrice,
                decorationType,
                decorationTemplate
            );
            const markupPrice = parseFloat(
                (
                    (parseFloat(basePrice) * parseFloat(markupPercentage || 0)) /
                    100
                ).toFixed(2)
            );
            childItem.markup_percentage = markupPercentage;
            childItem.markup_price = markupPrice;
            return markupPrice;
        },
        showToastWithCooldown(type, key, message, options = {}, cooldownMs = 3500) {
    const now = Date.now();
    const lastShownAt = this.toastCooldownTracker[key] || 0;

    if (now - lastShownAt < cooldownMs) {
        return;
    }

    this.toastCooldownTracker[key] = now;

    if (this.$toast[type]) {
        this.$toast[type](message, options);
    } else {
        console.warn(`Invalid toast type: ${type}`);
    }
},
        // External hook for PaymentShipmentV2 to force grand total
        // to recompute when split-shipping methods/costs change.
        refreshGrandTotal() {
            // Bump version so computed shipping sees a reactive change
            this.splitShippingVersion += 1;

            this.$nextTick(() => {
                const newTotal = this.calculatedGrandTotal;
                if (this.$parent && this.$parent.order_data) {
                    this.$parent.order_data.grand_total = newTotal;
                    this.$parent.order_data.order_price = newTotal;
                }
            });
        },

        // Get active product discount for an item
        getActiveProductDiscount(item) {
            if (
                !item ||
                !item.main_new_product ||
                !item.main_new_product.MainNewProductDiscount
            ) {
                return null;
            }

            const discount = item.main_new_product.MainNewProductDiscount;

            // Return null if discount doesn't exist
            if (!discount) {
                return null;
            }

            const today = new Date();
            // Set time to the beginning of the day for a consistent date-only comparison
            today.setHours(0, 0, 0, 0);

            // Check if the discount has a start date and if it has already started
            if (discount.start_date) {
                const startDate = new Date(discount.start_date);
                startDate.setHours(0, 0, 0, 0); // Normalize to start of day for accurate comparison
                if (today < startDate) {
                    return null; // Discount hasn't started yet
                }
            }

            // Check if the discount has an end date and if it has expired
            if (discount.end_date) {
                const endDate = new Date(discount.end_date);
                endDate.setHours(23, 59, 59, 999); // Normalize to end of day for accurate comparison
                if (today > endDate) {
                    return null; // Discount has expired
                }
            }

            // Validate discount_type and discount_value
            if (!discount.discount_type || !discount.discount_value) {
                return null;
            }

            // If all checks pass, the discount is active
            return discount;
        },
        // Apply discount to size cost if activeProductDiscount exists
        applyDiscountToSizeCost(originalCost, item) {
            if (!originalCost || originalCost <= 0) {
                return originalCost;
            }

            const activeDiscount = this.getActiveProductDiscount(item);
            // Just check if discount exists and has required fields
            if (
                !activeDiscount ||
                !activeDiscount.discount_type ||
                !activeDiscount.discount_value
            ) {
                return originalCost;
            }

            const discountType = activeDiscount.discount_type;
            const discountValue = parseFloat(
                activeDiscount.discount_value || 0
            );

            if (discountType === "Percent") {
                return parseFloat(
                    (originalCost * (1 - discountValue / 100)).toFixed(2)
                );
            } else {
                // Fixed amount discount
                return parseFloat(
                    Math.max(0, originalCost - discountValue).toFixed(2)
                );
            }
        },

        // Get item discount - calculates from product discount (same logic as Cart.vue)
        // Discount is calculated on individual Item Sub Total for each item (including subItems)
        // Each item gets its own individual discount, not a group discount
        // Calculate discount amount for an item
        // Discount calculation removed - no longer applying overall discount
        // Discount is now applied at size cost level
        getItemDiscount(item, parentItem = null) {
            return 0;
        },
        handleBackClick() {
            var _this = this;
            // If drawer is open, close it first
            if (_this.showOrdersDrawer) {
                _this.showOrdersDrawer = false;
            }
            
            // Handle split shipment navigation
            if (_this.$parent.isSplitShipment) {
                if (_this.$parent.split_shipment_step === 'review') {
                    // Go back to payment step
                    _this.$parent.split_shipment_step = 'payment';
                    return;
                } else if (_this.$parent.split_shipment_step === 'payment') {
                    // Go back to billing step
                    _this.$parent.split_shipment_step = 'billing';
                    return;
                } else if (_this.$parent.split_shipment_step === 'billing') {
                    // Go back to charges step
                    _this.$parent.split_shipment_step = 'charges';
                    return;
                } else if (_this.$parent.split_shipment_step === 'charges') {
                    // Go back to split items (packaging step skipped)
                    _this.$parent.split_shipment_step = 'split_items';
                    return;
                } else if (_this.$parent.split_shipment_step === 'split_items') {
                    // Try to go to previous address first; only go to addresses step if already on first address
                    const splitItemsComponent = _this.$parent.$refs.splitItemsByAddress || _this.$parent.$children.find(c => c.$options && c.$options.name === 'SplitItemsByAddress');
                    const bulkSplitComponent = _this.$parent.$refs.bulkPersonalizationSplit || _this.$parent.$children.find(c => c.$options && c.$options.name === 'BulkPersonalizationSplit');
                    if (splitItemsComponent && typeof splitItemsComponent.goToPreviousAddress === 'function') {
                        if (splitItemsComponent.goToPreviousAddress()) return;
                    }
                    if (bulkSplitComponent && typeof bulkSplitComponent.goToPreviousAddress === 'function') {
                        if (bulkSplitComponent.goToPreviousAddress()) return;
                    }
                    _this.$parent.split_shipment_step = 'addresses';
                    return;
                } else if (_this.$parent.split_shipment_step === 'addresses') {
                    if (_this.$store && _this.$store.state && _this.$store.state.splitShipment) {
                        _this.$store.commit('splitShipment/resetSplitShipment');
                    }
                    _this.$parent.split_shipment_step = null;
                    _this.$router.push({ name: "cartV3" });
                    return;
                }
            }
            
            // Standard checkout flow navigation
            // If on review pay page, go back to payment shipment
            if (_this.$parent.is_reviewpay) {
                _this.$parent.is_reviewpay = false;
                _this.$parent.is_payment = true;
            }
            // If on payment shipment page, go back to shipping & billing address
            else if (_this.$parent.is_payment) {
                _this.$parent.is_reviewpay = false;
                _this.$parent.is_payment = false;
            }
            // If on shipping & billing address page, go back to cart
            else {
                _this.$router.push({ name: "cartV3" });
            }
        },
        handlePlaceOrder() {
            var _this = this;
            // Check if it's a split shipment
            if (_this.$parent.isSplitShipment && _this.$parent.split_shipment_step === 'review') {
                // Call placeOrderSplit for split shipments
                _this.$parent.placeOrderSplit();
            } else {
                // Call standard placeOrder for normal shipments
                _this.$parent.placeOrder();
            }
        },
        handleNextClick() {
            var _this = this;
            // If drawer is open, close it first and then proceed
            if (_this.showOrdersDrawer) {
                _this.showOrdersDrawer = false;
                // Use nextTick to ensure drawer closes before proceeding
                _this.$nextTick(() => {
                    _this.proceedWithNext();
                });
                return;
            }
            // If drawer is closed, proceed directly
            _this.proceedWithNext();
        },
        proceedWithNext() {
            var _this = this;
            
            // Handle split shipment navigation
            if (_this.$parent.isSplitShipment) {
                if (_this.$parent.split_shipment_step === 'addresses') {
                    const splitAddresses = (_this.$store.state.splitShipment && _this.$store.state.splitShipment.splitAddresses) || [];
                    const invalidAddresses = [];

                    splitAddresses.forEach((address, index) => {
                        const email = (address.email || "").toString().trim();
                        const missingFields = [];

                        if (!email) missingFields.push("email");

                        if (missingFields.length > 0) {
                            invalidAddresses.push({
                                index: index + 1,
                                missingFields
                            });
                        }
                    });
                    if (invalidAddresses.length === 0 && splitAddresses.length < 2) {
                        _this.showToastWithCooldown("error", "split-shipment-min-addresses", "Please add at least two address for split shipment", {
                            position: "top-right"
                        });
                        return;
                    }
                    if (invalidAddresses.length > 0) {
                        const firstInvalidAddress = invalidAddresses[0];
                        _this.$toast.error(`Address ${firstInvalidAddress.index} is missing ${firstInvalidAddress.missingFields.join(" and ")}`, {
                            position: "top-right",
                            duration: 5000
                        });
                        return;
                    }
                    const defaultAddresses = splitAddresses.filter(address => address && address.is_default);
                    if (defaultAddresses.length !== 1) {
                        _this.showToastWithCooldown("error", "split-shipment-default-address-required", "Please select default address", {
                            position: "top-right"
                        });
                        return;
                    }

                    // Move to split items step
                    _this.$parent.split_shipment_step = 'split_items';
                    return;
                } else if (_this.$parent.split_shipment_step === 'split_items') {
                    // Try to find SplitItemsByAddress component (for <= 4 addresses)
                    const splitItemsComponent = _this.$parent.$children.find(child => child.$options && child.$options.name === 'SplitItemsByAddress');
                    // Try to find BulkPersonalizationSplit component (for > 4 addresses)
                    const bulkSplitComponent = _this.$parent.$children.find(child => child.$options && child.$options.name === 'BulkPersonalizationSplit');
                    
                    if (splitItemsComponent) {
                        // Check if summary screen is showing
                        if (splitItemsComponent.showSummary) {
                            // Summary screen is showing, proceed to packaging
                            if (splitItemsComponent.allItemsAssigned) {
                        _this.$parent.proceedToPackaging();
                            } else {
                                _this.showToastWithCooldown("warning", "split-items-by-address-all-items-assigned", "Please assign all items to addresses before proceeding", {
                                    position: "top-right"
                                });
                            }
                            return;
                        }
                        
                        // Check if there are more addresses to process
                        const addresses = splitItemsComponent.splitAddresses || [];
                        const currentIndex = splitItemsComponent.currentAddressIndex || 0;
                        
                        // Validate that at least one item is selected for current address (commented: user can skip address)
                        // if (splitItemsComponent.selectedItemsCount === 0) {
                        //     _this.$toast.warning("Please select at least one product for this address", {
                        //         position: "top-right"
                        //     });
                        //     return;
                        // }
                        
                        // Save current address; on last address this shows summary screen (user must click NEXT again to go to charges)
                        splitItemsComponent.saveAndNextAddress();
                    } else if (bulkSplitComponent) {
                        // Check if summary screen is showing
                        if (bulkSplitComponent.showSummary) {
                            // Summary screen is showing, proceed to packaging
                            _this.$parent.proceedToPackaging();
                            return;
                        }
                        
                        // For bulk split, check if all items are assigned
                        const totalUnassigned = bulkSplitComponent.products ? bulkSplitComponent.products.reduce((sum, product) => {
                            return sum + bulkSplitComponent.getUnassignedQuantity(product);
                        }, 0) : 999;
                        
                        if (totalUnassigned === 0) {
                            const splitAddresses = Array.isArray(bulkSplitComponent.splitAddresses) ? bulkSplitComponent.splitAddresses : [];
                            const quantityAssignments = bulkSplitComponent.quantityAssignments || {};
                            const assignedAddressCount = splitAddresses.reduce((count, _address, index) => {
                                const addressAssignments = quantityAssignments[index] || {};
                                const hasAssignedProducts = Object.values(addressAssignments).some(qty => Number(qty) > 0);
                                return count + (hasAssignedProducts ? 1 : 0);
                            }, 0);

                            if (assignedAddressCount < 2) {
                                _this.showToastWithCooldown("warning", "split-shipment-bulk-min-assigned-addresses", "Please assign products to at least two addresses", {
                                    position: "top-right"
                                });
                                return;
                            }
                            // All items assigned, show summary screen
                            bulkSplitComponent.proceedToNext();
                        } else {
                            // Items remaining, show warning
                            _this.showToastWithCooldown("warning", "split-shipment-items-remaining", `${totalUnassigned} items still need to be assigned. Please assign all items before proceeding.`, {
                                position: "top-right"
                            });
                        }
                        return;
                    } else {
                        // Component not found, show warning
                        _this.showToastWithCooldown("warning", "split-shipment-all-remaining-products-assigned", "Please assign all remaining products to addresses before proceeding", {
                            position: "top-right"
                        });
                    }
                    return;
                } else if (_this.$parent.split_shipment_step === 'charges') {
                    // Move to next step after charges (billing address)
                    _this.$parent.split_shipment_step = 'billing';
                    return;
                } else if (_this.$parent.split_shipment_step === 'billing') {
                    // Validate billing address before proceeding
                    // Find BillingAddress component
                    const billingAddressComponent = _this.$parent.$children.find(
                        child => child.$options && child.$options.name === 'BillingAddress'
                    );
                    
                    if (billingAddressComponent && billingAddressComponent.validateBillingAddress) {
                        const isValid = billingAddressComponent.validateBillingAddress();
                        if (!isValid) {
                            return; // Don't proceed if validation fails
                        }
                    } else if (!_this.$parent.order_data || !_this.$parent.order_data.billing_address_id) {
                        // Fallback validation - check if billing address is set in order_data
                        _this.$toast.error("Please select a billing address before proceeding", {
                            position: "top-right",
                            queue: true
                        });
                        return;
                    }
                    
                    // Move to next step after billing (payment & shipment)
                    _this.$parent.split_shipment_step = 'payment';
                    return;
                } else if (_this.$parent.split_shipment_step === 'payment') {
                    // If on payment shipment page, validate payment method before proceeding
                    if (_this.$parent.$refs.PayShipmentRefSplit) {
                        // Validate and proceed to review
                        const result = _this.$parent.$refs.PayShipmentRefSplit.proceedToReview();
                        // Handle both promise and boolean return
                        if (result && typeof result.then === 'function') {
                            // It's a promise
                            result.then((isValid) => {
                                if (isValid) {
                                    _this.$parent.split_shipment_step = 'review';
                                }
                            });
                        } else if (result === true) {
                            // It's a boolean and validation passed
                            _this.$parent.split_shipment_step = 'review';
                        }
                        // If result is false, validation failed, don't proceed
                    } else {
                        // Fallback: directly proceed if ref not available
                        _this.$parent.split_shipment_step = 'review';
                    }
                    return;
                } else if (_this.$parent.split_shipment_step === 'review') {
                    // On review step, place the order
                    _this.handlePlaceOrder();
                    return;
                }
                // For other split shipment steps, handle accordingly
                // This will be handled as we add more steps
            }
            
            // Standard checkout flow navigation
            // If on shipping payment page, submit form to go to payment shipment
            if (!_this.$parent.is_reviewpay && !_this.$parent.is_payment) {
                // Find ShippingPayment form and trigger submit
                const form = document.querySelector(
                    ".shipping_address_form_custom"
                );
                if (form) {
                    // Submit form - this will go to payment shipment page
                    const submitEvent = new Event("submit", {
                        cancelable: true,
                        bubbles: true
                    });
                    form.dispatchEvent(submitEvent);
                }
            } else if (_this.$parent.is_payment) {
                // If on payment shipment page, validate payment method before proceeding
                if (_this.$parent.$refs.PayShipmentRef) {
                    // Validate and proceed to review
                    _this.$parent.$refs.PayShipmentRef.proceedToReview();
                } else {
                    // Fallback: directly proceed if ref not available
                    _this.$parent.is_reviewpay = true;
                    _this.$parent.is_payment = false;
                }
            } else {
                // Already on review pay, do nothing
                _this.$parent.is_reviewpay = true;
                _this.$parent.is_payment = false;
            }
        },
        shippment_charge() {
            // Touch splitShippingVersion so Vue tracks dependency on it
            const _version = this.splitShippingVersion;
            void _version;

            // Split shipment: sum shipping_cost per address, only on Payment & Shipment or Review step
            if (this.isSplitShipment) {
                if (
                    this.split_shipment_step !== "payment" &&
                    this.split_shipment_step !== "review"
                ) {
                    return 0;
                }

                const splitModule = this.$store.state.splitShipment;
                const addresses =
                    (splitModule && splitModule.splitAddresses) || [];

                const total = addresses.reduce((sum, addr) => {
                    if (!addr) return sum;
                    const rawCost =
                        addr.shipping_cost !== undefined &&
                        addr.shipping_cost !== null
                            ? addr.shipping_cost
                            : 0;
                    const cost = parseFloat(rawCost);
                    if (isNaN(cost)) {
                        return sum;
                    }
                    // Round each address cost to 2 decimals before summing
                    const rounded = parseFloat(cost.toFixed(2));
                    return sum + rounded;
                }, 0);

                // Final safeguard rounding
                return parseFloat(total.toFixed(2));
            }

            // Standard (non-split) shipment: show shipping only on Payment & Shipment or Review
            const parent = this.$parent || {};
            const isOnPaymentOrReview =
                parent.is_payment === true || this.is_reviewpay === true;
            if (!isOnPaymentOrReview) {
                return 0;
            }

            const shipment = parent.selected_shiping_method;
            if (shipment) {
                this.shippingPrice = shipment.total;
                return parseFloat(this.shippingPrice);
            }
            return 0;
        },

        // Get all shipping services (rollup_fee_id = 4) from all cart items
        getShippingServices() {
            if (!this.cart_items || this.cart_items.length === 0) return [];

            let allShippingServices = [];

            this.cart_items.forEach((item) => {
                // Parse decoration if it's a string
                let decoration = item.decoration;
                if (decoration && typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        decoration = null;
                    }
                }

                // Get services from decoration
                const otherServices =
                    decoration && decoration.other_services_list
                        ? decoration.other_services_list
                        : [];

                // Get live services for this item (already filtered to exclude duplicates)
                const liveServices = this.getLiveOtherServicesForItem(item);

                // Combine decoration services and live services
                const allOtherServices = [...otherServices, ...liveServices];

                const shippingServices = allOtherServices.filter((s) => {
                    const rollupService = s.rollup_service || {};
                    const serviceFeeId =
                        rollupService.rollup_fee_id !== undefined &&
                        rollupService.rollup_fee_id !== null
                            ? rollupService.rollup_fee_id
                            : s.rollup_fee_id !== undefined &&
                              s.rollup_fee_id !== null
                            ? s.rollup_fee_id
                            : null;
                    // Exclude services with Per Shipping Address fee structure
                    if (this.isPerShippingAddressService(s)) {
                        return false;
                    }
                    return serviceFeeId === 4 || serviceFeeId === "4";
                });

                // Add services - same decorator and service appears once only
                const quantity = this.getTotalItemQuantity(item);
                const decoratorId = item.main_new_product
                    ? item.main_new_product.default_decorator_id
                    : null;

                shippingServices.forEach((service) => {
                    // Check if service already exists (by id AND decorator_id)
                    // Skip same decorator and service (do not count duplicate occurrences)
                    const existingService = allShippingServices.find(
                        (s) =>
                            s.id === service.id &&
                            s._decorator_id === decoratorId
                    );

                    // Add if this service does not already exist
                    if (!existingService) {
                        const newService = {
                            ...service,
                            _decorator_id: decoratorId
                        };
                        if (this.isPerItemService(service)) {
                            // Per item fee structure: quantity = item quantity, total = price * quantity
                            newService._quantity = quantity;
                            newService._calculatedTotal =
                                parseFloat(
                                    service.retail_cost || service.net_cost || 0
                                ) * quantity;
                        } else {
                            // Non-per item: quantity = 1, total = price
                            newService._quantity = 1;
                            newService._calculatedTotal = parseFloat(
                                service.retail_cost || service.net_cost || 0
                            );
                        }
                        allShippingServices.push(newService);
                    }
                });

                // Also check subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        let subDecoration = subItem.decoration;
                        if (
                            subDecoration &&
                            typeof subDecoration === "string"
                        ) {
                            try {
                                subDecoration = JSON.parse(subDecoration);
                            } catch (e) {
                                subDecoration = null;
                            }
                        }

                        const subOtherServices =
                            subDecoration && subDecoration.other_services_list
                                ? subDecoration.other_services_list
                                : [];

                        // Get live services for subItem (already filtered to exclude duplicates)
                        const subLiveServices =
                            this.getLiveOtherServicesForItem(subItem);

                        // Combine decoration services and live services
                        const subAllOtherServices = [
                            ...subOtherServices,
                            ...subLiveServices
                        ];

                        const subShippingServices = subAllOtherServices.filter(
                            (s) => {
                                const rollupService = s.rollup_service || {};
                                const serviceFeeId =
                                    rollupService.rollup_fee_id !== undefined &&
                                    rollupService.rollup_fee_id !== null
                                        ? rollupService.rollup_fee_id
                                        : s.rollup_fee_id !== undefined &&
                                          s.rollup_fee_id !== null
                                        ? s.rollup_fee_id
                                        : null;
                                // Exclude services with Per Shipping Address fee structure
                                if (this.isPerShippingAddressService(s)) {
                                    return false;
                                }
                                return (
                                    serviceFeeId === 4 || serviceFeeId === "4"
                                );
                            }
                        );

                        const subQuantity = this.getTotalItemQuantity(subItem);
                        const subDecoratorId = subItem.main_new_product
                            ? subItem.main_new_product.default_decorator_id
                            : null;

                        subShippingServices.forEach((service) => {
                            // Check if service already exists (by id AND decorator_id)
                            // Skip same decorator and service (do not count duplicate occurrences)
                            const existingService = allShippingServices.find(
                                (s) =>
                                    s.id === service.id &&
                                    s._decorator_id === subDecoratorId
                            );

                            // Add if this service does not already exist
                            if (!existingService) {
                                const newService = {
                                    ...service,
                                    _decorator_id: subDecoratorId
                                };
                                if (this.isPerItemService(service)) {
                                    // Per item fee structure: quantity = item quantity, total = price * quantity
                                    newService._quantity = subQuantity;
                                    newService._calculatedTotal =
                                        parseFloat(
                                            service.retail_cost ||
                                                service.net_cost ||
                                                0
                                        ) * subQuantity;
                                } else {
                                    // Non-per item: quantity = 1, total = price
                                    newService._quantity = 1;
                                    newService._calculatedTotal = parseFloat(
                                        service.retail_cost ||
                                            service.net_cost ||
                                            0
                                    );
                                }
                                allShippingServices.push(newService);
                            }
                        });
                    });
                }
            });

            return allShippingServices;
        },

        // Get shipping services for tooltip:
        // - Standard flow: existing shipping services
        // - Split shipment: one synthetic "service" per address (Shipping Charge (Address X))
        //   plus any existing shipping services
        getShippingServicesForTooltip() {
            const baseServices = this.getShippingServices() || [];

            if (!this.isSplitShipment) {
                return baseServices;
            }

            const splitModule = this.$store.state.splitShipment;
            const addresses = (splitModule && splitModule.splitAddresses) || [];

            const addressServices = addresses
                .map((addr, index) => {
                    if (!addr) return null;
                    const rawCost =
                        addr.shipping_cost !== undefined && addr.shipping_cost !== null
                            ? addr.shipping_cost
                            : 0;
                    const cost = parseFloat(rawCost);
                    if (isNaN(cost) || cost <= 0) return null;

                    const label = `Shipping Charge (Address ${index + 1})`;

                    return {
                        id: `split-address-shipping-${index + 1}`,
                        ecomm_display: label,
                        name: label,
                        retail_cost: cost,
                        net_cost: cost,
                        fee_structure: "Per Order",
                        // Use "-" quantity so ToolTip shows "-" instead of 1
                        _quantity: "-",
                        _calculatedTotal: cost,
                        rollup_fee_id: 4,
                        show_service: true
                    };
                })
                .filter(Boolean);

            return [...addressServices, ...baseServices];
        },

        // Calculate total shipping including shipping method charge + shipping services
        getShippingTotal() {
            // Only calculate shipping on the appropriate step:
            // - Split flow: Payment & Shipment or Review
            // - Standard flow: Payment & Shipment (is_payment) or Review (is_reviewpay)
            if (this.isSplitShipment) {
                if (
                    this.split_shipment_step !== "payment" &&
                    this.split_shipment_step !== "review"
                ) {
                    return 0;
                }
            } else {
                const parent = this.$parent || {};
                const isOnPaymentOrReview =
                    parent.is_payment === true || this.is_reviewpay === true;
                if (!isOnPaymentOrReview) {
                    return 0;
                }
            }

            let total = this.shippment_charge() || 0;

            const shippingServices = this.getShippingServices();
            shippingServices.forEach((service) => {
                if (
                    service._calculatedTotal !== undefined &&
                    service._calculatedTotal !== null
                ) {
                    total += parseFloat(service._calculatedTotal);
                } else {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        // For Per Item, we need total quantity across all items
                        const quantity = service._quantity || 0;
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                }
            });

            return parseFloat(total.toFixed(2));
        },

        // Get Shipping Breakdown (shipping method charge + shipping services)
        getShippingBreakdown() {
            const breakdown = [];

            // Split shipment: show per-address shipping charges
            if (this.isSplitShipment) {
                const splitModule = this.$store.state.splitShipment;
                const addresses = (splitModule && splitModule.splitAddresses) || [];

                addresses.forEach((addr, index) => {
                    if (!addr) return;
                    const rawCost =
                        addr.shipping_cost !== undefined && addr.shipping_cost !== null
                            ? addr.shipping_cost
                            : 0;
                    const cost = parseFloat(rawCost);
                    if (isNaN(cost) || cost <= 0) return;

                    breakdown.push({
                        type: "shipping_method",
                        name: `Shipping Charge (Address ${index + 1})`,
                        qty: "-",
                        amt: cost,
                        total: cost,
                        show_service: true,
                        address_sequence: index + 1
                    });
                });

                // Also include any shipping services (e.g., extra freight fees)
                const shippingServicesSplit = this.getShippingServices();
                if (shippingServicesSplit && shippingServicesSplit.length > 0) {
                    shippingServicesSplit.forEach((service) => {
                        const servicePrice = parseFloat(
                            service.retail_cost || service.net_cost || 0
                        );
                        if (servicePrice > 0) {
                            let serviceQty = service._quantity || 1;
                            let serviceAmt = servicePrice;
                            let serviceTotal = service._calculatedTotal || 0;

                            if (serviceTotal === 0) {
                                if (this.isPerItemService(service)) {
                                    serviceTotal = servicePrice * serviceQty;
                                } else {
                                    serviceQty = 1;
                                    serviceTotal = servicePrice;
                                }
                            }

                            breakdown.push({
                                type: "service",
                                name:
                                    service.ecomm_display ||
                                    service.name ||
                                    service.service_name ||
                                    "Shipping Service",
                                qty: serviceQty,
                                amt: parseFloat(serviceAmt).toFixed(2),
                                total: parseFloat(serviceTotal).toFixed(2),
                                show_service:
                                    service.show_service !== undefined
                                        ? service.show_service
                                        : true,
                                service_id: service.id || null,
                                ecomm_display: service.ecomm_display || null
                            });
                        }
                    });
                }

                return breakdown.length > 0 ? breakdown : null;
            }

            // Standard (non-split) shipment: single shipping method row + services
            const shippingMethodCharge = this.shippment_charge() || 0;
            const shippingServices = this.getShippingServices();

            // Add shipping method charge if > 0
            if (shippingMethodCharge > 0) {
                breakdown.push({
                    type: "shipping_method",
                    name: "Shipping Charge",
                    qty: 1,
                    amt: parseFloat(shippingMethodCharge).toFixed(2),
                    total: parseFloat(shippingMethodCharge).toFixed(2),
                    show_service: true
                });
            }

            // Add shipping services
            if (shippingServices && shippingServices.length > 0) {
                shippingServices.forEach((service) => {
                    const servicePrice = parseFloat(
                        service.retail_cost || service.net_cost || 0
                    );
                    if (servicePrice > 0) {
                        let serviceQty = service._quantity || 1;
                        let serviceAmt = servicePrice;
                        let serviceTotal = service._calculatedTotal || 0;

                        if (serviceTotal === 0) {
                            if (this.isPerItemService(service)) {
                                serviceTotal = servicePrice * serviceQty;
                            } else {
                                serviceQty = 1;
                                serviceTotal = servicePrice;
                            }
                        }

                        breakdown.push({
                            type: "service",
                            name:
                                service.ecomm_display ||
                                service.name ||
                                service.service_name ||
                                "Shipping Service",
                            qty: serviceQty,
                            amt: parseFloat(serviceAmt).toFixed(2),
                            total: parseFloat(serviceTotal).toFixed(2),
                            show_service:
                                service.show_service !== undefined
                                    ? service.show_service
                                    : true,
                            service_id: service.id || null,
                            ecomm_display: service.ecomm_display || null
                        });
                    }
                });
            }

            return breakdown.length > 0 ? breakdown : null;
        },

        // Helper function to check if service is Per Item
        isPerItemService(service) {
            if (!service) return false;
            return (
                service.fee_structure === "Per Item" ||
                (service.rollup_service &&
                    service.rollup_service.fee_structure_name === "Per Item")
            );
        },

        // Helper function to check if service has Per Shipping Address fee structure
        isPerShippingAddressService(service) {
            if (!service) return false;
            const feeStructureName =
                service.fee_structure ||
                (service.rollup_service &&
                    service.rollup_service.fee_structure_name) ||
                (service.master_service &&
                    service.master_service.fee_structure_data &&
                    service.master_service.fee_structure_data.name);

            if (!feeStructureName) return false;

            const name = String(feeStructureName).toLowerCase().trim();
            return (
                name === "per shipping address" ||
                name.includes("per shipping address")
            );
        },

        // Get all packaging services (rollup_fee_id = 5) from all cart items
        getPackagingServices() {
            if (!this.cart_items || this.cart_items.length === 0) return [];

            let allPackagingServices = [];

            this.cart_items.forEach((item) => {
                // Parse decoration if it's a string
                let decoration = item.decoration;
                if (decoration && typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        decoration = null;
                    }
                }

                // Get services from decoration
                const otherServices =
                    decoration && decoration.other_services_list
                        ? decoration.other_services_list
                        : [];

                // Get live services for this item (already filtered to exclude duplicates)
                const liveServices = this.getLiveOtherServicesForItem(item);

                // Combine decoration services and live services
                const allOtherServices = [...otherServices, ...liveServices];

                const packagingServices = allOtherServices.filter((s) => {
                    const rollupService = s.rollup_service || {};
                    const serviceFeeId =
                        rollupService.rollup_fee_id !== undefined &&
                        rollupService.rollup_fee_id !== null
                            ? rollupService.rollup_fee_id
                            : s.rollup_fee_id !== undefined &&
                              s.rollup_fee_id !== null
                            ? s.rollup_fee_id
                            : null;
                    return serviceFeeId === 5 || serviceFeeId === "5";
                });

                // Add services - same decorator and service appears once only
                const quantity = this.getTotalItemQuantity(item);
                const decoratorId = item.main_new_product
                    ? item.main_new_product.default_decorator_id
                    : null;

                packagingServices.forEach((service) => {
                    // Check if service already exists (by id AND decorator_id)
                    // Skip same decorator and service (do not count duplicate occurrences)
                    const existingService = allPackagingServices.find(
                        (s) =>
                            s.id === service.id &&
                            s._decorator_id === decoratorId
                    );

                    // Add if this service does not already exist
                    if (!existingService) {
                        const newService = {
                            ...service,
                            _decorator_id: decoratorId
                        };
                        if (this.isPerItemService(service)) {
                            // Per item fee structure: quantity = item quantity, total = price * quantity
                            newService._quantity = quantity;
                            newService._calculatedTotal =
                                parseFloat(
                                    service.retail_cost || service.net_cost || 0
                                ) * quantity;
                        } else {
                            // Non-per item: quantity = 1, total = price
                            newService._quantity = 1;
                            newService._calculatedTotal = parseFloat(
                                service.retail_cost || service.net_cost || 0
                            );
                        }
                        allPackagingServices.push(newService);
                    }
                });

                // Also check subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        let subDecoration = subItem.decoration;
                        if (
                            subDecoration &&
                            typeof subDecoration === "string"
                        ) {
                            try {
                                subDecoration = JSON.parse(subDecoration);
                            } catch (e) {
                                subDecoration = null;
                            }
                        }

                        const subOtherServices =
                            subDecoration && subDecoration.other_services_list
                                ? subDecoration.other_services_list
                                : [];

                        // Get live services for subItem (already filtered to exclude duplicates)
                        const subLiveServices =
                            this.getLiveOtherServicesForItem(subItem);

                        // Combine decoration services and live services
                        const subAllOtherServices = [
                            ...subOtherServices,
                            ...subLiveServices
                        ];

                        const subPackagingServices = subAllOtherServices.filter(
                            (s) => {
                                const rollupService = s.rollup_service || {};
                                const serviceFeeId =
                                    rollupService.rollup_fee_id !== undefined &&
                                    rollupService.rollup_fee_id !== null
                                        ? rollupService.rollup_fee_id
                                        : s.rollup_fee_id !== undefined &&
                                          s.rollup_fee_id !== null
                                        ? s.rollup_fee_id
                                        : null;
                                return (
                                    serviceFeeId === 5 || serviceFeeId === "5"
                                );
                            }
                        );

                        const subQuantity = this.getTotalItemQuantity(subItem);
                        const subDecoratorId = subItem.main_new_product
                            ? subItem.main_new_product.default_decorator_id
                            : null;

                        subPackagingServices.forEach((service) => {
                            // Check if service already exists (by id AND decorator_id)
                            // Skip same decorator and service (do not count duplicate occurrences)
                            const existingService = allPackagingServices.find(
                                (s) =>
                                    s.id === service.id &&
                                    s._decorator_id === subDecoratorId
                            );

                            // Add if this service does not already exist
                            if (!existingService) {
                                const newService = {
                                    ...service,
                                    _decorator_id: subDecoratorId
                                };
                                if (this.isPerItemService(service)) {
                                    // Per item fee structure: quantity = item quantity, total = price * quantity
                                    newService._quantity = subQuantity;
                                    newService._calculatedTotal =
                                        parseFloat(
                                            service.retail_cost ||
                                                service.net_cost ||
                                                0
                                        ) * subQuantity;
                                } else {
                                    // Non-per item: quantity = 1, total = price
                                    newService._quantity = 1;
                                    newService._calculatedTotal = parseFloat(
                                        service.retail_cost ||
                                            service.net_cost ||
                                            0
                                    );
                                }
                                allPackagingServices.push(newService);
                            }
                        });
                    });
                }
            });

            return allPackagingServices;
        },

        // Should we include split shipment fee in packaging totals/tooltips?
        includeSplitShipmentFeeInPackaging() {
            if (!this.isSplitShipment) return false;
            const step = this.split_shipment_step;
            // Only from Charges Summary step onwards
            return (
                step === "charges" ||
                step === "billing" ||
                step === "payment" ||
                step === "review"
            );
        },

        // Get packaging services for tooltip (include split shipment fee as virtual service)
        getPackagingServicesForTooltip() {
            const services = [...this.getPackagingServices()];

            if (this.includeSplitShipmentFeeInPackaging()) {
                const assignments =
                    (this.$store.state.splitShipment &&
                        this.$store.state.splitShipment.productAssignments) ||
                    {};
                const indices = new Set();
                Object.keys(assignments).forEach((key) => {
                    const a = assignments[key];
                    if (a && a.selected && a.addressIndex !== undefined) {
                        indices.add(a.addressIndex);
                    }
                });
                const totalWithProducts = indices.size;
                const chargeable =
                    totalWithProducts <= 1 ? 0 : totalWithProducts - 1;
                if (chargeable > 0) {
                    const opt =
                        this.$store.getters.getAdminOption &&
                        this.$store.getters.getAdminOption(
                            "split_shipment_fee_per_address"
                        );
                    const val =
                        opt && opt.option_value != null
                            ? String(opt.option_value).replace(/[^0-9.]/g, "")
                            : "";
                    const feePerAddress = parseFloat(val) || 0;
                    const total = feePerAddress * chargeable;
                    if (total > 0) {
                        services.push({
                            id: "split_shipment_fee_per_address",
                            rollup_fee_id: 5,
                            rollup_service: { rollup_fee_id: 5 },
                            service_name: "Split Shipment Fee",
                            name: "Split Shipment Fee",
                            ecomm_display:
                                "Split Shipment Fee per address over (" +
                                totalWithProducts +
                                ") Addresses",
                            fee_structure: "Per Item",
                            retail_cost: feePerAddress,
                            net_cost: feePerAddress,
                            _quantity: chargeable,
                            _calculatedTotal: total,
                            show_service: true
                        });
                    }
                }
            }

            return services;
        },

        // Calculate total packaging charges (services + split shipment fee) from breakdown
        getPackagingTotal() {
            const breakdown = this.getPackagingBreakdown();
            if (breakdown && breakdown.length > 0) {
                let total = 0;
                breakdown.forEach((item) => {
                    if (
                        item.total &&
                        item.total !== "INCL" &&
                        item.total !== "-"
                    ) {
                        total += parseFloat(item.total) || 0;
                    } else if (
                        (item.amt || item.amount) &&
                        item.amt !== "INCL" &&
                        item.amt !== "-" &&
                        item.amount !== "INCL" &&
                        item.amount !== "-"
                    ) {
                        total += parseFloat(item.amt || item.amount || 0);
                    }
                });
                if (total > 0) {
                    return parseFloat(total.toFixed(2));
                }
            }
            return 0;
        },

        // Get Packaging Breakdown (packaging services + split shipment fee when applicable)
        getPackagingBreakdown() {
            const breakdown = [];
            const packagingServices = this.getPackagingServices();

            // Add packaging services
            if (packagingServices && packagingServices.length > 0) {
                packagingServices.forEach((service) => {
                    const servicePrice = parseFloat(
                        service.retail_cost || service.net_cost || 0
                    );
                    if (servicePrice > 0) {
                        let serviceQty = service._quantity || 1;
                        let serviceAmt = servicePrice;
                        let serviceTotal = service._calculatedTotal || 0;

                        if (serviceTotal === 0) {
                            if (this.isPerItemService(service)) {
                                serviceTotal = servicePrice * serviceQty;
                            } else {
                                serviceQty = 1;
                                serviceTotal = servicePrice;
                            }
                        }

                        breakdown.push({
                            type: "service",
                            name:
                                service.ecomm_display ||
                                service.name ||
                                service.service_name ||
                                "Packaging Service",
                            qty: serviceQty,
                            amt: parseFloat(serviceAmt).toFixed(2),
                            total: parseFloat(serviceTotal).toFixed(2),
                            show_service:
                                service.show_service !== undefined
                                    ? service.show_service
                                    : true,
                            service_id: service.id || null,
                            ecomm_display: service.ecomm_display || null
                        });
                    }
                });
            }

            // Split shipment fee: first address free, charge for (addresses with products - 1)
            if (this.includeSplitShipmentFeeInPackaging()) {
                const assignments = this.$store.state.splitShipment && this.$store.state.splitShipment.productAssignments || {};
                const indices = new Set();
                Object.keys(assignments).forEach(key => {
                    const a = assignments[key];
                    if (a && a.selected && a.addressIndex !== undefined) indices.add(a.addressIndex);
                });
                const totalWithProducts = indices.size;
                const chargeable = totalWithProducts <= 1 ? 0 : totalWithProducts - 1;
                if (chargeable > 0) {
                    const opt = this.$store.getters.getAdminOption && this.$store.getters.getAdminOption('split_shipment_fee_per_address');
                    const val = opt && opt.option_value != null ? String(opt.option_value).replace(/[^0-9.]/g, '') : '';
                    const feePerAddress = parseFloat(val) || 0;
                    const total = feePerAddress * chargeable;
                    if (total > 0) {
                        breakdown.push({
                            type: "service",
                            name: "Split Shipment Fee per address over (" + totalWithProducts + ") Addresses",
                            qty: chargeable,
                            amt: parseFloat(feePerAddress).toFixed(2),
                            total: parseFloat(total).toFixed(2),
                            show_service: true,
                            service_id: null,
                            ecomm_display: null
                        });
                    }
                }
            }

            return breakdown.length > 0 ? breakdown : null;
        },

        // Get all sales tax services (rollup_fee_id = 3) from all cart items
        getSalesTaxServices() {
            if (!this.cart_items || this.cart_items.length === 0) return [];

            let allSalesTaxServices = [];

            this.cart_items.forEach((item) => {
                // Parse decoration if it's a string
                let decoration = item.decoration;
                if (decoration && typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        decoration = null;
                    }
                }

                // Get services from decoration
                const otherServices =
                    decoration && decoration.other_services_list
                        ? decoration.other_services_list
                        : [];

                // Get live services for this item (already filtered to exclude duplicates)
                const liveServices = this.getLiveOtherServicesForItem(item);

                // Combine decoration services and live services
                const allOtherServices = [...otherServices, ...liveServices];

                const salesTaxServices = allOtherServices.filter((s) => {
                    const rollupService = s.rollup_service || {};
                    const serviceFeeId =
                        rollupService.rollup_fee_id !== undefined &&
                        rollupService.rollup_fee_id !== null
                            ? rollupService.rollup_fee_id
                            : s.rollup_fee_id !== undefined &&
                              s.rollup_fee_id !== null
                            ? s.rollup_fee_id
                            : null;
                    return serviceFeeId === 3 || serviceFeeId === "3";
                });

                // Add services - same decorator and service appears once only
                const quantity = this.getTotalItemQuantity(item);
                const decoratorId = item.main_new_product
                    ? item.main_new_product.default_decorator_id
                    : null;

                salesTaxServices.forEach((service) => {
                    // Check if service already exists (by id AND decorator_id)
                    // Skip same decorator and service (do not count duplicate occurrences)
                    const existingService = allSalesTaxServices.find(
                        (s) =>
                            s.id === service.id &&
                            s._decorator_id === decoratorId
                    );

                    // Add if this service does not already exist
                    if (!existingService) {
                        const newService = {
                            ...service,
                            _decorator_id: decoratorId
                        };
                        if (this.isPerItemService(service)) {
                            // Per item fee structure: quantity = item quantity, total = price * quantity
                            newService._quantity = quantity;
                            newService._calculatedTotal =
                                parseFloat(
                                    service.retail_cost || service.net_cost || 0
                                ) * quantity;
                        } else {
                            newService._quantity = 1;
                            newService._calculatedTotal = parseFloat(
                                service.retail_cost || service.net_cost || 0
                            );
                        }
                        allSalesTaxServices.push(newService);
                    }
                });

                // Also check subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        let subDecoration = subItem.decoration;
                        if (
                            subDecoration &&
                            typeof subDecoration === "string"
                        ) {
                            try {
                                subDecoration = JSON.parse(subDecoration);
                            } catch (e) {
                                subDecoration = null;
                            }
                        }

                        const subOtherServices =
                            subDecoration && subDecoration.other_services_list
                                ? subDecoration.other_services_list
                                : [];

                        // Get live services for subItem (already filtered to exclude duplicates)
                        const subLiveServices =
                            this.getLiveOtherServicesForItem(subItem);

                        // Combine decoration services and live services
                        const subAllOtherServices = [
                            ...subOtherServices,
                            ...subLiveServices
                        ];

                        const subSalesTaxServices = subAllOtherServices.filter(
                            (s) => {
                                const rollupService = s.rollup_service || {};
                                const serviceFeeId =
                                    rollupService.rollup_fee_id !== undefined &&
                                    rollupService.rollup_fee_id !== null
                                        ? rollupService.rollup_fee_id
                                        : s.rollup_fee_id !== undefined &&
                                          s.rollup_fee_id !== null
                                        ? s.rollup_fee_id
                                        : null;
                                return (
                                    serviceFeeId === 3 || serviceFeeId === "3"
                                );
                            }
                        );

                        const subQuantity = this.getTotalItemQuantity(subItem);
                        const subDecoratorId = subItem.main_new_product
                            ? subItem.main_new_product.default_decorator_id
                            : null;

                        subSalesTaxServices.forEach((service) => {
                            // Check if service already exists (by id AND decorator_id)
                            // Skip same decorator and service (do not count duplicate occurrences)
                            const existingService = allSalesTaxServices.find(
                                (s) =>
                                    s.id === service.id &&
                                    s._decorator_id === subDecoratorId
                            );

                            // Add if this service does not already exist
                            if (!existingService) {
                                const newService = {
                                    ...service,
                                    _decorator_id: subDecoratorId
                                };
                                if (this.isPerItemService(service)) {
                                    // Per item fee structure: quantity = item quantity, total = price * quantity
                                    newService._quantity = subQuantity;
                                    newService._calculatedTotal =
                                        parseFloat(
                                            service.retail_cost ||
                                                service.net_cost ||
                                                0
                                        ) * subQuantity;
                                } else {
                                    // Non-per item: quantity = 1, total = price
                                    newService._quantity = 1;
                                    newService._calculatedTotal = parseFloat(
                                        service.retail_cost ||
                                            service.net_cost ||
                                            0
                                    );
                                }
                                allSalesTaxServices.push(newService);
                            }
                        });
                    });
                }
            });

            return allSalesTaxServices;
        },

        // Calculate total sales tax including services and order_data.sales_tax
        getSalesTaxTotal() {
            let total = parseFloat(
                (this.order_data && this.order_data.sales_tax) || 0
            );

            const salesTaxServices = this.getSalesTaxServices();
            salesTaxServices.forEach((service) => {
                if (
                    service._calculatedTotal !== undefined &&
                    service._calculatedTotal !== null
                ) {
                    total += parseFloat(service._calculatedTotal);
                } else {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        // For Per Item, we need total quantity across all items
                        const quantity = service._quantity || 0;
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                }
            });

            return parseFloat(total.toFixed(2));
        },

        // Get Sales Tax Breakdown (sales tax from order_data + sales tax services)
        getSalesTaxBreakdown() {
            const breakdown = [];
            const salesTaxFromOrder = parseFloat(
                (this.order_data && this.order_data.sales_tax) || 0
            );
            const salesTaxServices = this.getSalesTaxServices();

            // Add sales tax from order_data if > 0
            if (salesTaxFromOrder > 0) {
                breakdown.push({
                    type: "sales_tax",
                    name: "Sales Tax",
                    qty: 1,
                    amt: parseFloat(salesTaxFromOrder).toFixed(2),
                    total: parseFloat(salesTaxFromOrder).toFixed(2),
                    show_service: true
                });
            }

            // Add sales tax services
            if (salesTaxServices && salesTaxServices.length > 0) {
                salesTaxServices.forEach((service) => {
                    const servicePrice = parseFloat(
                        service.retail_cost || service.net_cost || 0
                    );
                    if (servicePrice > 0) {
                        let serviceQty = service._quantity || 1;
                        let serviceAmt = servicePrice;
                        let serviceTotal = service._calculatedTotal || 0;

                        if (serviceTotal === 0) {
                            if (this.isPerItemService(service)) {
                                serviceTotal = servicePrice * serviceQty;
                            } else {
                                serviceQty = 1;
                                serviceTotal = servicePrice;
                            }
                        }

                        breakdown.push({
                            type: "service",
                            name:
                                service.ecomm_display ||
                                service.name ||
                                service.service_name ||
                                "Sales Tax Service",
                            qty: serviceQty,
                            amt: parseFloat(serviceAmt).toFixed(2),
                            total: parseFloat(serviceTotal).toFixed(2),
                            show_service:
                                service.show_service !== undefined
                                    ? service.show_service
                                    : true,
                            service_id: service.id || null,
                            ecomm_display: service.ecomm_display || null
                        });
                    }
                });
            }

            return breakdown.length > 0 ? breakdown : null;
        },

        showSizes(sizes) {
            if (!sizes || !Array.isArray(sizes)) {
                return "";
            }
            return sizes
                .filter(
                    (siz) =>
                        siz &&
                        siz.quantity > 0 &&
                        siz.main_new_sub_product &&
                        siz.main_new_sub_product.Size &&
                        siz.main_new_sub_product.Size.size
                )
                .map(
                    (element) =>
                        element.main_new_sub_product.Size.size +
                        ": " +
                        element.quantity
                )
                .join(", ");
        },

        totalDiscount(sizes) {
            let discount = 0;
            sizes.forEach((size) => {
                discount += parseFloat(size.discount);
            });
            return discount;
        },

        handleContinueShopping() {
            // Redirect to home page or products page
            this.$router.push("/");
        },

        // Prepare display data for all items (main items and subItems)
        prepareDisplayDataForItems() {
            this.cart_items.forEach((item) => {
                item.displayData = this.getItemDisplayData(item);
                // Also calculate displayData for subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        subItem.displayData = this.getItemDisplayData(
                            subItem,
                            item
                        );
                    });
                }
            });
        },

        // Enrich rush fee breakdowns with real-time vendor service prices
        async enrichRushFeeBreakdowns(cartItems) {
            if (!cartItems || cartItems.length === 0) {
                return;
            }

            // Collect unique default_decorator_ids from cart items
            const decoratorIds = new Set();

            cartItems.forEach((item) => {
                // Get decorator_id from product
                const decoratorId =
                    item.main_new_product &&
                    item.main_new_product.default_decorator_id
                        ? item.main_new_product.default_decorator_id
                        : null;

                if (decoratorId) {
                    decoratorIds.add(decoratorId);
                }

                // Also check subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        const subDecoratorId =
                            subItem.main_new_product &&
                            subItem.main_new_product.default_decorator_id
                                ? subItem.main_new_product.default_decorator_id
                                : null;
                        if (subDecoratorId) {
                            decoratorIds.add(subDecoratorId);
                        }
                    });
                }
            });

            if (decoratorIds.size === 0) {
                return; // No decorator IDs found
            }

            // Fetch vendor services for all unique decorator IDs
            const vendorServicesMap = new Map();
            const fetchPromises = Array.from(decoratorIds).map(
                async (decoratorId) => {
                    try {
                        const response = await ApiService.get(
                            `/vendors/${decoratorId}/services`
                        );
                        if (response.data && response.data.vendorServices) {
                            vendorServicesMap.set(
                                decoratorId,
                                response.data.vendorServices
                            );
                        } else if (
                            response.data &&
                            Array.isArray(response.data)
                        ) {
                            // Handle case where response is directly an array
                            vendorServicesMap.set(decoratorId, response.data);
                        }
                    } catch (error) {
                        console.error(
                            `Error fetching vendor services for decorator ${decoratorId}:`,
                            error
                        );
                    }
                }
            );

            await Promise.all(fetchPromises);

            // Enrich rush fee breakdowns for each item
            cartItems.forEach((item) => {
                this.enrichItemRushFeeBreakdown(item, vendorServicesMap);

                // Also enrich subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        this.enrichItemRushFeeBreakdown(
                            subItem,
                            vendorServicesMap
                        );
                    });
                }
            });
        },

        // Enrich rush fee breakdown for a single item
        enrichItemRushFeeBreakdown(item, vendorServicesMap) {
            if (!item.rush_fee_breakdown || !item.rush_fee_breakdown.services) {
                return;
            }

            // Get decorator_id from product
            const decoratorId =
                item.main_new_product &&
                item.main_new_product.default_decorator_id
                    ? item.main_new_product.default_decorator_id
                    : null;

            if (!decoratorId) {
                return; // No decorator ID found
            }

            // Get vendor services for this decorator
            const vendorServices = vendorServicesMap.get(decoratorId);
            if (!vendorServices || vendorServices.length === 0) {
                return; // No vendor services found
            }

            // Get master_service.id from decoration
            let masterServiceId = null;
            if (item.decoration && item.decoration.master_service) {
                masterServiceId = item.decoration.master_service.id;
            }

            if (!masterServiceId) {
                return; // No master service ID found
            }

            // Find vendor service that matches master_service.id
            const vendorService = vendorServices.find(
                (vs) => vs.id === masterServiceId
            );
            if (!vendorService) {
                return; // Vendor service not found
            }

            // Get current quantity for calculation
            let currentQuantity = 0;
            // Try to get from Cart component first
            if (this.$root && this.$root.$children) {
                const cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" ||
                        comp.getTotalItemQuantity
                );
                if (cartComponent && cartComponent.getTotalItemQuantity) {
                    currentQuantity = cartComponent.getTotalItemQuantity(item);
                }
            }
            // Fallback to local calculation
            if (currentQuantity === 0) {
                currentQuantity = this.getTotalItemQuantity(item);
            }

            // Update rush fee breakdown services with latest prices
            item.rush_fee_breakdown.services.forEach((service, index) => {
                if (service.is_rush_option === true) {
                    // Update rush options (rush1, rush3, rush5, rush7, rush_package)
                    let updatedPrice = null;
                    switch (service.service_id) {
                        case "rush1":
                            if (
                                vendorService.rush1 !== undefined &&
                                vendorService.rush1 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush1 || 0
                                );
                            }
                            break;
                        case "rush3":
                            if (
                                vendorService.rush3 !== undefined &&
                                vendorService.rush3 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush3 || 0
                                );
                            }
                            break;
                        case "rush5":
                            if (
                                vendorService.rush5 !== undefined &&
                                vendorService.rush5 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush5 || 0
                                );
                            }
                            break;
                        case "rush7":
                            if (
                                vendorService.rush7 !== undefined &&
                                vendorService.rush7 !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush7 || 0
                                );
                            }
                            break;
                        case "rush_package":
                            if (
                                vendorService.rush_package !== undefined &&
                                vendorService.rush_package !== null
                            ) {
                                updatedPrice = parseFloat(
                                    vendorService.rush_package || 0
                                );
                            }
                            break;
                    }

                    if (updatedPrice !== null) {
                        // Use Vue.set to ensure reactivity
                        this.$set(
                            item.rush_fee_breakdown.services[index],
                            "retail_cost",
                            updatedPrice
                        );
                        // Rush options: rush_package is Per Order (multiply by 1), others (rush1, rush3, rush5, rush7) are Per Item (multiply by quantity)
                        let serviceTotal = updatedPrice;
                        if (service.service_id === "rush_package") {
                            // Rush Package: multiply by 1 (fixed price)
                            serviceTotal = updatedPrice * 1;
                        } else {
                            // Other rush options (rush1, rush3, rush5, rush7): multiply by quantity
                            serviceTotal = updatedPrice * currentQuantity;
                        }
                        this.$set(
                            item.rush_fee_breakdown.services[index],
                            "total",
                            serviceTotal
                        );
                    }
                } else {
                    // Update other rush fee services by matching service_id
                    if (service.service_id) {
                        const matchingVendorService = vendorServices.find(
                            (vs) => vs.id === service.service_id
                        );
                        if (
                            matchingVendorService &&
                            matchingVendorService.retail_cost !== undefined
                        ) {
                            const updatedRetailCost = parseFloat(
                                matchingVendorService.retail_cost || 0
                            );

                            // Use Vue.set to ensure reactivity
                            this.$set(
                                item.rush_fee_breakdown.services[index],
                                "retail_cost",
                                updatedRetailCost
                            );

                            // Recalculate total based on fee_structure
                            const isPerItem =
                                service.fee_structure === "Per Item" ||
                                service.fee_structure === 6 ||
                                service.fee_structure === "6";

                            let serviceTotal;
                            if (isPerItem) {
                                // Per Item: multiply by current quantity
                                serviceTotal = parseFloat(
                                    (
                                        updatedRetailCost * currentQuantity
                                    ).toFixed(2)
                                );
                            } else {
                                // Per Order: use price as-is
                                serviceTotal = parseFloat(
                                    updatedRetailCost.toFixed(2)
                                );
                            }
                            this.$set(
                                item.rush_fee_breakdown.services[index],
                                "total",
                                serviceTotal
                            );
                        }
                    }
                }
            });

            // Recalculate total for rush_fee_breakdown (this will be recalculated in getRushFeeTotal, but update stored value too)
            // Note: getRushFeeTotal will recalculate based on current quantity, so this is just for reference
            let total = 0;
            item.rush_fee_breakdown.services.forEach((service) => {
                const servicePrice = parseFloat(service.retail_cost || 0);
                if (servicePrice > 0) {
                    if (service.is_rush_option === true) {
                        // Rush options: rush_package is Per Order (multiply by 1), others (rush1, rush3, rush5, rush7) are Per Item (multiply by quantity)
                        if (service.service_id === "rush_package") {
                            // Rush Package: multiply by 1 (fixed price)
                            total += servicePrice * 1;
                        } else {
                            // Other rush options (rush1, rush3, rush5, rush7): multiply by quantity
                            total += servicePrice * currentQuantity;
                        }
                    } else {
                        // Other services depend on fee_structure
                        const isPerItem =
                            service.fee_structure === "Per Item" ||
                            service.fee_structure === 6 ||
                            service.fee_structure === "6";
                        total += isPerItem
                            ? servicePrice * currentQuantity
                            : servicePrice;
                    }
                }
            });
            this.$set(
                item.rush_fee_breakdown,
                "total",
                parseFloat(total.toFixed(2))
            );
        },

        getCart() {
            var _this = this;
            if (_this.isAuthenticatedClient) {
                new Promise(() => {
                    ApiService.get("/cart-new")
                        .then(async ({ data }) => {
                            if (data.success == false) {
                                _this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                });
                                _this.isBusy = false;
                                _this.$parent.isLoader = false;
                                return false;
                            }
                            // Process and group items (same logic as Cart.vue)
                            let cart_items = [];
                            let front_art_url;

                            data.cart_items.forEach((item) => {
                                // Preserve saved_design_id (important for order placement)
                                const saved_design_id = item.saved_design_id;

                                // Parse JSON fields - support both array (legacy) and object { front, back, left, right }
                                item.name_and_number_json =
                                    item.name_and_number_json
                                        ? JSON.parse(item.name_and_number_json)
                                        : [];
                                if (Array.isArray(item.name_and_number_json)) {
                                    item.name_and_number_json =
                                        item.name_and_number_json.filter(
                                            (nn) => nn.name != "" || nn.number
                                        );
                                } else if (
                                    item.name_and_number_json &&
                                    typeof item.name_and_number_json ===
                                        "object"
                                ) {
                                    ["front", "back", "left", "right"].forEach(
                                        (key) => {
                                            if (
                                                !Array.isArray(
                                                    item.name_and_number_json[
                                                        key
                                                    ]
                                                )
                                            ) {
                                                item.name_and_number_json[key] =
                                                    [];
                                            }
                                        }
                                    );
                                }

                                item.design_images = item.design_image
                                    ? JSON.parse(item.design_image)
                                    : [];

                                if (item.design_images.length > 0) {
                                    item.design_image = JSON.parse(
                                        item.design_image
                                    )[0]["url"];
                                }

                                item.front_art_url = "";
                                if (item.design_images.length > 0) {
                                    if (
                                        front_art_url !=
                                        item.design_images[0].design_image
                                    ) {
                                        item.front_art_url =
                                            item.design_images[0].design_image;
                                        front_art_url = item.front_art_url;
                                    }
                                }

                                item.non_standard_colors =
                                    item.non_standard_colors
                                        ? JSON.parse(item.non_standard_colors)
                                        : [];
                                item.decoration_colors = item.decoration_colors
                                    ? JSON.parse(item.decoration_colors)
                                    : [];
                                item.item_prices = item.item_prices
                                    ? JSON.parse(item.item_prices)
                                    : [];
                                item.location_decoration_colors =
                                    item.location_decoration_colors
                                        ? JSON.parse(
                                              item.location_decoration_colors
                                          )
                                        : [];
                                item.imprint_locations = item.imprint_locations
                                    ? JSON.parse(item.imprint_locations)
                                    : [];

                                // Parse decoration and setup_fees_details if they are strings
                                if (item.decoration) {
                                    item.decoration =
                                        typeof item.decoration === "string"
                                            ? JSON.parse(item.decoration)
                                            : item.decoration;
                                }
                                if (item.setup_fees_details) {
                                    item.setup_fees_details =
                                        typeof item.setup_fees_details ===
                                        "string"
                                            ? JSON.parse(
                                                  item.setup_fees_details
                                              )
                                            : item.setup_fees_details;
                                }
                                // Only normalize setup fee details for PCNA (decoration_type 0).
                                // For other decoration types, keep payload values as-is.
                                if (
                                    item.setup_fees_details &&
                                    item.decoration_type == 0
                                ) {
                                    const decorationData = item.decoration || {};
                                    const setupMaster =
                                        decorationData.product_master_service ||
                                        {};
                                    const setupFeeColor1 = parseFloat(
                                        setupMaster.setup_fee_color1 || 0
                                    );
                                    const setupFeeMulticolor = parseFloat(
                                        setupMaster.setup_fee_multicolor || 0
                                    );
                                    const feeStructure =
                                        parseInt(setupMaster.fee_structure) || 1;

                                    if (
                                        (setupFeeColor1 > 0 ||
                                            setupFeeMulticolor > 0) &&
                                        item.setup_fees_details.locations &&
                                        Array.isArray(
                                            item.setup_fees_details.locations
                                        )
                                    ) {
                                        let setupTotal = 0;
                                        item.setup_fees_details.locations =
                                            item.setup_fees_details.locations.map(
                                                (location) => {
                                                    const qty =
                                                        parseInt(
                                                            location.quantity
                                                        ) || 1;
                                                    const isFullColor =
                                                        location.is_full_color ===
                                                            true ||
                                                        /full\s*color/i.test(
                                                            String(
                                                                location.name ||
                                                                    ""
                                                            )
                                                        );
                                                    let perPrice = 0;
                                                    let total = 0;

                                                    if (feeStructure === 1) {
                                                        perPrice =
                                                            setupFeeColor1;
                                                        total = perPrice * qty;
                                                    } else {
                                                        perPrice =
                                                            isFullColor ||
                                                            qty > 1
                                                                ? setupFeeMulticolor
                                                                : setupFeeColor1;
                                                        total = perPrice;
                                                        location.quantity = 1;
                                                    }

                                                    setupTotal += total;
                                                    return {
                                                        ...location,
                                                        per_price: perPrice,
                                                        total: total
                                                    };
                                                }
                                            );
                                        item.setup_fees_details.total = setupTotal;
                                    }
                                }

                                // Parse rush_fee_breakdown if it's a string
                                if (item.rush_fee_breakdown) {
                                    try {
                                        item.rush_fee_breakdown =
                                            typeof item.rush_fee_breakdown ===
                                            "string"
                                                ? JSON.parse(
                                                      item.rush_fee_breakdown
                                                  )
                                                : item.rush_fee_breakdown;
                                    } catch (e) {
                                        console.error(
                                            "Error parsing rush_fee_breakdown:",
                                            e
                                        );
                                    }
                                }

                                // Initialize subItems array
                                item.subItems = [];

                                // Group items by item_id, decoration_type, decoration_price_template, and service (for decoration_type 0)
                                if (item.build_id) {
                                    // For build items, group by front_art_url
                                    let itemIndex = cart_items.findIndex(
                                        (element) =>
                                            element.front_art_url &&
                                            element.front_art_url.includes(
                                                front_art_url
                                            )
                                    );
                                    if (
                                        itemIndex >= 0 &&
                                        cart_items[itemIndex]
                                    ) {
                                        // Preserve saved_design_id when pushing to subItems
                                        item.saved_design_id = saved_design_id;
                                        cart_items[itemIndex].subItems.push(
                                            item
                                        );
                                    } else {
                                        // Preserve saved_design_id when pushing to cart_items
                                        item.saved_design_id = saved_design_id;
                                        cart_items.push(item);
                                    }
                                } else {
                                    // Assembly grouping first (match Cart.vue behavior)
                                    const assemblyKey = this.getAssemblyKey(item);
                                    if (assemblyKey) {
                                        const assemblyIndex = cart_items.findIndex(
                                            (element) => {
                                                if (element.build_id) return false;
                                                // Match by stored group_assembly_id when both items have it
                                                if (
                                                    item.group_assembly_id &&
                                                    element.group_assembly_id
                                                ) {
                                                    return (
                                                        element.group_assembly_id ===
                                                        item.group_assembly_id
                                                    );
                                                }
                                                // Fallback: match by computed assembly key
                                                return (
                                                    this.getAssemblyKey(element) ===
                                                    assemblyKey
                                                );
                                            }
                                        );

                                        if (
                                            assemblyIndex >= 0 &&
                                            cart_items[assemblyIndex]
                                        ) {
                                            item.saved_design_id = saved_design_id;
                                            cart_items[assemblyIndex].subItems.push(
                                                item
                                            );
                                        } else {
                                            item.saved_design_id = saved_design_id;
                                            cart_items.push(item);
                                        }
                                        return;
                                    }

                                    // Group by item_id AND service for visual grouping
                                    // Same product with same service shows together, different services show separately
                                    let itemIndex = cart_items.findIndex(
                                        (element) => {
                                            // Basic matching: item_id, decoration_type, decoration_price_template
                                            if (
                                                element.item_id !=
                                                    item.item_id ||
                                                element.decoration_type !=
                                                    item.decoration_type ||
                                                element.decoration_price_template !=
                                                    item.decoration_price_template
                                            ) {
                                                return false;
                                            }

                                            // For decoration type 0, also check master_service.id to identify the service
                                            if (item.decoration_type == 0) {
                                                let elementDecoration =
                                                    element.decoration;
                                                let itemDecoration =
                                                    item.decoration;

                                                // Parse if string
                                                if (
                                                    typeof elementDecoration ===
                                                    "string"
                                                ) {
                                                    try {
                                                        elementDecoration =
                                                            JSON.parse(
                                                                elementDecoration
                                                            );
                                                    } catch (e) {
                                                        elementDecoration = {};
                                                    }
                                                }
                                                if (
                                                    typeof itemDecoration ===
                                                    "string"
                                                ) {
                                                    try {
                                                        itemDecoration =
                                                            JSON.parse(
                                                                itemDecoration
                                                            );
                                                    } catch (e) {
                                                        itemDecoration = {};
                                                    }
                                                }

                                                const elementServiceId =
                                                    elementDecoration.master_service &&
                                                    elementDecoration
                                                        .master_service.id
                                                        ? elementDecoration
                                                              .master_service.id
                                                        : null;
                                                const itemServiceId =
                                                    itemDecoration.master_service &&
                                                    itemDecoration
                                                        .master_service.id
                                                        ? itemDecoration
                                                              .master_service.id
                                                        : null;

                                                // If both have service IDs, they must match
                                                if (
                                                    elementServiceId !== null &&
                                                    itemServiceId !== null
                                                ) {
                                                    return (
                                                        elementServiceId ==
                                                        itemServiceId
                                                    );
                                                }

                                                // If one has ID and other doesn't, they're different services
                                                if (
                                                    (elementServiceId !==
                                                        null) !==
                                                    (itemServiceId !== null)
                                                ) {
                                                    return false;
                                                }

                                                // If neither has ID, fall back to basic matching (already matched above)
                                                return true;
                                            }

                                            // For other decoration types, basic matching is sufficient
                                            return true;
                                        }
                                    );

                                    if (
                                        itemIndex >= 0 &&
                                        cart_items[itemIndex]
                                    ) {
                                        // Preserve saved_design_id when pushing to subItems
                                        item.saved_design_id = saved_design_id;
                                        cart_items[itemIndex].subItems.push(
                                            item
                                        );
                                    } else {
                                        // Preserve saved_design_id when pushing to cart_items
                                        item.saved_design_id = saved_design_id;
                                        cart_items.push(item);
                                    }
                                }
                            });

                            await _this.applyRealtimeTemplateFees(cart_items);
                            _this.cart_items = cart_items;
                            _this.total_quantity = data.total_quantity;
                            _this.grand_total = parseFloat(data.total_price);

                            // Enrich rush fee breakdowns with real-time vendor service prices (before preparing display data)
                            _this
                                .enrichRushFeeBreakdowns(cart_items)
                                .then(() => {
                                    // Prepare display data for each item (main items and subItems) after enrichment
                                    _this.prepareDisplayDataForItems();
                                })
                                .catch(() => {
                                    // If enrichment fails, still prepare display data
                                    _this.prepareDisplayDataForItems();
                                });
                            _this.$parent.order_data.total_non_standard_fees =
                                parseFloat(data.total_non_standard_fees_sp) +
                                parseFloat(data.total_non_standard_fees_emb);

                            // Update grand_total using calculatedGrandTotal (includes all fees)
                            // This will be triggered by the watcher, but we also set it here for immediate update
                            _this.$nextTick(() => {
                                const calculatedTotal =
                                    _this.calculatedGrandTotal;
                                if (_this.$parent && _this.$parent.order_data) {
                                    _this.$parent.order_data.grand_total =
                                        calculatedTotal;
                                    _this.$parent.order_data.order_price =
                                        calculatedTotal;
                                }
                            });
                            // Check processed cart_items array instead of data.cart_items
                            // This ensures cartNotEmpty is set correctly after processing/grouping
                            if (cart_items && cart_items.length > 0) {
                                localStorage.setItem("cartNotEmpty", true);
                                _this.cartNotEmpty = true;
                            } else {
                                localStorage.setItem("cartNotEmpty", false);
                                _this.cartNotEmpty = false;
                            }
                            _this.isBusy = false;
                            let total_non_standard_colors = [];
                            if (_this.cart_items.length > 0) {
                                let total_weight = 0;
                                let front_art_url;

                                // Helper function to process item (for both main items and subItems)
                                const processItem = (item) => {
                                    item.CartChildItems.forEach((size) => {
                                        if (size.quantity > 0) {
                                            total_weight =
                                                total_weight +
                                                parseFloat(
                                                    size.main_new_sub_product
                                                        .case_weight
                                                ) *
                                                    Number(size.quantity);
                                        }
                                    });

                                    // Process design_images if not already processed
                                    if (
                                        !item.design_images &&
                                        item.design_image
                                    ) {
                                        item.design_images = item.design_image;
                                        if (item.design_images) {
                                            try {
                                                const parsed = JSON.parse(
                                                    item.design_image
                                                );
                                                if (
                                                    parsed &&
                                                    parsed.length > 0
                                                ) {
                                                    item.design_image =
                                                        parsed[0]["url"];
                                                    if (
                                                        front_art_url !=
                                                        parsed[0].design_image
                                                    ) {
                                                        item.front_art_url =
                                                            parsed[0].design_image;
                                                        front_art_url =
                                                            item.front_art_url;
                                                    }
                                                }
                                            } catch (e) {
                                                console.error(
                                                    "Error parsing design_image:",
                                                    e
                                                );
                                            }
                                        }
                                    }

                                    // Process colors if not already processed
                                    if (!item.non_standard_colors_processed) {
                                        item.non_standard_colors =
                                            item.non_standard_colors
                                                ? typeof item.non_standard_colors ===
                                                  "string"
                                                    ? JSON.parse(
                                                          item.non_standard_colors
                                                      )
                                                    : item.non_standard_colors
                                                : [];
                                        item.decoration_colors =
                                            item.decoration_colors
                                                ? typeof item.decoration_colors ===
                                                  "string"
                                                    ? JSON.parse(
                                                          item.decoration_colors
                                                      )
                                                    : item.decoration_colors
                                                : [];
                                        item.non_standard_colors_processed = true;
                                    }

                                    total_non_standard_colors =
                                        total_non_standard_colors.concat(
                                            item.non_standard_colors || []
                                        );
                                    this.total_imprint_locations_price +=
                                        parseFloat(
                                            item.imprint_locations_price || 0
                                        );
                                    this.total_setup_fee += parseFloat(
                                        item.setup_fee || 0
                                    );
                                };

                                _this.cart_items.forEach((item) => {
                                    // Process main item
                                    processItem(item);

                                    // Process subItems if they exist
                                    if (
                                        item.subItems &&
                                        item.subItems.length > 0
                                    ) {
                                        item.subItems.forEach((subItem) => {
                                            processItem(subItem);
                                        });
                                    }
                                });
                                _this.$parent.total_weight_in_lbs =
                                    total_weight.toFixed(2);
                                _this.total_non_standard_colors = [
                                    ...new Set(total_non_standard_colors)
                                ];
                            }
                            // Removed total_imprint_locations_price and total_setup_fee from order_price
                            // because they are already included in cartSubTotal (via item subtotals)
                            // _this.$parent.order_data.order_price+=this.total_imprint_locations_price+ this.total_setup_fee;

                            // Fetch live services for all decorators
                            _this.fetchLiveServicesForDecorators();

                            _this.$parent.isLoader = false;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                            _this.$parent.isLoader = false;
                        });
                });
            }
        },

        // Get unique decorator IDs from all cart items
        getUniqueDecoratorIds() {
            const decoratorIds = new Set();

            if (!this.cart_items || this.cart_items.length === 0) {
                return [];
            }

            this.cart_items.forEach((item) => {
                // Check main item
                if (item.main_new_product) {
                    const decoratorId =
                        item.main_new_product.default_decorator_id;
                    if (decoratorId) {
                        decoratorIds.add(decoratorId);
                    }
                }

                // Check subItems
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        if (subItem.main_new_product) {
                            const decoratorId =
                                subItem.main_new_product.default_decorator_id;
                            if (decoratorId) {
                                decoratorIds.add(decoratorId);
                            }
                        }
                    });
                }
            });

            return Array.from(decoratorIds);
        },

        // Fetch live services for all unique decorators
        async fetchLiveServicesForDecorators() {
            const decoratorIds = this.getUniqueDecoratorIds();

            if (decoratorIds.length === 0) {
                return;
            }

            // Reset live services
            this.liveServicesByDecorator = {};

            // Fetch services for each decorator
            const fetchPromises = decoratorIds.map(async (decoratorId) => {
                try {
                    const response = await ApiService.get(
                        `/vendor-services/${decoratorId}/other-services`
                    );
                    if (response.data && response.data.success !== false) {
                        this.liveServicesByDecorator[decoratorId] =
                            response.data.services || [];
                    }
                } catch (error) {
                    console.error(
                        `Error fetching services for decorator ${decoratorId}:`,
                        error
                    );
                }
            });

            await Promise.all(fetchPromises);
        },

        // Get live services for a specific item (with duplicate check)
        getLiveOtherServicesForItem(item) {
            if (!item || !item.main_new_product) {
                return [];
            }

            const decoratorId = item.main_new_product.default_decorator_id;
            if (!decoratorId || !this.liveServicesByDecorator[decoratorId]) {
                return [];
            }

            const liveServices = this.liveServicesByDecorator[decoratorId];

            // Parse decoration to get existing services
            let decoration = item.decoration;
            if (decoration && typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    decoration = null;
                }
            }

            const existingServices =
                decoration && decoration.other_services_list
                    ? decoration.other_services_list
                    : [];

            // Filter out services that already exist in decoration.other_services_list
            // Check by service_id (master_service_id) to avoid duplicates
            const existingServiceIds = new Set();
            existingServices.forEach((service) => {
                const serviceId =
                    service.service_id ||
                    service.master_service_id ||
                    service.id;
                if (serviceId) {
                    existingServiceIds.add(serviceId);
                }
            });

            // Return only services that don't exist in decoration
            return liveServices.filter((service) => {
                const serviceId =
                    service.service_id ||
                    service.master_service_id ||
                    service.id;
                return !existingServiceIds.has(serviceId);
            });
        },

        hasLimit(item, index) {
            if (!item.is_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },

        // Cart page registers window.CartV3Component; checkout has no Cart child — use fallbacks below.
        resolveCartVueComponent() {
            if (typeof window !== "undefined" && window.CartV3Component) {
                return window.CartV3Component;
            }
            if (this.$root && this.$root.$children) {
                return this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" ||
                        comp.$options.name === "shopping-cart" ||
                        comp.getCombinedColorMixFeeTotal ||
                        comp.getItemSubTotal
                );
            }
            return null;
        },
        getRollupFeeIdFromService(service) {
            if (!service) return null;
            const rollupService = service.rollup_service || {};
            const id =
                rollupService.rollup_fee_id !== undefined &&
                rollupService.rollup_fee_id !== null
                    ? rollupService.rollup_fee_id
                    : service.rollup_fee_id !== undefined &&
                      service.rollup_fee_id !== null
                    ? service.rollup_fee_id
                    : null;
            return id;
        },
        getNormalizedColorTypeFromDecoration(decoration) {
            if (!decoration || typeof decoration !== "object") return "";
            const rawColorType =
                (decoration.master_service &&
                    decoration.master_service.color_type) ||
                decoration.color_type ||
                "";
            return String(rawColorType).toLowerCase().trim();
        },
        getItemColorType(item) {
            if (!item) return "";
            let decoration = item.decoration;
            if (decoration && typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return "";
                }
            }
            return this.getNormalizedColorTypeFromDecoration(decoration);
        },
        getColorMixFeeServicesFromItem(item) {
            if (!item) return [];
            const colorType = this.getItemColorType(item);
            const isSupportedColorType =
                colorType === "thread" || colorType === "ink";
            if (!isSupportedColorType) return [];
            let decoration = item.decoration;
            if (decoration && typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return [];
                }
            }
            if (
                !decoration ||
                !decoration.other_services_list ||
                !Array.isArray(decoration.other_services_list)
            ) {
                return [];
            }
            return decoration.other_services_list.filter((service) => {
                const serviceFeeId = this.getRollupFeeIdFromService(service);
                return serviceFeeId === 13 || serviceFeeId === "13";
            });
        },
        isPrimaryCustomColorRollupService(service) {
            if (!service) return false;
            const t = (service.type || "").toLowerCase();
            if (t === "thread_fee" || t === "custom_ink_mix") return true;
            const name = (
                service.name ||
                service.service_name ||
                service.ecomm_display ||
                (service.rollup_service &&
                    (service.rollup_service.name ||
                        service.rollup_service.service_name ||
                        service.rollup_service.ecomm_display)) ||
                ""
            ).toLowerCase();
            if (name.includes("thread mix") || name.includes("ink mix"))
                return true;
            if (name.includes("color thread") || name.includes("color ink"))
                return true;
            if (
                name.includes("thread fee") &&
                (name.includes("color") || name.includes("custom"))
            )
                return true;
            if (
                name.includes("ink fee") &&
                (name.includes("color") || name.includes("custom"))
            )
                return true;
            return false;
        },
        getOtherColorMixFeeServicesFromItem(item) {
            return this.getColorMixFeeServicesFromItem(item).filter(
                (s) => !this.isPrimaryCustomColorRollupService(s)
            );
        },
        getOtherColorMixFeeRollupTotalFromItem(item) {
            let total = 0;
            const services = this.getOtherColorMixFeeServicesFromItem(item);
            if (!services || services.length === 0) return 0;
            const quantity = this.getTotalItemQuantity(item);
            services.forEach((service) => {
                const servicePrice =
                    service.retail_cost || service.net_cost || 0;
                if (service.fee_structure === "Per Item") {
                    total += parseFloat(servicePrice) * quantity;
                } else {
                    total += parseFloat(servicePrice);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        getAssemblyDecorationServiceId(item) {
            if (!item) return null;
            let decoration = item.decoration;
            if (decoration) {
                if (typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        decoration = null;
                    }
                }
                if (decoration) {
                    if (decoration.id) return String(decoration.id);
                    const masterService = decoration.master_service || null;
                    if (masterService && masterService.id)
                        return String(masterService.id);
                }
            }
            if (item.decoration_type != null && item.decoration_type !== "") {
                return `type_${item.decoration_type}`;
            }
            return null;
        },
        getAssemblyDecoratorId(item) {
            if (!item || !item.main_new_product) return null;
            const decoratorId = item.main_new_product.default_decorator_id;
            return decoratorId !== undefined &&
                decoratorId !== null &&
                decoratorId !== ""
                ? String(decoratorId)
                : null;
        },
        getAssemblyVendorId(item) {
            if (!item || !item.main_new_product) return null;
            const product = item.main_new_product;
            const vendorId =
                product.vendor_id ||
                product.default_vendor_id ||
                (product.Vendor && product.Vendor.id) ||
                (product.vendor && product.vendor.id) ||
                product.default_decorator_id ||
                null;
            return vendorId !== undefined &&
                vendorId !== null &&
                vendorId !== ""
                ? String(vendorId)
                : null;
        },
        getAssemblyKey(item) {
            if (!item) return null;
            if (
                item.group_assembly_id &&
                item.group_assembly_id !== "null" &&
                item.group_assembly_id !== "undefined"
            ) {
                return item.group_assembly_id;
            }
            const savedDesignId = item.saved_design_id;
            if (
                savedDesignId === undefined ||
                savedDesignId === null ||
                savedDesignId === "" ||
                savedDesignId === "null" ||
                savedDesignId === "undefined"
            ) {
                return null;
            }
            const serviceId = this.getAssemblyDecorationServiceId(item);
            if (!serviceId) return null;
            const decoratorId = this.getAssemblyDecoratorId(item) || "x";
            const vendorId = this.getAssemblyVendorId(item) || "x";
            return [
                String(savedDesignId),
                serviceId,
                decoratorId,
                vendorId
            ].join("|");
        },
        isAssemblyGroup(item) {
            if (!item || !item.subItems || item.subItems.length === 0) {
                return false;
            }
            if (
                item.group_assembly_id &&
                item.group_assembly_id !== "null" &&
                item.group_assembly_id !== "undefined"
            ) {
                return item.subItems.some(
                    (s) => s.group_assembly_id === item.group_assembly_id
                );
            }
            const assemblyKey = this.getAssemblyKey(item);
            if (!assemblyKey) return false;
            return item.subItems.some(
                (subItem) => this.getAssemblyKey(subItem) === assemblyKey
            );
        },
        getAssemblyGroupedItems(item) {
            if (!item) return [];
            if (!item.subItems || item.subItems.length === 0) return [item];
            return [item, ...item.subItems];
        },
        getTierQuantityForItem(item, parentItem = null) {
            return resolveTierQuantityForItem(item, parentItem, {
                getTotalItemQuantity: this.getTotalItemQuantity.bind(this),
                isAssemblyGroup: this.isAssemblyGroup.bind(this),
                getAssemblyGroupedItems: this.getAssemblyGroupedItems.bind(this)
            });
        },
        getEffectivePriceDecorationBulk(item) {
            if (!item) return null;
            let decoration = item.decoration;
            if (decoration && typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    decoration = null;
                }
            }

            let bulk =
                (decoration && decoration.price_decoration_bulk) ||
                item.price_decoration_bulk ||
                (item.main_new_product && item.main_new_product.price_decoration_bulk) ||
                null;

            if (typeof bulk === "string") {
                try {
                    bulk = JSON.parse(bulk);
                } catch (e) {
                    bulk = null;
                }
            }

            return bulk;
        },

        // Get prepared display data for cart item
        // parentItem: set when computing a subItem under a grouped parent (checkout / summary parity with Cart.vue)
        getItemDisplayData(item, parentItem = null) {
            if (!item) return null;

            // Try to get prepared data from Cart.vue if available
            if (this.$root && this.$root.$children) {
                const cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" ||
                        comp.getCartItemDisplayData
                );
                if (cartComponent && cartComponent.getCartItemDisplayData) {
                    return cartComponent.getCartItemDisplayData(item);
                }
            }

            // Otherwise, prepare basic data from item properties
            // Get quantity from Cart component first, then fallback to local calculation
            let quantity = 0;
            if (this.$root && this.$root.$children) {
                const cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" ||
                        comp.getTotalItemQuantity
                );
                if (cartComponent && cartComponent.getTotalItemQuantity) {
                    quantity = cartComponent.getTotalItemQuantity(item);
                }
            }
            // Fallback to local calculation
            if (quantity === 0 || quantity === undefined || quantity === null) {
                quantity = this.getTotalItemQuantity(item);
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (decoration && typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error("Error parsing decoration:", e);
                    decoration = null;
                }
            }

            // Get services from decoration
            const otherServices =
                decoration && decoration.other_services_list
                    ? decoration.other_services_list
                    : [];
            const baseFeeServices = otherServices.filter(
                (s) => s.rollup_fee_id === 1 || s.rollup_fee_id === "1"
            );
            const runChargeServices = otherServices.filter(
                (s) => s.rollup_fee_id === 12 || s.rollup_fee_id === "12"
            );
            let colorMixFeeServices = this.getColorMixFeeServicesFromItem(
                item
            );
            const setupFeeServices = otherServices.filter(
                (s) => s.rollup_fee_id === 2 || s.rollup_fee_id === "2"
            );

            const isSubItemOfGroup =
                parentItem &&
                this.isGroupedDecorationType0(parentItem) &&
                (parentItem.subItems || []).some(
                    (s) => String(s.id) === String(item.id)
                );

            let colorMixFeeData = this.getColorMixFeeData(item);
            if (isSubItemOfGroup) {
                colorMixFeeData = null;
                if (parentItem && this.isAssemblyGroup(parentItem)) {
                    colorMixFeeServices =
                        this.getOtherColorMixFeeServicesFromItem(item);
                } else {
                    colorMixFeeServices = [];
                }
            }

            // Calculate color mix fee data and total
            const colorMixFeeTotal = this.getColorMixFeeTotal(
                item,
                colorMixFeeData,
                colorMixFeeServices,
                quantity
            );

            // Calculate run charge breakdown and total
            const runChargeBreakdown = this.getRunChargeBreakdown(
                item,
                parentItem
            );
            const runChargeTotal = this.getRunChargeTotalFromBreakdown(
                item,
                runChargeBreakdown,
                runChargeServices,
                quantity
            );

            // Calculate setup fee total (matching tooltip logic)
            const setupFeeTotal = this.getSetupFeeTotalFromDetails(
                item.setup_fees_details,
                setupFeeServices,
                quantity
            );

            // Calculate rush fee total (try from Cart component first, otherwise calculate locally)
            let rushFeeTotal = 0;
            if (item.rush_fee_breakdown) {
                // Try to get from Cart component first
                if (this.$root && this.$root.$children) {
                    const cartComponent = this.$root.$children.find(
                        (comp) =>
                            comp.$options.name === "CartV3" ||
                            comp.getRushFeeTotal
                    );
                    if (cartComponent && cartComponent.getRushFeeTotal) {
                        rushFeeTotal = parseFloat(
                            cartComponent.getRushFeeTotal(item) || 0
                        );
                    }
                }

                // Fallback: calculate locally using same logic as Cart.vue
                if (
                    rushFeeTotal === 0 &&
                    item.rush_fee_breakdown &&
                    item.rush_fee_breakdown.services
                ) {
                    item.rush_fee_breakdown.services.forEach((service) => {
                        const servicePrice = parseFloat(
                            service.retail_cost || 0
                        );

                        if (servicePrice > 0) {
                            // Rush options: rush_package is Per Order (multiply by 1), others (rush1, rush3, rush5, rush7) are Per Item (multiply by quantity)
                            if (service.is_rush_option === true) {
                                // Check if it's rush_package or other rush options
                                if (service.service_id === "rush_package") {
                                    // Rush Package: multiply by 1 (fixed price)
                                    rushFeeTotal += servicePrice * 1;
                                } else {
                                    // Other rush options (rush1, rush3, rush5, rush7): multiply by quantity
                                    rushFeeTotal += servicePrice * quantity;
                                }
                            } else {
                                // For other rush fee services, check fee_structure
                                const isPerItem =
                                    service.fee_structure === "Per Item" ||
                                    service.fee_structure === 6 ||
                                    service.fee_structure === "6";

                                if (isPerItem) {
                                    // Per Item: multiply by current quantity
                                    rushFeeTotal += servicePrice * quantity;
                                } else {
                                    // Per Order: use price as-is
                                    rushFeeTotal += servicePrice;
                                }
                            }
                        }
                    });
                    rushFeeTotal = parseFloat(rushFeeTotal.toFixed(2));
                }
            }

            // Get color-size combinations (try from Cart component first, otherwise calculate)
            let colorSizeCombinations = [];
            if (this.$root && this.$root.$children) {
                const cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" ||
                        comp.getColorSizeCombinations
                );
                if (cartComponent && cartComponent.getColorSizeCombinations) {
                    colorSizeCombinations =
                        cartComponent.getColorSizeCombinations(
                            item,
                            parentItem
                        );
                }
            }
            // If not available from Cart component, use simplified version
            if (!colorSizeCombinations || colorSizeCombinations.length === 0) {
                colorSizeCombinations = this.getColorSizeCombinations(
                    item,
                    parentItem
                );
            }

            // For decoration type 1 and 2, add included services unit price to each combination's cost
            // This matches Cart.vue logic where included services are added per item
            // IMPORTANT: Always add included services to combinations, regardless of where they come from
            // (Cart.vue's getColorSizeCombinations doesn't include them, so we need to add them here)
            if (
                (item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) &&
                colorSizeCombinations &&
                colorSizeCombinations.length > 0
            ) {
                // Get baseFeeServices - use same logic as Cart.vue
                let servicesToUse = baseFeeServices;
                if (!servicesToUse || servicesToUse.length === 0) {
                    // Fallback: get from decoration if not already filtered
                    const otherServices =
                        decoration && decoration.other_services_list
                            ? decoration.other_services_list
                            : [];
                    servicesToUse = otherServices.filter(
                        (s) => s.rollup_fee_id === 1 || s.rollup_fee_id === "1"
                    );
                }

                if (servicesToUse && servicesToUse.length > 0) {
                    // Calculate included services unit price (show_service = false)
                    let includedServicesUnitPrice = 0;
                    servicesToUse.forEach((service) => {
                        // Check if show_service is false (included services)
                        const showService =
                            service.show_service !== undefined
                                ? service.show_service
                                : true;
                        if (!showService) {
                            const serviceUnitPrice = parseFloat(
                                service.retail_cost || service.net_cost || 0
                            );
                            includedServicesUnitPrice += serviceUnitPrice;
                        }
                    });

                    // Add included services unit price to each combination's cost
                    if (includedServicesUnitPrice > 0) {
                        colorSizeCombinations = colorSizeCombinations.map(
                            (combination) => {
                                // Only add if not already included (check flag)
                                if (
                                    combination._includesIncludedServices !==
                                    true
                                ) {
                                    const updatedCost =
                                        parseFloat(combination.cost || 0) +
                                        includedServicesUnitPrice;
                                    return {
                                        ...combination,
                                        cost: updatedCost,
                                        total_cost:
                                            updatedCost *
                                            parseInt(combination.quantity || 0),
                                        _includesIncludedServices: true // Flag to indicate included services are already added
                                    };
                                }
                                return combination;
                            }
                        );
                    }
                }
            }

            // Get baseFeeTotal directly from Cart component
            // This ensures it's always in sync with Cart component's calculation
            // Try multiple ways to access Cart component
            let baseFeeTotal = 0;
            let cartComponent = null;

            // Method 1: Try window.CartV3Component (stored globally by Cart component)
            if (typeof window !== "undefined" && window.CartV3Component) {
                cartComponent = window.CartV3Component;
            }

            // Method 2: Try $root.$children (if on same page)
            if (!cartComponent && this.$root && this.$root.$children) {
                cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" ||
                        comp.$options.name === "shopping-cart" ||
                        comp.getBaseFeeTotal
                );
            }

            if (cartComponent && cartComponent.getBaseFeeTotal) {
                baseFeeTotal = parseFloat(
                    cartComponent.getBaseFeeTotal(item, parentItem) || 0
                );
            }

            // Fallback: Calculate locally if Cart component not available
            if (baseFeeTotal === 0) {
                if (colorSizeCombinations && colorSizeCombinations.length > 0) {
                    // Sum up all color-size combination totals
                    colorSizeCombinations.forEach((combination) => {
                        const cost = parseFloat(
                            (parseFloat(combination.cost || 0) || 0).toFixed(2)
                        );
                        const qty = parseInt(combination.quantity || 0);
                        baseFeeTotal += cost * qty;
                    });

                    // Get included services (show_service = false) unit price
                    let includedServicesUnitPrice = 0;
                    if (baseFeeServices && baseFeeServices.length > 0) {
                        baseFeeServices.forEach((service) => {
                            if (!service.show_service) {
                                // Included services: add unit price directly
                                const serviceUnitPrice = parseFloat(
                                    service.retail_cost || service.net_cost || 0
                                );
                                includedServicesUnitPrice += serviceUnitPrice;
                            }
                        });
                    }

                    // Add included services total: unit price × quantity
                    baseFeeTotal += includedServicesUnitPrice * quantity;

                    // Add other services (show_service = true)
                    if (baseFeeServices && baseFeeServices.length > 0) {
                        baseFeeServices.forEach((service) => {
                            if (service.show_service) {
                                const servicePrice =
                                    service.retail_cost ||
                                    service.net_cost ||
                                    0;
                                if (service.fee_structure === "Per Item") {
                                    baseFeeTotal +=
                                        parseFloat(servicePrice) * quantity;
                                } else {
                                    baseFeeTotal += parseFloat(servicePrice);
                                }
                            }
                        });
                    }

                    baseFeeTotal = parseFloat(baseFeeTotal.toFixed(2));
                } else {
                    // Final fallback: Use subtotal_price if no color-size combinations
                    baseFeeTotal = parseFloat(item.subtotal_price || 0);
                }
            }

            // Generate custom color breakdown (includes services) - AFTER all calculations
            const customColorBreakdown = this.getCustomColorBreakdown(
                item,
                colorMixFeeData,
                colorMixFeeServices,
                quantity
            );

            // Generate base fee breakdown (includes color-size combinations + services) - AFTER all calculations
            const baseFeeBreakdown = this.getBaseFeeBreakdown(
                item,
                colorSizeCombinations,
                baseFeeServices,
                quantity,
                baseFeeTotal > 0 && quantity > 0 ? baseFeeTotal / quantity : 0
            );

            // Calculate item subtotal
            // For grouped decoration type 0, 1, and 2 items, exclude individual color mix fee (will be shown separately as combined)
            // This matches Cart.vue's getItemSubTotal logic
            let itemSubTotal = 0;

            // Grouped parent OR subItem under a grouped parent: exclude rolled-up color mix (matches Cart.vue)
            if (
                (item.decoration_type === 0 ||
                    item.decoration_type === 1 ||
                    item.decoration_type === 2 ||
                    item.decoration_type === 4) &&
                (this.isGroupedDecorationType0(item) || isSubItemOfGroup)
            ) {
                itemSubTotal =
                    baseFeeTotal +
                    runChargeTotal +
                    setupFeeTotal +
                    rushFeeTotal;

                itemSubTotal += this.getDynamicPatchCostTotal(item);

                // Add Name/Number fees (only for decoration type 1 and 2, as type 0 includes them in run charge)
                if (item.decoration_type != 0) {
                    const itemPrices = item.item_prices || {};
                    itemSubTotal +=
                        parseFloat(itemPrices.front_number_fees || 0) +
                        parseFloat(itemPrices.back_name_fees || 0) +
                        parseFloat(itemPrices.back_number_fees || 0) +
                        parseFloat(itemPrices.front_name_fees || 0) +
                        parseFloat(itemPrices.front_number_decor_up_fees || 0) +
                        parseFloat(itemPrices.back_name_decor_up_fees || 0) +
                        parseFloat(itemPrices.back_number_decor_up_fees || 0);
                }

                if (
                    isSubItemOfGroup &&
                    parentItem &&
                    this.isAssemblyGroup(parentItem)
                ) {
                    itemSubTotal += this.getOtherColorMixFeeRollupTotalFromItem(
                        item
                    );
                }

                // For grouped parent rows, include combined color mix fee once.
                // Sub-items stay color-mix-excluded to avoid duplication.
                if (this.isGroupedDecorationType0(item) && !isSubItemOfGroup) {
                    itemSubTotal += this.getCombinedColorMixFeeTotal(item);
                }
            } else {
                // For single items or non-grouped items, include all fees
                itemSubTotal =
                    baseFeeTotal +
                    runChargeTotal +
                    colorMixFeeTotal +
                    setupFeeTotal +
                    rushFeeTotal;

                itemSubTotal += this.getDynamicPatchCostTotal(item);

                // Add Name/Number fees (only for decoration type 1 and 2, as type 0 includes them in run charge)
                if (item.decoration_type != 0) {
                    const itemPrices = item.item_prices || {};
                    itemSubTotal +=
                        parseFloat(itemPrices.front_number_fees || 0) +
                        parseFloat(itemPrices.back_name_fees || 0) +
                        parseFloat(itemPrices.back_number_fees || 0) +
                        parseFloat(itemPrices.front_name_fees || 0) +
                        parseFloat(itemPrices.front_number_decor_up_fees || 0) +
                        parseFloat(itemPrices.back_name_decor_up_fees || 0) +
                        parseFloat(itemPrices.back_number_decor_up_fees || 0);
                }
            }

            // Item discount - use getItemDiscount method which has full calculation logic
            // Note: We can't call this.getItemDiscount here because it might cause circular dependency
            // So we'll calculate discount directly or use the method after it's defined
            let itemDiscount = 0;

            // Try to get from Cart component first (uses product discount calculation)
            if (this.$root && this.$root.$children) {
                const cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" || comp.getItemDiscount
                );
                if (cartComponent && cartComponent.getItemDiscount) {
                    itemDiscount = parseFloat(
                        cartComponent.getItemDiscount(item) || 0
                    );
                }
            }

            // Discount calculation removed - no longer applying overall discount
            // Discount is now applied at size cost level
            itemDiscount = 0;

            // Item total (subtotal - no discount)
            const itemTotal = itemSubTotal;

            // Basic display data structure
            return {
                id: item.id,
                item_id: item.item_id,
                decoration_type: item.decoration_type,
                quantity: quantity,
                subtotal_price: item.subtotal_price || 0,

                // Base Fee
                baseFeeTotal: baseFeeTotal,
                baseUnitPrice:
                    item.subtotal_price && quantity > 0
                        ? parseFloat(item.subtotal_price) / quantity
                        : 0,
                baseFeeServices: baseFeeServices,
                colorSizeCombinations: colorSizeCombinations,
                baseFeeBreakdown: baseFeeBreakdown,

                // Run Charge
                runChargeBreakdown: runChargeBreakdown,
                runChargeTotal: runChargeTotal,
                runChargeServices: runChargeServices,

                // Color Mix Fee
                colorMixFeeData: colorMixFeeData,
                colorMixFeeTotal: colorMixFeeTotal,
                colorMixFeeServices: colorMixFeeServices,
                customColorBreakdown: customColorBreakdown,

                // Setup Fee
                setupFeeDetails:
                    item.setup_fees_details || null,
                setupFeeTotal: setupFeeTotal,
                setupFeeServices: setupFeeServices,

                // Rush Fee
                rushFeeBreakdown: item.rush_fee_breakdown || null,
                rushFeeTotal: rushFeeTotal,
                rushFeeServices:
                    item.rush_fee_breakdown && item.rush_fee_breakdown.services
                        ? item.rush_fee_breakdown.services
                        : [],

                // Item totals (calculated properly: base + run charge + color mix + setup + rush fee)
                itemSubTotal: itemSubTotal,
                itemDiscount: itemDiscount,
                itemTotal: itemTotal,

                // Decoration info
                decoration: decoration,
                masterService:
                    decoration && decoration.master_service
                        ? decoration.master_service
                        : null,

                hasFullColor: false
            };
        },

        // Get Color Mix Fee Data
        getColorMixFeeData(item) {
            if (!item || !item.decoration) return null;

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error("Error parsing decoration:", e);
                    return null;
                }
            }

            const colorType = this.getNormalizedColorTypeFromDecoration(
                decoration
            );
            const isThread = colorType === "thread";
            const isInk = colorType === "ink";
            if (!isThread && !isInk) return null;

            // Get fee per color - prioritize VendorFees (real-time) over decoration.color_mix_fee
            let feePerColor = 0;

            // First, try to get from VendorFees (real-time update from API)
            if (
                item.main_new_product &&
                item.main_new_product.VendorFees &&
                Array.isArray(item.main_new_product.VendorFees)
            ) {
                const vendorFees = item.main_new_product.VendorFees;
                let targetService = null;

                if (isThread) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("thread mix fee")))
                    );
                } else if (isInk) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("ink mix fee")))
                    );
                }

                if (targetService && targetService.retail_cost) {
                    feePerColor = parseFloat(targetService.retail_cost) || 0;
                }
            }

            // NO FALLBACK - Only use VendorFees with rollup_fee_id
            // If VendorFees not available or fee is 0, feePerColor remains 0

            if (!feePerColor || feePerColor <= 0) {
                return null;
            }

            // Get unique non-standard color count
            const mixColorCount = this.getUniqueNonStandardColors(item);

            // Calculate total
            const total = mixColorCount * feePerColor;

            // Determine fee label
            let feeLabel = "Custom Color Ink Fee";
            let breakdownLabel = "Custom Color Ink Fee";
            if (isThread) {
                feeLabel = "Custom Color Thread Fee";
                breakdownLabel = "Custom Color Thread Fee";
            }

            return {
                label: feeLabel,
                breakdownLabel: breakdownLabel,
                mixColorCount: mixColorCount,
                unitPrice: feePerColor,
                total: total
            };
        },

        // Get unique non-standard colors
        getUniqueNonStandardColors(item) {
            const uniqueColors = new Set();

            // For decoration type 1 and 2, use non_standard_colors array
            if (item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) {
                let nonStandardColors = item.non_standard_colors;
                if (typeof nonStandardColors === "string") {
                    try {
                        nonStandardColors = JSON.parse(nonStandardColors);
                    } catch (e) {
                        return 0;
                    }
                }

                if (nonStandardColors && Array.isArray(nonStandardColors)) {
                    nonStandardColors.forEach((colorHex) => {
                        if (colorHex && typeof colorHex === "string") {
                            const colorKey = colorHex.toLowerCase();
                            if (
                                colorKey &&
                                colorKey !== "#gggggg" &&
                                colorKey !== ""
                            ) {
                                uniqueColors.add(colorKey);
                            }
                        }
                    });
                }

                return uniqueColors.size;
            }

            // For decoration type 0, use imprint_locations
            let imprintLocations = item.imprint_locations;
            if (typeof imprintLocations === "string") {
                try {
                    imprintLocations = JSON.parse(imprintLocations);
                } catch (e) {
                    return 0;
                }
            }

            if (!imprintLocations || !Array.isArray(imprintLocations)) {
                return 0;
            }

            imprintLocations.forEach((location) => {
                if (
                    location &&
                    location.is_selected &&
                    location.colors &&
                    Array.isArray(location.colors)
                ) {
                    location.colors.forEach((colorObj) => {
                        if (colorObj && colorObj.color) {
                            const color = colorObj.color;
                            const colorId = parseInt(color.color_id || 0);

                            if (colorId === 0) {
                                const colorKey = (
                                    color.color_value ||
                                    color.hex ||
                                    ""
                                ).toLowerCase();
                                if (
                                    colorKey &&
                                    colorKey !== "#gggggg" &&
                                    colorKey !== ""
                                ) {
                                    uniqueColors.add(colorKey);
                                }
                            }
                        }
                    });
                }
            });

            return uniqueColors.size;
        },

        // Get Color Mix Fee Total
        getColorMixFeeTotal(
            item,
            colorMixFeeData,
            colorMixFeeServices,
            quantity
        ) {
            let total = 0;

            if (colorMixFeeData && colorMixFeeData.total > 0) {
                total += parseFloat(colorMixFeeData.total);
            }

            // Add services with rollup_fee_id = 13 (Color Mix Fee services)
            if (colorMixFeeServices && colorMixFeeServices.length > 0) {
                colorMixFeeServices.forEach((service) => {
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },

        // Get Custom Color Breakdown (includes services)
        getCustomColorBreakdown(
            item,
            colorMixFeeData,
            colorMixFeeServices,
            quantity
        ) {
            if (
                !item ||
                (item.decoration_type !== 0 &&
                    item.decoration_type !== 1 &&
                    item.decoration_type !== 2 &&
                    item.decoration_type !== 4)
            ) {
                return null;
            }

            const breakdown = [];

            // Add color mix fee data row if exists
            if (colorMixFeeData && colorMixFeeData.total > 0) {
                // Determine the correct label based on breakdownLabel (for grouped items) or label (for non-grouped)
                // breakdownLabel has the correct logic based on service name (Custom Color Ink Fee / Custom Color Thread Fee)
                let feeName = "Custom Color Fee";

                if (colorMixFeeData.breakdownLabel) {
                    // For grouped items, use breakdownLabel which has service-based logic
                    feeName = colorMixFeeData.breakdownLabel;
                } else if (colorMixFeeData.label) {
                    // For non-grouped items, label already has the correct logic
                    feeName = colorMixFeeData.label;
                } else {
                    // Fallback: determine based on item decoration_type and service
                    if (item.decoration_type === 2 || item.decoration_type === 4) {
                        feeName = "Custom Color Thread Fee";
                    } else if (
                        item.decoration_type === 1 ||
                        item.decoration_type === 5
                    ) {
                        feeName = "Custom Color Ink Fee";
                    } else if (item.decoration_type === 0) {
                        // Check service name for decoration type 0
                        const decoration = item.decoration;
                        let masterService = null;
                        if (decoration) {
                            try {
                                const parsedDecoration =
                                    typeof decoration === "string"
                                        ? JSON.parse(decoration)
                                        : decoration;
                                masterService =
                                    (parsedDecoration &&
                                        parsedDecoration.master_service) ||
                                    null;
                            } catch (e) {
                                // Ignore parse errors
                            }
                        }

                        if (masterService) {
                            const serviceName = (
                                masterService.name ||
                                masterService.service_name ||
                                ""
                            ).toLowerCase();
                            const isEmbroidery =
                                serviceName.includes("embroidery") ||
                                serviceName.includes("emb");
                            if (isEmbroidery) {
                                feeName = "Custom Color Thread Fee";
                            } else {
                                feeName = "Custom Color Ink Fee";
                            }
                        }
                    }
                }

                breakdown.push({
                    type: "colorMixFee",
                    name: feeName,
                    qty: colorMixFeeData.mixColorCount || 0,
                    amt: parseFloat(colorMixFeeData.unitPrice || 0).toFixed(2),
                    total: parseFloat(colorMixFeeData.total || 0).toFixed(2)
                });
            }

            // Add services with rollup_fee_id = 13 (Custom Color Fee services)
            if (colorMixFeeServices && colorMixFeeServices.length > 0) {
                colorMixFeeServices.forEach((service) => {
                    const servicePrice = parseFloat(
                        service.retail_cost || service.net_cost || 0
                    );
                    if (servicePrice > 0) {
                        let serviceQty = quantity;
                        let serviceAmt = servicePrice;
                        let serviceTotal = 0;

                        if (service.fee_structure === "Per Item") {
                            serviceTotal = servicePrice * quantity;
                        } else {
                            serviceQty = 1;
                            serviceTotal = servicePrice;
                        }

                        breakdown.push({
                            type: "service",
                            vendor_service_type: service.type || null,
                            name:
                                service.name ||
                                service.service_name ||
                                "Service",
                            qty: serviceQty,
                            amt: parseFloat(serviceAmt).toFixed(2),
                            total: parseFloat(serviceTotal).toFixed(2),
                            show_service:
                                service.show_service !== undefined
                                    ? service.show_service
                                    : true,
                            service_id: service.id || null
                        });
                    }
                });
            }

            return breakdown.length > 0 ? breakdown : null;
        },

        // Get Base Fee Breakdown (includes color-size combinations + services)
        getBaseFeeBreakdown(
            item,
            colorSizeCombinations,
            baseFeeServices,
            quantity,
            baseUnitPrice
        ) {
            if (!item) {
                return null;
            }

            const breakdown = [];

            // Add color-size combinations
            if (colorSizeCombinations && colorSizeCombinations.length > 0) {
                colorSizeCombinations.forEach((combination) => {
                    const size = combination.size || "N/A";
                    const colorName =
                        combination.color_name ||
                        combination.colorName ||
                        "N/A";
                    const colorValue =
                        combination.color_value ||
                        combination.color ||
                        "#000000";
                    const qty = parseInt(combination.quantity || 0);
                    const unitPrice = parseFloat(combination.cost || 0);
                    const totalPrice = unitPrice * qty;

                    breakdown.push({
                        type: "colorSize",
                        name: `Product Base Price - ${size}`,
                        color: colorName,
                        colorValue: colorValue,
                        qty: qty,
                        amt: parseFloat(unitPrice).toFixed(2),
                        total: parseFloat(totalPrice).toFixed(2)
                    });
                });
            } else if (baseUnitPrice > 0) {
                // Fallback: single base price if no color-size combinations
                breakdown.push({
                    type: "basePrice",
                    name: "Product Base Price",
                    qty: quantity,
                    amt: parseFloat(baseUnitPrice).toFixed(2),
                    total: parseFloat(baseUnitPrice * quantity).toFixed(2)
                });
            } else if (item.subtotal_price && item.subtotal_price > 0) {
                // Another fallback: use subtotal_price if available
                const fallbackUnitPrice =
                    quantity > 0
                        ? parseFloat(item.subtotal_price) / quantity
                        : 0;
                if (fallbackUnitPrice > 0) {
                    breakdown.push({
                        type: "basePrice",
                        name: "Product Base Price",
                        qty: quantity,
                        amt: parseFloat(fallbackUnitPrice).toFixed(2),
                        total: parseFloat(item.subtotal_price).toFixed(2)
                    });
                }
            }

            // Add base fee services (rollup_fee_id = 1)
            if (baseFeeServices && baseFeeServices.length > 0) {
                baseFeeServices.forEach((service) => {
                    const servicePrice = parseFloat(
                        service.retail_cost || service.net_cost || 0
                    );
                    if (servicePrice > 0 || !service.show_service) {
                        let serviceQty = quantity;
                        let serviceAmt = servicePrice;
                        let serviceTotal = 0;

                        if (service.fee_structure === "Per Item") {
                            serviceTotal = servicePrice * quantity;
                        } else {
                            serviceQty = 1;
                            serviceTotal = servicePrice;
                        }

                        breakdown.push({
                            type: "service",
                            name:
                                service.name ||
                                service.service_name ||
                                "Service",
                            qty: !service.show_service ? quantity : serviceQty,
                            amt: !service.show_service
                                ? "INCL"
                                : parseFloat(serviceAmt).toFixed(2),
                            total: !service.show_service
                                ? "INCL"
                                : parseFloat(serviceTotal).toFixed(2),
                            show_service:
                                service.show_service !== undefined
                                    ? service.show_service
                                    : true,
                            service_id: service.id || null
                        });
                    }
                });
            }

            return breakdown.length > 0 ? breakdown : null;
        },

        // Get total item quantity
        getTotalItemQuantity(item) {
            if (
                !item ||
                !item.CartChildItems ||
                !Array.isArray(item.CartChildItems)
            ) {
                return 0;
            }
            return item.CartChildItems.reduce((total, childItem) => {
                const qty =
                    childItem.tempQuantity !== undefined &&
                    childItem.tempQuantity !== null
                        ? childItem.tempQuantity
                        : childItem.quantity;
                return total + parseInt(qty || 0, 10);
            }, 0);
        },
        getDynamicPatchCostContext(item) {
            const cartComponent = this.resolveCartVueComponent();
            if (cartComponent && cartComponent.getDynamicPatchCostContext) {
                return cartComponent.getDynamicPatchCostContext(item);
            }

            let details = item && item.patch_cost_details ? item.patch_cost_details : [];
            if (typeof details === "string") {
                try {
                    details = JSON.parse(details);
                } catch (e) {
                    details = [];
                }
            }
            if (!Array.isArray(details) || details.length === 0) {
                return {
                    details: [],
                    total: parseFloat((item && item.patch_cost) || 0) || 0
                };
            }

            const qty = this.getTotalItemQuantity(item);
            const billableQty = qty > 0 ? Math.max(qty, 50) : 0;
            let total = 0;
            const normalizedDetails = details.map((row) => {
                const perPatchPrice = parseFloat(row && row.perPatchPrice) || 0;
                const inventoryAvailable =
                    parseInt((row && row.inventory_used) || 0, 10) || 0;
                const inventorySufficientForProduct =
                    qty > 0 && inventoryAvailable >= qty;
                const inventoryUsed = inventorySufficientForProduct
                    ? qty
                    : Math.min(inventoryAvailable, billableQty);
                const chargedQty = inventorySufficientForProduct
                    ? 0
                    : Math.max(0, billableQty - inventoryUsed);
                const lineTotal = perPatchPrice * chargedQty;
                total += lineTotal;
                return {
                    ...row,
                    perPatchPrice,
                    quantity: qty,
                    totalQty: qty,
                    inventory_used: inventoryUsed,
                    charged_quantity: chargedQty,
                    total: lineTotal,
                    slab:
                        row && row.slab != null
                            ? row.slab
                            : billableQty
                };
            });
            const normalizedTotal = parseFloat(total.toFixed(2));
            if (item && typeof item === "object") {
                item.patch_cost_details = normalizedDetails;
                item.patch_cost = normalizedTotal;
            }
            return {
                details: normalizedDetails,
                total: normalizedTotal
            };
        },
        getDynamicPatchCostTotal(item) {
            return this.getDynamicPatchCostContext(item).total;
        },

        // Get all artwork colors (standard + non-standard)
        getAllArtworkColors(item) {
            if (!item) return [];

            const allColors = [];

            // Add standard colors from decoration_colors
            if (
                item.decoration_colors &&
                Array.isArray(item.decoration_colors) &&
                item.decoration_colors.length > 0
            ) {
                item.decoration_colors.forEach((color) => {
                    if (color && color.hex) {
                        allColors.push({
                            hex: color.hex,
                            name: color.name || color.hex
                        });
                    }
                });
            }

            // Add non-standard colors
            let nonStandardColors = item.non_standard_colors;
            if (typeof nonStandardColors === "string") {
                try {
                    nonStandardColors = JSON.parse(nonStandardColors);
                } catch (e) {
                    nonStandardColors = null;
                }
            }

            if (nonStandardColors && Array.isArray(nonStandardColors)) {
                nonStandardColors.forEach((colorHex) => {
                    if (colorHex && typeof colorHex === "string") {
                        const colorKey = colorHex.toLowerCase();
                        if (
                            colorKey &&
                            colorKey !== "#gggggg" &&
                            colorKey !== "" &&
                            !allColors.some(
                                (c) => (c.hex || c).toLowerCase() === colorKey
                            )
                        ) {
                            allColors.push(colorHex);
                        }
                    }
                });
            }

            // For decoration type 0, also check imprint_locations for non-standard colors
            if (item.decoration_type === 0) {
                let imprintLocations = item.imprint_locations;
                if (typeof imprintLocations === "string") {
                    try {
                        imprintLocations = JSON.parse(imprintLocations);
                    } catch (e) {
                        imprintLocations = null;
                    }
                }

                if (imprintLocations && Array.isArray(imprintLocations)) {
                    imprintLocations.forEach((location) => {
                        if (
                            location &&
                            location.colors &&
                            Array.isArray(location.colors)
                        ) {
                            location.colors.forEach((color) => {
                                if (
                                    color &&
                                    color.color_id === 0 &&
                                    color.hex
                                ) {
                                    const colorKey = color.hex.toLowerCase();
                                    if (
                                        colorKey &&
                                        colorKey !== "#gggggg" &&
                                        colorKey !== "" &&
                                        !allColors.some(
                                            (c) =>
                                                (c.hex || c).toLowerCase() ===
                                                colorKey
                                        )
                                    ) {
                                        allColors.push({
                                            hex: color.hex,
                                            name: color.name || color.hex
                                        });
                                    }
                                }
                            });
                        }
                    });
                }
            }

            return allColors;
        },

        normalizeImprintLocationKey(locationName) {
            const raw = (locationName || "").toLowerCase().trim();
            if (raw.includes("front")) return "front";
            if (raw.includes("back")) return "back";
            if (raw.includes("left")) return "left";
            if (raw.includes("right")) return "right";
            return "";
        },
        getSelectedImprintLocationKeys(item) {
            let im = item && item.imprint_locations;
            if (typeof im === "string") {
                try {
                    im = JSON.parse(im);
                } catch (e) {
                    return new Set();
                }
            }
            if (!im || !Array.isArray(im)) return new Set();
            const keys = new Set();
            im.forEach((loc) => {
                if (!loc || loc.is_selected !== true) return;
                const k = this.normalizeImprintLocationKey(loc.location || "");
                if (k) keys.add(k);
            });
            return keys;
        },
        appendOrphanNameNumberFeesForAllowedImprints(
            item,
            breakdown,
            existingFeeNames,
            extra = {}
        ) {
            const allowed = this.getSelectedImprintLocationKeys(item);
            if (allowed.size === 0) return;
            const buckets = {
                back: this.getNameNumberFeesFromItemPrices(item, "back"),
                front: this.getNameNumberFeesFromItemPrices(item, "front"),
                left: this.getNameNumberFeesFromItemPrices(item, "left"),
                right: this.getNameNumberFeesFromItemPrices(item, "right")
            };
            allowed.forEach((key) => {
                (buckets[key] || []).forEach((fee) => {
                    if (fee.total > 0 && !existingFeeNames.includes(fee.name)) {
                        breakdown.push({
                            type: "nameNumberFee",
                            name: fee.name,
                            qty: fee.qty,
                            amt: fee.amt,
                            total: fee.total,
                            ...extra
                        });
                        existingFeeNames.push(fee.name);
                    }
                });
            });
        },

        // Get Run Charge Breakdown Data for Decoration Type 0, 1, and 2
        getRunChargeBreakdown(item, parentItem = null) {
            if (!item || item.decoration_type === undefined) {
                return [];
            }

            // Handle decoration type 0 (PCNA)
            if (item.decoration_type == 0) {
                return this.getRunChargeBreakdownType0(item, parentItem);
            }

            // Handle decoration type 1 (Screen Print) and 2 (Embroidery)
            if (item.decoration_type == 1 || item.decoration_type == 5 || item.decoration_type == 2 || item.decoration_type == 4) {
                return this.getRunChargeBreakdownType1And2(item, parentItem);
            }

            return [];
        },
        getEffectiveImprintLocations(item, parentItem = null) {
            const parseImprintLocations = (locations) => {
                if (Array.isArray(locations)) return locations;
                if (typeof locations === "string") {
                    try {
                        const parsed = JSON.parse(locations);
                        return Array.isArray(parsed) ? parsed : [];
                    } catch (e) {
                        return [];
                    }
                }
                return [];
            };

            const itemLocations = parseImprintLocations(
                item && item.imprint_locations
            );
            if (itemLocations.length > 0) {
                return itemLocations;
            }

            if (parentItem && this.isAssemblyGroup(parentItem)) {
                const parentLocations = parseImprintLocations(
                    parentItem.imprint_locations
                );
                if (parentLocations.length > 0) {
                    return parentLocations;
                }
            }

            return [];
        },

        // Get Run Charge Breakdown for Decoration Type 0 (PCNA) - Simplified version
        getRunChargeBreakdownType0(item, parentItem = null) {
            if (!item.decoration || !item.decoration.master_service) {
                return [];
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error(
                        "Error parsing decoration in getRunChargeBreakdown:",
                        e
                    );
                    return [];
                }
            }

            const quantity = this.getTotalItemQuantity(item);
            const masterService = decoration.master_service || {};
            const location1stFee = parseFloat(masterService.location_1st || 0);
            const additionalLocationFee = parseFloat(
                masterService.additional_location || 0
            );
            const costPerColor1st = parseFloat(
                masterService.cost_per_color_1st || 0
            );
            const costPerColor2ndOrMore = parseFloat(
                masterService.cost_per_color_2ndormore || 0
            );
            const fullColorValue = this.getFullColorValue(item);

            const breakdown = [];

            const imprintLocations = this.getEffectiveImprintLocations(
                item,
                parentItem
            );
            if (imprintLocations.length > 0) {
                let locationIndex = 0;

                imprintLocations.forEach((location) => {
                    if (location.is_selected) {
                        const isFullColor = this.isLocationFullColor(location);
                        const noOfColors = parseInt(location.no_of_color || 0);
                        const locationName =
                            location.location ||
                            `Location ${locationIndex + 1}`;

                        if (locationIndex === 0) {
                            // First Location
                            const location1stTotal = location1stFee * quantity;
                            breakdown.push({
                                type: "location",
                                name: `1st Location${
                                    locationName !== "1st Location"
                                        ? " (" + locationName + ")"
                                        : ""
                                }`,
                                qty: quantity,
                                amt:
                                    location1stFee === 0 ||
                                    location1stTotal === 0
                                        ? "INCL"
                                        : location1stFee,
                                total:
                                    location1stFee === 0 ||
                                    location1stTotal === 0
                                        ? "INCL"
                                        : location1stTotal
                            });

                            // Full Color or Regular Colors
                            if (isFullColor && fullColorValue > 0) {
                                breakdown.push({
                                    type: "fullColor",
                                    name: "Full Color",
                                    qty: quantity,
                                    amt: fullColorValue,
                                    total: fullColorValue * quantity
                                });
                            } else {
                                // 1st Color
                                const color1stTotal =
                                    costPerColor1st * quantity;
                                const isEmbroideryDecoration =
                                    item.decoration_type == 2 ||
                                    item.decoration_type == 4;
                                if (
                                    !isEmbroideryDecoration ||
                                    (costPerColor1st > 0 && color1stTotal > 0)
                                ) {
                                    breakdown.push({
                                        type: "color1",
                                        name: "1st Color",
                                        qty: quantity,
                                        amt:
                                            costPerColor1st === 0 ||
                                            color1stTotal === 0
                                                ? "INCL"
                                                : costPerColor1st,
                                        total:
                                            costPerColor1st === 0 ||
                                            color1stTotal === 0
                                                ? "INCL"
                                                : color1stTotal
                                    });
                                }

                                // Additional Colors
                                if (noOfColors > 1) {
                                    const additionalColors = noOfColors - 1;
                                    breakdown.push({
                                        type: "addlColor",
                                        name: `Addl Color (${additionalColors})`,
                                        qty: quantity * additionalColors,
                                        amt: costPerColor2ndOrMore,
                                        total:
                                            costPerColor2ndOrMore *
                                            additionalColors *
                                            quantity
                                    });
                                }
                            }

                            // Specialty Color and Custom Color Upcharge
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                let totalSpecialtyUpcharge = 0;
                                let totalCustomUpcharge = 0;
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        const upcharge = parseFloat(
                                            color.color.decor_upcharge || 0
                                        );
                                        const stock =
                                            color.color.stock === true ||
                                            color.color.stock === 1;
                                        const colorType = String(
                                            color.color.type ||
                                                color.color.color_type ||
                                                ""
                                        )
                                            .replace(/['"]/g, "")
                                            .trim()
                                            .toLowerCase();

                                        if (upcharge > 0) {
                                            if (stock && colorType !== "vinyl") {
                                                // Specialty Color: stock = true AND upcharge > 0
                                                totalSpecialtyUpcharge +=
                                                    upcharge;
                                            } else if (colorType !== "vinyl") {
                                                // Custom Color: stock = false AND upcharge > 0
                                                totalCustomUpcharge += upcharge;
                                            }
                                        }
                                    }
                                });
                                if (totalSpecialtyUpcharge > 0) {
                                    breakdown.push({
                                        type: "colorUpcharge",
                                        name: "Specialty Color",
                                        qty: quantity,
                                        amt: totalSpecialtyUpcharge,
                                        total: totalSpecialtyUpcharge * quantity
                                    });
                                }
                                if (totalCustomUpcharge > 0) {
                                    breakdown.push({
                                        type: "customColorUpcharge",
                                        name: "Custom Color",
                                        qty: quantity,
                                        amt: totalCustomUpcharge,
                                        total: totalCustomUpcharge * quantity
                                    });
                                }
                            }

                            if (locationIndex === 0) {
                                const locationKey =
                                    this.normalizeImprintLocationKey(
                                        locationName
                                    ) || "front";
                                const locationFees =
                                    this.getNameNumberFeesFromItemPrices(
                                        item,
                                        locationKey
                                    );

                                locationFees.forEach((fee) => {
                                    if (fee.total > 0) {
                                        breakdown.push({
                                            type: "nameNumberFee",
                                            name: fee.name,
                                            qty: fee.qty,
                                            amt: fee.amt,
                                            total: fee.total
                                        });
                                    }
                                });
                            }
                        } else {
                            // Additional Location
                            breakdown.push({
                                type: "location",
                                name: `Additional Location (${locationName})`,
                                qty: quantity,
                                amt: additionalLocationFee,
                                total: additionalLocationFee * quantity
                            });

                            // Full Color or Regular Colors for additional location
                            if (isFullColor && fullColorValue > 0) {
                                breakdown.push({
                                    type: "fullColor",
                                    name: "Full Color",
                                    qty: quantity,
                                    amt: fullColorValue,
                                    total: fullColorValue * quantity
                                });
                            } else {
                                // 1st Color
                                const color1stTotal =
                                    costPerColor1st * quantity;
                                const isEmbroideryDecoration =
                                    item.decoration_type == 2 ||
                                    item.decoration_type == 4;
                                if (
                                    !isEmbroideryDecoration ||
                                    (costPerColor1st > 0 && color1stTotal > 0)
                                ) {
                                    breakdown.push({
                                        type: "color1",
                                        name: "1st Color",
                                        qty: quantity,
                                        amt:
                                            costPerColor1st === 0 ||
                                            color1stTotal === 0
                                                ? "INCL"
                                                : costPerColor1st,
                                        total:
                                            costPerColor1st === 0 ||
                                            color1stTotal === 0
                                                ? "INCL"
                                                : color1stTotal
                                    });
                                }

                                if (noOfColors > 1) {
                                    const additionalColors = noOfColors - 1;
                                    breakdown.push({
                                        type: "addlColor",
                                        name: `Addl Color (${additionalColors})`,
                                        qty: quantity * additionalColors,
                                        amt: costPerColor2ndOrMore,
                                        total:
                                            costPerColor2ndOrMore *
                                            additionalColors *
                                            quantity
                                    });
                                }
                            }

                            // Specialty Color and Custom Color Upcharge for additional location
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                let totalSpecialtyUpcharge = 0;
                                let totalCustomUpcharge = 0;
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        const upcharge = parseFloat(
                                            color.color.decor_upcharge || 0
                                        );
                                        const stock =
                                            color.color.stock === true ||
                                            color.color.stock === 1;
                                        const colorType = String(
                                            color.color.type ||
                                                color.color.color_type ||
                                                ""
                                        )
                                            .replace(/['"]/g, "")
                                            .trim()
                                            .toLowerCase();

                                        if (upcharge > 0) {
                                            if (stock && colorType !== "vinyl") {
                                                // Specialty Color: stock = true AND upcharge > 0
                                                totalSpecialtyUpcharge +=
                                                    upcharge;
                                            } else if (colorType !== "vinyl") {
                                                // Custom Color: stock = false AND upcharge > 0
                                                totalCustomUpcharge += upcharge;
                                            }
                                        }
                                    }
                                });
                                if (totalSpecialtyUpcharge > 0) {
                                    breakdown.push({
                                        type: "colorUpcharge",
                                        name: "Specialty Color",
                                        qty: quantity,
                                        amt: totalSpecialtyUpcharge,
                                        total: totalSpecialtyUpcharge * quantity
                                    });
                                }
                                if (totalCustomUpcharge > 0) {
                                    breakdown.push({
                                        type: "customColorUpcharge",
                                        name: "Custom Color",
                                        qty: quantity,
                                        amt: totalCustomUpcharge,
                                        total: totalCustomUpcharge * quantity
                                    });
                                }
                            }

                            // Name/Number Fees for additional location
                            // Normalize compound names like "left sleeve", "right sleeve" etc. to core locations
                            const locationNameLowerRaw = (
                                locationName || ""
                            )
                                .toLowerCase()
                                .trim();
                            let locationKey = locationNameLowerRaw;
                            if (locationKey.includes("front")) {
                                locationKey = "front";
                            } else if (locationKey.includes("back")) {
                                locationKey = "back";
                            } else if (locationKey.includes("left")) {
                                locationKey = "left";
                            } else if (locationKey.includes("right")) {
                                locationKey = "right";
                            }
                            let nameNumberFeesForLocation =
                                this.getNameNumberFeesFromItemPrices(
                                    item,
                                    locationKey
                                );

                            // If location is "back", also include general back fees
                            if (locationKey === "back") {
                                const backFees =
                                    this.getNameNumberFeesFromItemPrices(
                                        item,
                                        "back"
                                    );
                                // Combine location-specific and general back fees, avoiding duplicates
                                const existingFeeNames =
                                    nameNumberFeesForLocation.map(
                                        (f) => f.name
                                    );
                                backFees.forEach((fee) => {
                                    if (!existingFeeNames.includes(fee.name)) {
                                        nameNumberFeesForLocation.push(fee);
                                    }
                                });
                            }

                            nameNumberFeesForLocation.forEach((fee) => {
                                if (fee.total > 0) {
                                    breakdown.push({
                                        type: "nameNumberFee",
                                        name: fee.name,
                                        qty: fee.qty,
                                        amt: fee.amt,
                                        total: fee.total
                                    });
                                }
                            });
                        }

                        locationIndex++;
                    }
                });
            }

            const existingFeeNamesCS0 = breakdown
                .filter((row) => row.type === "nameNumberFee")
                .map((row) => row.name);
            this.appendOrphanNameNumberFeesForAllowedImprints(
                item,
                breakdown,
                existingFeeNamesCS0
            );

            // Organize breakdown by location for better readability
            return this.organizeBreakdownByLocation(breakdown);
        },

        // Organize flat breakdown array into location-wise structure
        organizeBreakdownByLocation(breakdown) {
            if (
                !breakdown ||
                !Array.isArray(breakdown) ||
                breakdown.length === 0
            ) {
                return breakdown; // Return as-is if empty or invalid
            }

            const locations = [];
            let currentLocation = null;

            breakdown.forEach((item) => {
                // Format decimal values to 2 digits for amt and total
                const formattedItem = { ...item };

                // Format amt to 2 decimal places as string (if it's a number, not "INCL" or "-")
                // Convert to string to preserve trailing zeros (1.2 → "1.20", 1.26 → "1.26")
                if (formattedItem.amt !== "INCL" && formattedItem.amt !== "-") {
                    const numAmt =
                        typeof formattedItem.amt === "string"
                            ? parseFloat(formattedItem.amt)
                            : formattedItem.amt;
                    if (!isNaN(numAmt) && typeof numAmt === "number") {
                        formattedItem.amt = parseFloat(numAmt).toFixed(2);
                    }
                }

                // Format total to 2 decimal places as string (if it's a number, not "INCL" or "-")
                // Convert to string to preserve trailing zeros (57.6 → "57.60", 57.66 → "57.66")
                if (
                    formattedItem.total !== "INCL" &&
                    formattedItem.total !== "-"
                ) {
                    const numTotal =
                        typeof formattedItem.total === "string"
                            ? parseFloat(formattedItem.total)
                            : formattedItem.total;
                    if (!isNaN(numTotal) && typeof numTotal === "number") {
                        formattedItem.total = parseFloat(numTotal).toFixed(2);
                    }
                }

                // If it's a location type, start a new location group
                if (formattedItem.type === "location") {
                    // Save previous location if exists
                    if (currentLocation) {
                        locations.push(currentLocation);
                    }

                    // Extract location name from "1st Location (Front)" or "Additional Location (Back)"
                    let locationName = "Location";
                    const match = formattedItem.name.match(/\(([^)]+)\)/);
                    if (match) {
                        locationName = match[1]; // Extract "Front" or "Back"
                    } else if (formattedItem.name.includes("1st Location")) {
                        locationName = "Front";
                    } else if (
                        formattedItem.name.includes("Additional Location")
                    ) {
                        locationName =
                            formattedItem.name
                                .replace("Additional Location", "")
                                .trim()
                                .replace(/[()]/g, "") || "Back";
                    }

                    // Start new location
                    currentLocation = {
                        location: locationName,
                        locationName: formattedItem.name,
                        items: [formattedItem]
                    };
                } else if (currentLocation) {
                    // Add item to current location
                    currentLocation.items.push(formattedItem);
                } else {
                    // Item before any location - create a default location
                    currentLocation = {
                        location: "Default",
                        locationName: "Default Location",
                        items: [formattedItem]
                    };
                }
            });

            // Don't forget the last location
            if (currentLocation) {
                locations.push(currentLocation);
            }

            // Return location-wise structure (array of location objects)
            // Structure: [{ location: "Front", locationName: "...", items: [...] }, ...]
            return locations.length > 0 ? locations : breakdown; // Fallback to original if no locations found
        },

        // Get Run Charge Breakdown for Decoration Type 1 and 2
        getRunChargeBreakdownType1And2(item, parentItem = null) {
            if (!item.decoration) {
                return [];
            }
            const getLocationColorCount = (location) => {
                if (!location || typeof location !== "object") return 0;
                const declaredColorCount =
                    parseInt(location.no_of_color || 0) || 0;
                const colorsArrayCount =
                    location.colors && Array.isArray(location.colors)
                        ? location.colors.filter((colorObj) => {
                              return (
                                  colorObj &&
                                  colorObj.color &&
                                  (colorObj.color.color_id !== undefined ||
                                      colorObj.color.color_value ||
                                      colorObj.color.hex)
                              );
                          }).length
                        : 0;
                return Math.max(declaredColorCount, colorsArrayCount);
            };

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return [];
                }
            }

            const imprintLocations = this.getEffectiveImprintLocations(
                item,
                parentItem
            );
            if (!imprintLocations.length) {
                return [];
            }

            // Get price_decoration_bulk from decoration or item
            let priceBulk =
                decoration.price_decoration_bulk || item.price_decoration_bulk;
            if (typeof priceBulk === "string") {
                try {
                    priceBulk = JSON.parse(priceBulk);
                } catch (e) {
                    priceBulk = null;
                }
            }

            const lineQuantity = this.getTotalItemQuantity(item);
            const tierQuantity = this.getTierQuantityForItem(item, parentItem);
            const breakdown = [];
            const fullColorValue = this.getFullColorValue(item);
            const masterService = decoration.master_service || {};
            const location1stFee = parseFloat(masterService.location_1st || 0);
            const additionalLocationFee = parseFloat(
                masterService.additional_location || 0
            );
            const costPerColor1st = parseFloat(
                masterService.cost_per_color_1st || 0
            );
            const costPerColor2ndOrMore = parseFloat(
                masterService.cost_per_color_2ndormore || 0
            );

            // Find first selected location
            const firstLocation =
                imprintLocations.find((loc) => loc.is_selected) ||
                imprintLocations[0];
            if (!firstLocation) {
                return [];
            }

            const firstLocationName = firstLocation.location || "1st Location";
            const firstLocationColorCount = getLocationColorCount(firstLocation);
            const isFirstLocationFullColor =
                this.isLocationFullColor(firstLocation);

            // 1st Location (INCL)
            breakdown.push({
                type: "location",
                name: `1st Location${
                    firstLocationName !== "1st Location"
                        ? " (" + firstLocationName + ")"
                        : ""
                }`,
                qty: lineQuantity,
                amt: location1stFee > 0 ? location1stFee : "INCL",
                total:
                    location1stFee > 0 ? location1stFee * lineQuantity : "INCL",
                isIncluded: location1stFee <= 0
            });

            // Full Color or Regular Colors for first location
            if (isFirstLocationFullColor && fullColorValue > 0) {
                breakdown.push({
                    type: "fullColor",
                    name: "Full Color",
                    qty: lineQuantity,
                    amt: fullColorValue,
                    total: fullColorValue * lineQuantity,
                    isIncluded: false
                });
            } else {
                // 1st Color (hide INCL row only for embroidery type 2/4)
                const isEmbroideryDecoration =
                    item.decoration_type == 2 || item.decoration_type == 4;
                if (!isEmbroideryDecoration || costPerColor1st > 0) {
                    breakdown.push({
                        type: "color1",
                        name: "1st Color",
                        qty: lineQuantity,
                        amt: costPerColor1st > 0 ? costPerColor1st : "INCL",
                        total:
                            costPerColor1st > 0
                                ? costPerColor1st * lineQuantity
                                : "INCL",
                        isIncluded: costPerColor1st <= 0
                    });
                }

                // Addl Color for 1st Location
                if (firstLocationColorCount > 1) {
                    const addlColors = firstLocationColorCount - 1;
                    let addlColorPrice = 0;

                    if (
                        (item.decoration_type == 1 ||
                            item.decoration_type == 5) &&
                        priceBulk
                    ) {
                        addlColorPrice = this.getFirstLocationAddlColorPrice(
                            item,
                            priceBulk,
                            tierQuantity,
                            firstLocationColorCount
                        );
                    } else if (
                        item.decoration_type == 2 ||
                        item.decoration_type == 4
                    ) {
                        addlColorPrice = costPerColor2ndOrMore;
                    }

                    if (addlColorPrice > 0) {
                        breakdown.push({
                            type: "addlColor",
                            name: `Addl Color (${addlColors})`,
                            qty: lineQuantity * addlColors,
                            amt: addlColorPrice,
                            total: addlColorPrice * addlColors * lineQuantity,
                            isIncluded: false
                        });
                    }
                }
            }

            // Specialty Color (color upcharge) for 1st Location
            const firstLocationUpcharge = this.getLocationColorUpcharge(
                firstLocation,
                item
            );
            if (firstLocationUpcharge > 0) {
                breakdown.push({
                    type: "colorUpcharge",
                    name: "Specialty Color",
                    qty: lineQuantity,
                    amt: firstLocationUpcharge,
                    total: firstLocationUpcharge * lineQuantity,
                    isIncluded: false
                });
            }

            // Custom Color (color upcharge) for 1st Location
            const firstLocationCustomUpcharge =
                this.getLocationCustomColorUpcharge(firstLocation, item);
            if (firstLocationCustomUpcharge > 0) {
                breakdown.push({
                    type: "customColorUpcharge",
                    name: "Custom Color",
                    qty: lineQuantity,
                    amt: firstLocationCustomUpcharge,
                    total: firstLocationCustomUpcharge * lineQuantity,
                    isIncluded: false
                });
            }

            const firstLocKeyCS =
                this.normalizeImprintLocationKey(firstLocationName) || "front";
            const firstNameNumberFeesCS =
                this.getNameNumberFeesFromItemPrices(item, firstLocKeyCS);
            firstNameNumberFeesCS.forEach((fee) => {
                if (fee.total > 0) {
                    breakdown.push({
                        type: "nameNumberFee",
                        name: fee.name,
                        qty: fee.qty,
                        amt: fee.amt,
                        total: fee.total,
                        isIncluded: false
                    });
                }
            });

            // Additional Locations
            const firstSelectedIndex = imprintLocations.findIndex(
                (loc) => loc.is_selected
            );
            const additionalLocations = imprintLocations.filter((loc, idx) => {
                return loc.is_selected && idx !== firstSelectedIndex;
            });

            additionalLocations.forEach((location) => {
                const locationName = location.location || `Location`;
                const colorCount = getLocationColorCount(location);
                const isLocationFullColor = this.isLocationFullColor(location);
                const isEmbroideryDecoration =
                    item.decoration_type == 2 || item.decoration_type == 4;
                const embroideryLocationPrice = isEmbroideryDecoration
                    ? this.getEmbroideryLocationPrice(item, priceBulk, tierQuantity)
                    : 0;
                const effectiveAdditionalLocationFee =
                    isEmbroideryDecoration && embroideryLocationPrice > 0
                        ? embroideryLocationPrice
                        : additionalLocationFee;

                let locKeyAdd = this.normalizeImprintLocationKey(locationName);
                if (!locKeyAdd) locKeyAdd = locationName.toLowerCase().trim();
                let nameNumberFeesForLocation =
                    this.getNameNumberFeesFromItemPrices(item, locKeyAdd);
                const hasNameNumberFees =
                    nameNumberFeesForLocation.length > 0 &&
                    nameNumberFeesForLocation.some((fee) => fee.total > 0);

                // Skip only if no colors, not full color, AND no name/number fees
                if (
                    colorCount <= 0 &&
                    !isLocationFullColor &&
                    !hasNameNumberFees
                )
                    return;

                // Additional Location
                breakdown.push({
                    type: "location",
                    name: `Additional Location${
                        locationName ? " (" + locationName + ")" : ""
                    }`,
                    qty: lineQuantity,
                    amt:
                        effectiveAdditionalLocationFee > 0
                            ? effectiveAdditionalLocationFee
                            : "INCL",
                    total:
                        effectiveAdditionalLocationFee > 0
                            ? effectiveAdditionalLocationFee * lineQuantity
                            : "INCL",
                    isIncluded: effectiveAdditionalLocationFee <= 0
                });

                // Full Color or Addl Color for additional location
                if (isLocationFullColor && fullColorValue > 0) {
                    breakdown.push({
                        type: "fullColor",
                        name: "Full Color",
                        qty: lineQuantity,
                        amt: fullColorValue,
                        total: fullColorValue * lineQuantity,
                        isIncluded: false
                    });
                } else if (colorCount > 0) {
                    if (
                        (item.decoration_type == 1 ||
                            item.decoration_type == 5) &&
                        priceBulk
                    ) {
                        // Screen Print (type 1):
                        // (template colourN + master addl color) * (N * qty)
                        const templateLocation2ColorPrice =
                            this.getAdditionalLocationAddlColorPrice(
                                item,
                                priceBulk,
                                tierQuantity,
                                colorCount
                            );
                        const combinedType1Unit =
                            templateLocation2ColorPrice + costPerColor2ndOrMore;

                        if (combinedType1Unit > 0) {
                            breakdown.push({
                                type: "addlColor",
                                name: `Addl Color (${colorCount})`,
                                qty: lineQuantity * colorCount,
                                amt: combinedType1Unit,
                                total:
                                    combinedType1Unit *
                                    colorCount *
                                    lineQuantity,
                                isIncluded: false
                            });
                        }
                    } else if (
                        (item.decoration_type == 2 ||
                            item.decoration_type == 4) &&
                        priceBulk
                    ) {
                        // Embroidery (type 2/4):
                        // Additional location price is shown in the location row.
                        // Only true additional thread colors stay under Addl Color.
                        if (colorCount > 1 && costPerColor2ndOrMore > 0) {
                            const addlCount = colorCount;
                            breakdown.push({
                                type: "addlColor",
                                name: `Addl Color (${addlCount})`,
                                qty: lineQuantity * addlCount,
                                amt: costPerColor2ndOrMore,
                                total:
                                    costPerColor2ndOrMore *
                                    addlCount *
                                    lineQuantity,
                                isIncluded: false
                            });
                        }
                    }
                }

                // Specialty Color for additional location
                const locationUpcharge = this.getLocationColorUpcharge(
                    location,
                    item
                );
                if (locationUpcharge > 0) {
                    breakdown.push({
                        type: "colorUpcharge",
                        name: "Specialty Color",
                        qty: lineQuantity,
                        amt: locationUpcharge,
                        total: locationUpcharge * lineQuantity,
                        isIncluded: false
                    });
                }

                // Custom Color for additional location
                const locationCustomUpcharge =
                    this.getLocationCustomColorUpcharge(location, item);
                if (locationCustomUpcharge > 0) {
                    breakdown.push({
                        type: "customColorUpcharge",
                        name: "Custom Color",
                        qty: lineQuantity,
                        amt: locationCustomUpcharge,
                        total: locationCustomUpcharge * lineQuantity,
                        isIncluded: false
                    });
                }

                // Name/Number Fees for additional location
                // Use the fees we already found above
                nameNumberFeesForLocation.forEach((fee) => {
                    if (fee.total > 0) {
                        breakdown.push({
                            type: "nameNumberFee",
                            name: fee.name,
                            qty: fee.qty,
                            amt: fee.amt,
                            total: fee.total,
                            isIncluded: false
                        });
                    }
                });
            });

            const existingFeeNamesCS12 = breakdown
                .filter((row) => row.type === "nameNumberFee")
                .map((row) => row.name);
            this.appendOrphanNameNumberFeesForAllowedImprints(
                item,
                breakdown,
                existingFeeNamesCS12,
                { isIncluded: false }
            );

            // Organize breakdown by location for better readability
            return this.organizeBreakdownByLocation(breakdown);
        },

        // Get Run Charge Total from Breakdown
        // This should match exactly with ToolTip.vue's getRunChargeBreakdownTotal() method
        getRunChargeTotalFromBreakdown(
            item,
            breakdown,
            runChargeServices,
            quantity
        ) {
            let total = 0;

            // Handle location-wise structure (new format)
            if (breakdown && Array.isArray(breakdown) && breakdown.length > 0) {
                // Check if it's location-wise structure (array of location objects)
                if (
                    breakdown[0] &&
                    breakdown[0].location &&
                    breakdown[0].items
                ) {
                    // New location-wise structure
                    breakdown.forEach((location) => {
                        if (location.items && location.items.length > 0) {
                            location.items.forEach((row) => {
                                // Skip INCL and "-" rows - exactly matching tooltip logic
                                if (
                                    row.isIncluded ||
                                    row.total === "INCL" ||
                                    row.total === "-" ||
                                    row.amt === "INCL" ||
                                    row.amt === "-"
                                ) {
                                    return;
                                }
                                total += parseFloat(row.total || 0);
                            });
                        }
                    });
                } else {
                    // Old flat array structure (backward compatibility)
                    breakdown.forEach((row) => {
                        // Skip INCL and "-" rows - exactly matching tooltip logic
                        if (
                            row.isIncluded ||
                            row.total === "INCL" ||
                            row.total === "-" ||
                            row.amt === "INCL" ||
                            row.amt === "-"
                        ) {
                            return;
                        }
                        total += parseFloat(row.total || 0);
                    });
                }
            }

            // Add services with rollup_fee_id = 12 (Run Charge services) - exactly matching tooltip logic
            if (runChargeServices && runChargeServices.length > 0) {
                runChargeServices.forEach((service) => {
                    // Use same logic as tooltip's getServiceTotal()
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }

            // Only use fallback if breakdown is completely empty (not calculated)
            // This ensures we don't double-count if breakdown exists
            if (
                (!breakdown || breakdown.length === 0) &&
                item.imprint_locations_price
            ) {
                // Only add if we haven't calculated anything from breakdown
                total = parseFloat(item.imprint_locations_price || 0);

                // Still add services even in fallback case
                if (runChargeServices && runChargeServices.length > 0) {
                    runChargeServices.forEach((service) => {
                        const servicePrice =
                            service.retail_cost || service.net_cost || 0;
                        if (service.fee_structure === "Per Item") {
                            total += parseFloat(servicePrice) * quantity;
                        } else {
                            total += parseFloat(servicePrice);
                        }
                    });
                }
            }

            return parseFloat(total.toFixed(2));
        },

        // Get Setup Fee Total from Details
        // This should match exactly with ToolTip.vue's setupFeeTotal computed property
        getSetupFeeTotalFromDetails(
            setupFeeDetails,
            setupFeeServices,
            quantity
        ) {
            let total = 0;

            if (setupFeeDetails) {
                // Use total from setupFeeDetails if available and > 0
                if (
                    setupFeeDetails.total &&
                    parseFloat(setupFeeDetails.total) > 0
                ) {
                    total = parseFloat(setupFeeDetails.total);
                } else if (
                    setupFeeDetails.locations &&
                    setupFeeDetails.locations.length > 0
                ) {
                    // Calculate from locations if total is not available
                    total = setupFeeDetails.locations.reduce(
                        (sum, location) => {
                            return sum + parseFloat(location.total || 0);
                        },
                        0
                    );
                }
            }

            // Add services with rollup_fee_id = 2 (Setup Fee services) - include all services regardless of show_service
            if (setupFeeServices && setupFeeServices.length > 0) {
                setupFeeServices.forEach((service) => {
                    // Use same logic as tooltip's getServiceTotal()
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },

        // Helper method to check if location is full color (matches Cart.vue logic)
        // When user selected Full color in design studio, show Full Color in breakdown even if location has only name/number (0 colors)
        isLocationFullColor(location) {
            const hasFullColorFlag =
                location.is_full_color === true ||
                location.no_of_color === "full_color" ||
                location.no_of_color === "Full color";

            if (!hasFullColorFlag) {
                return false;
            }

            let actualColorCount = 0;
            if (location.colors && Array.isArray(location.colors)) {
                actualColorCount = location.colors.filter((colorObj) => {
                    return (
                        colorObj &&
                        colorObj.color &&
                        (colorObj.color.color_id !== undefined ||
                            colorObj.color.color_value ||
                            colorObj.color.hex)
                    );
                }).length;
            }

            if (actualColorCount === 0) {
                const noOfColors = parseInt(location.no_of_color || 0);
                if (
                    noOfColors > 0 &&
                    noOfColors !== "full_color" &&
                    noOfColors !== "Full color"
                ) {
                    actualColorCount = noOfColors;
                }
            }

            // Full color selected: show when multiple colors OR zero colors (e.g. only name/number on that location)
            return actualColorCount > 1 || actualColorCount === 0;
        },
        getLocationColorCount(location) {
            if (!location || typeof location !== "object") return 0;

            const declaredColorCount = parseInt(location.no_of_color || 0) || 0;
            const colorsArrayCount =
                location.colors && Array.isArray(location.colors)
                    ? location.colors.filter((colorObj) => {
                          return (
                              colorObj &&
                              colorObj.color &&
                              (colorObj.color.color_id !== undefined ||
                                  colorObj.color.color_value ||
                                  colorObj.color.hex)
                          );
                      }).length
                    : 0;

            // Use higher value so stale no_of_color does not drop addl-color rows.
            return Math.max(declaredColorCount, colorsArrayCount);
        },

        // Helper method to get full color value from master_service
        getFullColorValue(item) {
            if (!item.decoration || !item.decoration.master_service) {
                return 0;
            }

            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return 0;
                }
            }

            const masterService = decoration.master_service || {};
            return parseFloat(masterService.full_color || 0);
        },

        // Get First Location Additional Color Price (for type 1)
        getFirstLocationAddlColorPrice(item, priceBulk, quantity, colorCount) {
            if (
                !priceBulk ||
                !priceBulk.print_location1 ||
                item.decoration_type != 1 &&
                item.decoration_type != 5
            ) {
                return 0;
            }

            const priceData = priceBulk.print_location1;
            if (!Array.isArray(priceData)) {
                return 0;
            }

            // Find the price tier for current quantity
            let lastColorPrice = 0;
            let firstColorPrice = 0;

            for (let i = priceData.length - 1; i >= 0; i--) {
                const tier = priceData[i];
                if (
                    tier &&
                    tier.quantity &&
                    parseInt(tier.quantity) <= quantity
                ) {
                    lastColorPrice = parseFloat(
                        tier[`colour${colorCount}`] || 0
                    );
                    firstColorPrice = parseFloat(tier.colour1 || 0);
                    break;
                }
            }

            // If no tier found, use first tier
            if (lastColorPrice === 0 && priceData.length > 0) {
                const firstTier = priceData[0];
                lastColorPrice = parseFloat(
                    firstTier[`colour${colorCount}`] || 0
                );
                firstColorPrice = parseFloat(firstTier.colour1 || 0);
            }

            // Additional color price is template delta + master additional-color cost
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    decoration = null;
                }
            }
            const masterAddlColor = parseFloat(
                (((decoration || {}).master_service || {})
                    .cost_per_color_2ndormore || 0)
            );
            return Math.max(0, lastColorPrice - firstColorPrice) + masterAddlColor;
        },

        // Get Additional Location Additional Color Price (for type 1)
        getAdditionalLocationAddlColorPrice(
            item,
            priceBulk,
            quantity,
            colorCount
        ) {
            if (
                !priceBulk ||
                !priceBulk.print_location2 ||
                item.decoration_type != 1 &&
                item.decoration_type != 5
            ) {
                return 0;
            }

            const priceData = priceBulk.print_location2;
            if (!Array.isArray(priceData)) {
                return 0;
            }

            // Find the price tier for current quantity
            let directPrice = 0;

            for (let i = priceData.length - 1; i >= 0; i--) {
                const tier = priceData[i];
                if (
                    tier &&
                    tier.quantity &&
                    parseInt(tier.quantity) <= quantity
                ) {
                    directPrice = parseFloat(tier[`colour${colorCount}`] || 0);
                    break;
                }
            }

            // If no tier found, use first tier
            if (directPrice === 0 && priceData.length > 0) {
                const firstTier = priceData[0];
                directPrice = parseFloat(firstTier[`colour${colorCount}`] || 0);
            }

            return directPrice;
        },

        // Get Embroidery Location Price (for type 2)
        getEmbroideryLocationPrice(item, priceBulk, quantity) {
            if (!priceBulk || (item.decoration_type != 2 && item.decoration_type != 4)) {
                return 0;
            }

            // For embroidery, priceBulk is an array
            if (!Array.isArray(priceBulk)) {
                return 0;
            }

            // Find the price tier for current quantity
            let selectedRow = null;

            for (const row of priceBulk) {
                if (row.quantity1 && row.quantity2) {
                    if (
                        quantity >= parseInt(row.quantity1) &&
                        quantity <= parseInt(row.quantity2)
                    ) {
                        selectedRow = row;
                        break;
                    }
                } else if (
                    row.quantity1 &&
                    quantity >= parseInt(row.quantity1)
                ) {
                    selectedRow = row;
                    break;
                }
            }

            // If no tier found, use first tier
            if (!selectedRow && priceBulk.length > 0) {
                selectedRow = priceBulk[0];
            }

            if (selectedRow && selectedRow.location2 !== undefined) {
                return parseFloat(selectedRow.location2 || 0);
            }

            return 0;
        },

        // Get Location Color Upcharge (Specialty Colors only: stock=true AND upcharge>0)
        getLocationColorUpcharge(location) {
            if (
                !location ||
                !location.colors ||
                !Array.isArray(location.colors)
            ) {
                return 0;
            }

            let totalUpcharge = 0;
            location.colors.forEach((colorObj) => {
                if (
                    colorObj &&
                    colorObj.color &&
                    colorObj.color.decor_upcharge
                ) {
                    const upcharge = parseFloat(
                        colorObj.color.decor_upcharge || 0
                    );
                    const stock =
                        colorObj.color.stock === true ||
                        colorObj.color.stock === 1;
                    const colorType = String(
                        colorObj.color.type || colorObj.color.color_type || ""
                    )
                        .replace(/['"]/g, "")
                        .trim()
                        .toLowerCase();
                    // Only include specialty colors: stock = true AND upcharge > 0
                    if (upcharge > 0 && stock && colorType !== "vinyl") {
                        totalUpcharge += upcharge;
                    }
                }
            });

            return parseFloat(totalUpcharge.toFixed(2));
        },

        // Get Location Custom Color Upcharge (Custom Colors only: stock=false AND upcharge>0)
        getLocationCustomColorUpcharge(location) {
            if (
                !location ||
                !location.colors ||
                !Array.isArray(location.colors)
            ) {
                return 0;
            }

            let totalUpcharge = 0;
            location.colors.forEach((colorObj) => {
                if (
                    colorObj &&
                    colorObj.color &&
                    colorObj.color.decor_upcharge
                ) {
                    const upcharge = parseFloat(
                        colorObj.color.decor_upcharge || 0
                    );
                    const stock =
                        colorObj.color.stock === true ||
                        colorObj.color.stock === 1;
                    const colorType = String(
                        colorObj.color.type || colorObj.color.color_type || ""
                    )
                        .replace(/['"]/g, "")
                        .trim()
                        .toLowerCase();
                    // Only include custom colors: stock = false AND upcharge > 0
                    if (upcharge > 0 && !stock && colorType !== "vinyl") {
                        totalUpcharge += upcharge;
                    }
                }
            });

            return parseFloat(totalUpcharge.toFixed(2));
        },

        // Get Name/Number Fees from item_prices for a specific location
        getNameNumberFeesFromItemPrices(item, locationName) {
            const fees = [];

            if (!item.item_prices) {
                return fees;
            }

            // Parse item_prices if it's a string
            let itemPrices = item.item_prices;
            if (typeof itemPrices === "string") {
                try {
                    itemPrices = JSON.parse(itemPrices);
                } catch (e) {
                    return fees;
                }
            }

            if (!itemPrices.selected_name_number) {
                return fees;
            }

            const selectedNameNumber = itemPrices.selected_name_number;
            const location = locationName.toLowerCase();

            // Get real-time fees from VendorFees (if available)
            let nameFeePerItem = null;
            let numberFeePerItem = null;

            if (
                item.main_new_product &&
                item.main_new_product.VendorFees &&
                Array.isArray(item.main_new_product.VendorFees)
            ) {
                const vendorFees = item.main_new_product.VendorFees;

                // Get Name Fee (only if rollup_fee_id exists)
                const nameService = vendorFees.find(
                    (service) =>
                        service.rollup_fee_id &&
                        (service.type === "name" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("name")))
                );
                if (nameService && nameService.retail_cost) {
                    nameFeePerItem = parseFloat(nameService.retail_cost) || 0;
                }

                // Get Number Fee (only if rollup_fee_id exists)
                const numberService = vendorFees.find(
                    (service) =>
                        service.rollup_fee_id &&
                        (service.type === "number" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("number")))
                );
                if (numberService && numberService.retail_cost) {
                    numberFeePerItem =
                        parseFloat(numberService.retail_cost) || 0;
                }
            }

            // Front location
            if (location === "front" && selectedNameNumber.front) {
                const front = selectedNameNumber.front;

                // Front Name Fee (use item_prices first so pricing correct when VendorFees not loaded)
                if (
                    front.name &&
                    typeof front.name === "object" &&
                    front.name.front_name_count &&
                    parseInt(front.name.front_name_count || 0) > 0
                ) {
                    const count = parseInt(front.name.front_name_count || 0);
                    const totalFee = parseFloat(
                        front.name.front_name_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : nameFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Front Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (nameFeePerItem !== null && nameFeePerItem > 0) {
                        const total = count * nameFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Front Name Fee",
                                qty: count,
                                amt: nameFeePerItem,
                                total
                            });
                        }
                    }
                }

                // Front Name Decor Up Fee (from item_prices)
                if (
                    front.name &&
                    typeof front.name === "object" &&
                    front.name.front_name_decor_up_fees !== undefined &&
                    parseFloat(front.name.front_name_decor_up_fees || 0) > 0
                ) {
                    const count = parseInt(front.name.front_name_count || 0);
                    const totalFee = parseFloat(
                        front.name.front_name_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        front.name.front_name_decor_up_per_price || 0
                    );
                    fees.push({
                        name: "Front Name Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Front Number Fee (use item_prices first so pricing correct when VendorFees not loaded)
                if (
                    front.number &&
                    front.number.front_number_count &&
                    parseInt(front.number.front_number_count || 0) > 0
                ) {
                    const count = parseInt(
                        front.number.front_number_count || 0
                    );
                    const totalFee = parseFloat(
                        front.number.front_number_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : numberFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Front Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (
                        numberFeePerItem !== null &&
                        numberFeePerItem > 0
                    ) {
                        const total = count * numberFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Front Number Fee",
                                qty: count,
                                amt: numberFeePerItem,
                                total
                            });
                        }
                    }
                }

                // Front Number Decor Up Fee (always from item_prices, not from VendorFees)
                if (
                    front.number &&
                    front.number.front_number_decor_up_fees &&
                    front.number.front_number_decor_up_fees > 0
                ) {
                    const count = parseInt(
                        front.number.front_number_count || 0
                    );
                    const totalFee = parseFloat(
                        front.number.front_number_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        front.number.front_number_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Front Number Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }
            }

            // Back location
            if (location === "back" && selectedNameNumber.back) {
                const back = selectedNameNumber.back;

                // Back Name Fee (use item_prices first so pricing correct when VendorFees not loaded)
                if (
                    back.name &&
                    typeof back.name === "object" &&
                    back.name.back_name_count &&
                    parseInt(back.name.back_name_count || 0) > 0
                ) {
                    const count = parseInt(back.name.back_name_count || 0);
                    const totalFee = parseFloat(back.name.back_name_fees || 0);
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : nameFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Back Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (nameFeePerItem !== null && nameFeePerItem > 0) {
                        const total = count * nameFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Back Name Fee",
                                qty: count,
                                amt: nameFeePerItem,
                                total
                            });
                        }
                    }
                }

                // Back Name Decor Up Fee (always from item_prices, not from VendorFees)
                if (
                    back.name &&
                    typeof back.name === "object" &&
                    back.name.back_name_decor_up_fees !== undefined &&
                    parseFloat(back.name.back_name_decor_up_fees || 0) > 0
                ) {
                    const count = parseInt(back.name.back_name_count || 0);
                    const totalFee = parseFloat(
                        back.name.back_name_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        back.name.back_name_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Back Name Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Back Number Fee (use item_prices first so pricing correct when VendorFees not loaded)
                if (
                    back.number &&
                    typeof back.number === "object" &&
                    back.number.back_number_count &&
                    parseInt(back.number.back_number_count || 0) > 0
                ) {
                    const count = parseInt(back.number.back_number_count || 0);
                    const totalFee = parseFloat(
                        back.number.back_number_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : numberFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Back Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (
                        numberFeePerItem !== null &&
                        numberFeePerItem > 0
                    ) {
                        const total = count * numberFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Back Number Fee",
                                qty: count,
                                amt: numberFeePerItem,
                                total
                            });
                        }
                    }
                }

                // Back Number Decor Up Fee (always from item_prices, not from VendorFees)
                if (
                    back.number &&
                    typeof back.number === "object" &&
                    back.number.back_number_decor_up_fees !== undefined &&
                    parseFloat(back.number.back_number_decor_up_fees || 0) > 0
                ) {
                    const count = parseInt(back.number.back_number_count || 0);
                    const totalFee = parseFloat(
                        back.number.back_number_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        back.number.back_number_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Back Number Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }
            }

            // Left location (use item_prices first so pricing is correct on Cart Summary when VendorFees may not be loaded)
            if (location === "left" && selectedNameNumber.left) {
                const left = selectedNameNumber.left;
                if (
                    left.name &&
                    typeof left.name === "object" &&
                    left.name.left_name_count &&
                    parseInt(left.name.left_name_count || 0) > 0
                ) {
                    const count = parseInt(left.name.left_name_count || 0);
                    const totalFee = parseFloat(left.name.left_name_fees || 0);
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : nameFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Left Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (nameFeePerItem !== null && nameFeePerItem > 0) {
                        const total = count * nameFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Left Name Fee",
                                qty: count,
                                amt: nameFeePerItem,
                                total
                            });
                        }
                    }
                }
                if (
                    left.number &&
                    typeof left.number === "object" &&
                    left.number.left_number_count &&
                    parseInt(left.number.left_number_count || 0) > 0
                ) {
                    const count = parseInt(left.number.left_number_count || 0);
                    const totalFee = parseFloat(
                        left.number.left_number_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : numberFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Left Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (
                        numberFeePerItem !== null &&
                        numberFeePerItem > 0
                    ) {
                        const total = count * numberFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Left Number Fee",
                                qty: count,
                                amt: numberFeePerItem,
                                total
                            });
                        }
                    }
                }
            }

            // Right location (use item_prices first so pricing is correct on Cart Summary)
            if (location === "right" && selectedNameNumber.right) {
                const right = selectedNameNumber.right;
                if (
                    right.name &&
                    typeof right.name === "object" &&
                    right.name.right_name_count &&
                    parseInt(right.name.right_name_count || 0) > 0
                ) {
                    const count = parseInt(right.name.right_name_count || 0);
                    const totalFee = parseFloat(
                        right.name.right_name_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : nameFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Right Name Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (nameFeePerItem !== null && nameFeePerItem > 0) {
                        const total = count * nameFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Right Name Fee",
                                qty: count,
                                amt: nameFeePerItem,
                                total
                            });
                        }
                    }
                }
                if (
                    right.number &&
                    typeof right.number === "object" &&
                    right.number.right_number_count &&
                    parseInt(right.number.right_number_count || 0) > 0
                ) {
                    const count = parseInt(
                        right.number.right_number_count || 0
                    );
                    const totalFee = parseFloat(
                        right.number.right_number_fees || 0
                    );
                    const perPrice =
                        totalFee > 0 && count > 0
                            ? totalFee / count
                            : numberFeePerItem || 0;
                    if (totalFee > 0) {
                        fees.push({
                            name: "Right Number Fee",
                            qty: count,
                            amt: perPrice,
                            total: totalFee
                        });
                    } else if (
                        numberFeePerItem !== null &&
                        numberFeePerItem > 0
                    ) {
                        const total = count * numberFeePerItem;
                        if (total > 0) {
                            fees.push({
                                name: "Right Number Fee",
                                qty: count,
                                amt: numberFeePerItem,
                                total
                            });
                        }
                    }
                }
            }

            return fees;
        },

        // Get color-size combinations for display (always fetch fresh from Cart component)
        getColorSizeCombinationsForDisplay(item, parentItem = null) {
            if (!item) return [];

            // Always try to get fresh data from Cart component first
            // Try multiple ways to access Cart component
            let colorSizeCombinations = [];
            let cartComponent = null;

            // Method 1: Try window.CartV3Component (stored globally by Cart component)
            if (typeof window !== "undefined" && window.CartV3Component) {
                cartComponent = window.CartV3Component;
            }

            // Method 2: Try $root.$children (if on same page)
            if (!cartComponent && this.$root && this.$root.$children) {
                cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" ||
                        comp.$options.name === "shopping-cart" ||
                        comp.getColorSizeCombinations
                );
            }

            if (cartComponent && cartComponent.getColorSizeCombinations) {
                colorSizeCombinations =
                    cartComponent.getColorSizeCombinations(item, parentItem);
            }

            // If not available from Cart component, use local calculation
            if (!colorSizeCombinations || colorSizeCombinations.length === 0) {
                colorSizeCombinations = this.getColorSizeCombinations(
                    item,
                    parentItem
                );
            }

            // IMPORTANT: For decoration type 0 (PCNA), add included services to each combination
            // Cart component's getColorSizeCombinations doesn't include included services for type 0
            // This matches ToolTip component logic where included services are added
            if (
                colorSizeCombinations &&
                colorSizeCombinations.length > 0 &&
                (item.decoration_type === 0 || item.decoration_type === "0")
            ) {
                // Get included services unit price
                let decoration = item.decoration;
                if (decoration && typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        decoration = null;
                    }
                }

                const otherServices =
                    decoration && decoration.other_services_list
                        ? decoration.other_services_list
                        : [];
                const baseFeeServices = otherServices.filter(
                    (s) => s.rollup_fee_id === 1 || s.rollup_fee_id === "1"
                );

                let includedServicesUnitPrice = 0;
                if (baseFeeServices && baseFeeServices.length > 0) {
                    baseFeeServices.forEach((service) => {
                        const showService =
                            service.show_service !== undefined
                                ? service.show_service
                                : true;
                        if (!showService) {
                            const serviceUnitPrice = parseFloat(
                                service.retail_cost || service.net_cost || 0
                            );
                            includedServicesUnitPrice += serviceUnitPrice;
                        }
                    });
                }

                // Add included services to each combination's cost
                if (includedServicesUnitPrice > 0) {
                    colorSizeCombinations = colorSizeCombinations.map(
                        (combination) => {
                            // Only add if not already included (check flag)
                            if (
                                combination._includesIncludedServices !== true
                            ) {
                                const updatedCost =
                                    parseFloat(combination.cost || 0) +
                                    includedServicesUnitPrice;
                                return {
                                    ...combination,
                                    cost: updatedCost,
                                    total_cost:
                                        updatedCost *
                                        parseInt(combination.quantity || 0),
                                    _includesIncludedServices: true
                                };
                            }
                            return combination;
                        }
                    );
                }
            }

            return colorSizeCombinations;
        },

        // Get color-size combinations from cart item
        getColorSizeCombinations(item, parentItem = null) {
            if (
                !item ||
                !item.CartChildItems ||
                !Array.isArray(item.CartChildItems)
            ) {
                return [];
            }

            const combinations = [];

            // Group CartChildItems by color_id
            const colorGroups = {};
            item.CartChildItems.forEach((childItem) => {
                const mainProduct = childItem.main_new_sub_product;
                const colorObj = mainProduct && mainProduct.Color;
                const colorId =
                    childItem.color_id ||
                    (colorObj && colorObj.id) ||
                    (colorObj && colorObj.color_id);
                if (!colorId) return;

                if (!colorGroups[colorId]) {
                    colorGroups[colorId] = {
                        color_id: colorId,
                        color_name:
                            (colorObj && colorObj.name) ||
                            (colorObj && colorObj.color_name) ||
                            "Color",
                        color_value:
                            (colorObj && colorObj.color_value) ||
                            (colorObj && colorObj.hex) ||
                            (colorObj && colorObj.hash) ||
                            "#cccccc",
                        sizes: []
                    };
                }

                // Extract size information
                const sizeObj = mainProduct && mainProduct.Size;
                if (sizeObj) {
                    let sizeAbbr = "N/A";
                    if (sizeObj.size_name) {
                        sizeAbbr = sizeObj.size_name;
                    } else if (sizeObj.size) {
                        const sizeParts = sizeObj.size.trim().split(/\s+/);
                        sizeAbbr = sizeParts[sizeParts.length - 1];
                    } else if (sizeObj.name) {
                        const nameParts = sizeObj.name.trim().split(/\s+/);
                        sizeAbbr = nameParts[nameParts.length - 1];
                    }

                    const quantity = parseInt(childItem.quantity) || 0;
                    if (quantity > 0) {
                        let calculatedUnitPrice = 0;

                        // For decoration type 0 (PCNA), calculate tiers directly in CartSummary
                        // Same logic as Cart component's getBaseUnitPriceFromTiers
                        if (
                            item.decoration_type === 0 ||
                            item.decoration_type === "0"
                        ) {
                            // Calculate base unit price from tiers directly (same as Cart component)
                            const totalQuantity = this.getTierQuantityForItem(
                                item,
                                parentItem
                            );
                            let baseUnitPriceFromTiers = 0;

                            try {
                                // Check if decoration.price_decoration_bulk exists
                                let decoration = item.decoration;
                                if (
                                    decoration &&
                                    typeof decoration === "string"
                                ) {
                                    try {
                                        decoration = JSON.parse(decoration);
                                    } catch (e) {
                                        decoration = null;
                                    }
                                }

                                const decorationBulk =
                                    decoration &&
                                    decoration.price_decoration_bulk
                                        ? decoration.price_decoration_bulk
                                        : null;

                                if (decorationBulk) {
                                    // For decoration type 0, price_decoration_bulk is typically an array
                                    if (Array.isArray(decorationBulk)) {
                                        for (const [
                                            index,
                                            element
                                        ] of Object.entries(decorationBulk)) {
                                            if (
                                                element.quantity <=
                                                    totalQuantity ||
                                                index == 0
                                            ) {
                                                baseUnitPriceFromTiers =
                                                    parseFloat(
                                                        element.retail_cost ||
                                                            element.cost ||
                                                            0
                                                    );
                                            }
                                        }
                                    }
                                }
                            } catch (e) {
                                baseUnitPriceFromTiers =
                                    totalQuantity > 0
                                        ? parseFloat(item.subtotal_price || 0) /
                                          totalQuantity
                                        : 0;
                            }

                            const finalBasePrice =
                                baseUnitPriceFromTiers ||
                                (totalQuantity > 0
                                    ? parseFloat(item.subtotal_price || 0) /
                                      totalQuantity
                                    : 0);

                            calculatedUnitPrice = finalBasePrice;

                            // IMPORTANT: Add included services unit price for decoration type 0
                            // This matches ToolTip component logic where included services are added to unit price
                            let decoration = item.decoration;
                            if (decoration && typeof decoration === "string") {
                                try {
                                    decoration = JSON.parse(decoration);
                                } catch (e) {
                                    decoration = null;
                                }
                            }

                            const otherServices =
                                decoration && decoration.other_services_list
                                    ? decoration.other_services_list
                                    : [];
                            const baseFeeServices = otherServices.filter(
                                (s) =>
                                    s.rollup_fee_id === 1 ||
                                    s.rollup_fee_id === "1"
                            );

                            if (baseFeeServices && baseFeeServices.length > 0) {
                                baseFeeServices.forEach((service) => {
                                    // Included services: show_service = false
                                    const showService =
                                        service.show_service !== undefined
                                            ? service.show_service
                                            : true;
                                    if (!showService) {
                                        const serviceUnitPrice = parseFloat(
                                            service.retail_cost ||
                                                service.net_cost ||
                                                0
                                        );
                                        calculatedUnitPrice += serviceUnitPrice;
                                    }
                                });
                            }

                            // Apply product discount (same as Cart.vue)
                            calculatedUnitPrice = this.applyDiscountToSizeCost(
                                calculatedUnitPrice,
                                item
                            );
                        } else if (
                            item.decoration_type == 1 ||
                            item.decoration_type == 5 ||
                            item.decoration_type == 2 ||
                            item.decoration_type == 4
                        ) {
                            // Decoration type 1 (Screen Print) and 2/4 (Embroidery-like)
                            // Apply same logic as Cart.vue - calculate from base + markup + location + color category
                            try {
                                // Get base price and markup from current childItem
                                const basePrice = parseFloat(
                                    childItem.case_price || 0
                                );
                                const markupPrice = parseFloat(
                                    this.getChildMarkupPrice(item, childItem)
                                );

                                // Get single location price from decoration tiers based on total quantity
                                const bulkData =
                                    this.getEffectivePriceDecorationBulk(item);

                                let singleLocationPrice = 0;
                                const totalQuantity =
                                    this.getTierQuantityForItem(
                                        item,
                                        parentItem
                                    );

                                if (
                                    item.decoration_type == 1 ||
                                    item.decoration_type == 5
                                ) {
                                    // Screen Print: get from print_location1
                                    if (bulkData && bulkData.print_location1) {
                                        const location1Data =
                                            bulkData.print_location1;
                                        for (const [
                                            index,
                                            element
                                        ] of Object.entries(location1Data)) {
                                            if (
                                                element.quantity <=
                                                    totalQuantity ||
                                                index == 0
                                            ) {
                                                singleLocationPrice =
                                                    parseFloat(
                                                        element.colour1 || 0
                                                    );
                                            }
                                        }
                                    }
                                } else if (
                                    item.decoration_type == 2 ||
                                    item.decoration_type == 4
                                ) {
                                    // Embroidery/Patch: get from quantity slabs array
                                    if (bulkData && Array.isArray(bulkData)) {
                                        for (const [
                                            index,
                                            element
                                        ] of Object.entries(bulkData)) {
                                            if (
                                                element.quantity1 <=
                                                    totalQuantity ||
                                                index == 0
                                            ) {
                                                singleLocationPrice =
                                                    parseFloat(
                                                        element.cost || 0
                                                    );
                                            }
                                        }
                                    }
                                }

                                // Get color category price (dark/light fee) from decoration for this specific color
                                let colorCategory = null;
                                if (colorObj) {
                                    colorCategory =
                                        colorObj.category ||
                                        colorObj.color_category ||
                                        (colorObj.Color &&
                                            colorObj.Color.category) ||
                                        (mainProduct &&
                                            mainProduct.Color &&
                                            mainProduct.Color.category);
                                }

                                let colorCategoryPrice = 0;
                                // Keep CartSummary aligned with Cart realtime fee source.
                                let decoration = item.decoration;
                                if (
                                    decoration &&
                                    typeof decoration === "string"
                                ) {
                                    try {
                                        decoration = JSON.parse(decoration);
                                    } catch (e) {
                                        decoration = null;
                                    }
                                }

                                let feeSource =
                                    decoration ||
                                    item.decoration_template_data ||
                                    null;
                                if (
                                    !feeSource &&
                                    item.main_new_product &&
                                    item.main_new_product.decoration_price_type ===
                                        "custom_price"
                                ) {
                                    feeSource = {
                                        price_dark:
                                            item.main_new_product
                                                .price_color_category_dark || 0,
                                        price_light:
                                            item.main_new_product
                                                .price_color_category_light || 0
                                    };
                                }

                                if (feeSource && colorCategory) {
                                    if (
                                        colorCategory === "Dark" ||
                                        colorCategory === "dark"
                                    ) {
                                        colorCategoryPrice = parseFloat(
                                            feeSource.price_dark || 0
                                        );
                                    } else if (
                                        colorCategory === "Light" ||
                                        colorCategory === "light"
                                    ) {
                                        colorCategoryPrice = parseFloat(
                                            feeSource.price_light || 0
                                        );
                                    }
                                }

                                // Get decoration discount percentage
                                // Try to get from Cart component if available
                                let decorationDiscount = 0;
                                if (this.$root && this.$root.$children) {
                                    const cartComponent =
                                        this.$root.$children.find(
                                            (comp) =>
                                                comp.$options.name ===
                                                    "CartV3" ||
                                                comp.getDecorationDiscount
                                        );
                                    if (
                                        cartComponent &&
                                        cartComponent.getDecorationDiscount
                                    ) {
                                        decorationDiscount =
                                            cartComponent.getDecorationDiscount(
                                                item,
                                                totalQuantity,
                                                false
                                            );
                                    }
                                }

                                // Fallback for checkout flow where CartV3 component is not mounted:
                                // resolve template slab discount directly from item.price_decoration_bulk.
                                if (!decorationDiscount) {
                                    try {
                                        const bulkData =
                                            this.getEffectivePriceDecorationBulk(
                                                item
                                            );

                                        if (
                                            (item.decoration_type == 2 ||
                                                item.decoration_type == 4) &&
                                            Array.isArray(bulkData)
                                        ) {
                                            let selectedRow = null;
                                            for (const row of bulkData) {
                                                if (
                                                    totalQuantity >=
                                                        parseInt(
                                                            row.quantity1 || 0
                                                        ) &&
                                                    totalQuantity <=
                                                        parseInt(
                                                            row.quantity2 || 0
                                                        )
                                                ) {
                                                    selectedRow = row;
                                                    break;
                                                }
                                            }
                                            if (
                                                !selectedRow &&
                                                bulkData.length > 0
                                            ) {
                                                selectedRow =
                                                    bulkData[
                                                        bulkData.length - 1
                                                    ];
                                            }
                                            decorationDiscount = parseFloat(
                                                (selectedRow &&
                                                    selectedRow.discount) ||
                                                    0
                                            );
                                        } else if (
                                            (item.decoration_type == 1 ||
                                                item.decoration_type == 5) &&
                                            bulkData &&
                                            bulkData.print_location1
                                        ) {
                                            const rows = bulkData.print_location1;
                                            let selectedRow = null;
                                            for (const row of rows) {
                                                if (
                                                    totalQuantity >=
                                                    parseInt(row.quantity || 0)
                                                ) {
                                                    selectedRow = row;
                                                } else {
                                                    break;
                                                }
                                            }
                                            if (!selectedRow && rows.length > 0) {
                                                selectedRow = rows[0];
                                            }
                                            decorationDiscount = parseFloat(
                                                (selectedRow &&
                                                    selectedRow.discount) ||
                                                    0
                                            );
                                        }
                                    } catch (e) {
                                        // Keep default 0 if bulk parsing fails.
                                        decorationDiscount = 0;
                                    }
                                }

                                // Calculate unit price: base + markup + single location + color category
                                calculatedUnitPrice =
                                    basePrice +
                                    markupPrice +
                                    singleLocationPrice +
                                    colorCategoryPrice;

                                // OLD BEHAVIOR (kept for future rollback):
                                // Decoration discount was applied only on singleLocationPrice.
                                // if (decorationDiscount > 0) {
                                //     const decorationDiscountValue =
                                //         (formatPrice(singleLocationPrice) *
                                //             decorationDiscount) /
                                //         100;
                                //     calculatedUnitPrice -=
                                //         decorationDiscountValue;
                                // }

                                // Apply decoration discount on combined Product Base Price.
                                if (decorationDiscount > 0) {
                                    // Try to get icPriceFormat from Cart component
                                    let formatPrice = (price) => price;
                                    if (this.$root && this.$root.$children) {
                                        const cartComponent =
                                            this.$root.$children.find(
                                                (comp) =>
                                                    comp.$options.name ===
                                                        "CartV3" ||
                                                    comp.icPriceFormat
                                            );
                                        if (
                                            cartComponent &&
                                            cartComponent.icPriceFormat
                                        ) {
                                            formatPrice = (price) =>
                                                cartComponent.icPriceFormat(
                                                    price,
                                                    true
                                                );
                                        }
                                    }

                                    const decorationDiscountValue =
                                        (formatPrice(calculatedUnitPrice) *
                                            decorationDiscount) /
                                        100;
                                    calculatedUnitPrice -=
                                        decorationDiscountValue;
                                }

                                // Apply product discount (same as Cart.vue)
                                calculatedUnitPrice =
                                    this.applyDiscountToSizeCost(
                                        calculatedUnitPrice,
                                        item
                                    );
                            } catch (e) {
                                console.error(
                                    "Error calculating unit price for decoration type " +
                                        item.decoration_type +
                                        ":",
                                    e
                                );
                                // Final fallback: use total_price / quantity
                                calculatedUnitPrice =
                                    parseFloat(childItem.total_price || 0) /
                                    quantity;
                                // Apply product discount to fallback price as well
                                calculatedUnitPrice =
                                    this.applyDiscountToSizeCost(
                                        calculatedUnitPrice,
                                        item
                                    );
                            }
                        } else {
                            // For other decoration types, use childItem.unit_price or total_price / quantity
                            calculatedUnitPrice = parseFloat(
                                childItem.unit_price || 0
                            );
                            if (calculatedUnitPrice === 0) {
                                calculatedUnitPrice =
                                    parseFloat(childItem.total_price || 0) /
                                    quantity;
                            }
                            // Apply product discount to fallback price as well
                            calculatedUnitPrice = this.applyDiscountToSizeCost(
                                calculatedUnitPrice,
                                item
                            );
                        }

                        colorGroups[colorId].sizes.push({
                            size: sizeAbbr,
                            quantity: quantity,
                            cost: calculatedUnitPrice,
                            total_cost: calculatedUnitPrice * quantity
                        });
                    }
                }
            });

            // Convert grouped data to combinations array
            Object.values(colorGroups).forEach((colorGroup) => {
                colorGroup.sizes.forEach((size) => {
                    // Ensure color value has # prefix
                    let colorValue = colorGroup.color_value || "";
                    if (colorValue && !colorValue.startsWith("#")) {
                        colorValue = "#" + colorValue;
                    }
                    if (!colorValue) {
                        colorValue = "#cccccc";
                    }

                    combinations.push({
                        color_id: colorGroup.color_id,
                        color_name: colorGroup.color_name,
                        color_value: colorValue,
                        hex: colorValue,
                        size: size.size,
                        quantity: size.quantity,
                        cost: size.cost,
                        total_cost: size.total_cost
                    });
                });
            });

            return combinations;
        },

        // Check if item is part of a grouped decoration type 0, 1, or 2
        isGroupedDecorationType0(item) {
            if (!item || !item.subItems || item.subItems.length === 0) {
                return false;
            }

            const cartComponent = this.resolveCartVueComponent();
            if (cartComponent && cartComponent.isGroupedDecorationType0) {
                return cartComponent.isGroupedDecorationType0(item);
            }

            // Basic check: if item has subItems and decoration_type is 0, 1, or 2
            return (
                (item.decoration_type === 0 ||
                    item.decoration_type === 1 ||
                    item.decoration_type === 2 ||
                    item.decoration_type === 4) &&
                item.subItems &&
                item.subItems.length > 0
            );
        },

        // Get combined color mix fee services from all subItems
        getCombinedColorMixFeeServices(item) {
            if (!item || !item.subItems || item.subItems.length === 0) {
                return [];
            }

            const cartComponent = this.resolveCartVueComponent();
            if (
                cartComponent &&
                cartComponent.getCombinedColorMixFeeServices
            ) {
                return cartComponent.getCombinedColorMixFeeServices(item);
            }

            const allServices = [];
            const pushCopies = (groupItem, isParentLine) => {
                const services =
                    this.getColorMixFeeServicesFromItem(groupItem);
                if (!services || services.length === 0) return;
                const itemQuantity = this.getTotalItemQuantity(groupItem);
                services.forEach((service) => {
                    if (
                        !isParentLine &&
                        !this.isPrimaryCustomColorRollupService(service)
                    ) {
                        return;
                    }
                    const serviceCopy = { ...service };
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        serviceCopy._calculatedTotal =
                            parseFloat(servicePrice) * itemQuantity;
                        serviceCopy._quantity = itemQuantity;
                    } else {
                        serviceCopy._calculatedTotal =
                            parseFloat(servicePrice);
                        serviceCopy._quantity = 1;
                    }
                    allServices.push(serviceCopy);
                });
            };

            if (this.isAssemblyGroup(item)) {
                this.getAssemblyGroupedItems(item).forEach((groupItem, idx) => {
                    pushCopies(groupItem, idx === 0);
                });
            } else {
                item.subItems.forEach((subItem) => {
                    pushCopies(subItem, true);
                });
            }
            return allServices;
        },

        // Get combined color mix fee data for grouped items
        getCombinedColorMixFeeData(item) {
            if (!item || !item.subItems || item.subItems.length === 0) {
                return null;
            }

            const cartCompData = this.resolveCartVueComponent();
            if (cartCompData && cartCompData.getCombinedColorMixFeeData) {
                return cartCompData.getCombinedColorMixFeeData(item);
            }

            // Fallback: Try to get combined unique colors and calculate
            // First, try to get from Cart component's getCombinedUniqueNonStandardColors
            let mixColorCount = 0;
            if (this.$root && this.$root.$children) {
                const cartComponent = this.resolveCartVueComponent();
                if (
                    cartComponent &&
                    cartComponent.getCombinedUniqueNonStandardColors
                ) {
                    mixColorCount =
                        cartComponent.getCombinedUniqueNonStandardColors(item);
                } else {
                    // Fallback: combine unique colors from parent + all subItems (matching Cart.vue logic)
                    const uniqueColors = new Set();
                    const groupedItems = [item, ...(item.subItems || [])];

                    groupedItems.forEach((groupItem) => {
                        // For decoration type 1 and 2, use non_standard_colors array
                        if (
                            groupItem.decoration_type === 1 ||
                            groupItem.decoration_type === 2 ||
                            groupItem.decoration_type === 4
                        ) {
                            let nonStandardColors =
                                groupItem.non_standard_colors;
                            if (typeof nonStandardColors === "string") {
                                try {
                                    nonStandardColors =
                                        JSON.parse(nonStandardColors);
                                } catch (e) {
                                    return;
                                }
                            }

                            if (
                                nonStandardColors &&
                                Array.isArray(nonStandardColors)
                            ) {
                                nonStandardColors.forEach((colorHex) => {
                                    if (
                                        colorHex &&
                                        typeof colorHex === "string"
                                    ) {
                                        const colorKey = colorHex.toLowerCase();
                                        if (
                                            colorKey &&
                                            colorKey !== "#gggggg" &&
                                            colorKey !== ""
                                        ) {
                                            uniqueColors.add(colorKey);
                                        }
                                    }
                                });
                            }
                        } else if (groupItem.decoration_type === 0) {
                            // For decoration type 0 (PCNA), use imprint_locations
                            let imprintLocations = groupItem.imprint_locations;
                            if (typeof imprintLocations === "string") {
                                try {
                                    imprintLocations =
                                        JSON.parse(imprintLocations);
                                } catch (e) {
                                    return;
                                }
                            }

                            if (
                                !imprintLocations ||
                                !Array.isArray(imprintLocations)
                            ) {
                                return;
                            }

                            imprintLocations.forEach((location) => {
                                if (
                                    location &&
                                    location.is_selected &&
                                    location.colors &&
                                    Array.isArray(location.colors)
                                ) {
                                    location.colors.forEach((colorObj) => {
                                        if (colorObj && colorObj.color) {
                                            const color = colorObj.color;
                                            const colorId = parseInt(
                                                color.color_id || 0
                                            );

                                            // Check if it's a non-standard color (color_id == 0)
                                            if (colorId === 0) {
                                                // Use color_value or hex as unique identifier
                                                const colorKey = (
                                                    color.color_value ||
                                                    color.hex ||
                                                    ""
                                                ).toLowerCase();
                                                if (
                                                    colorKey &&
                                                    colorKey !== "#gggggg" &&
                                                    colorKey !== ""
                                                ) {
                                                    uniqueColors.add(colorKey);
                                                }
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    });

                    mixColorCount = uniqueColors.size;
                }
            }

            // Get fee per color from first item's decoration
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return null;
                }
            }

            // Check if decoration is null or undefined
            if (!decoration || typeof decoration !== "object") {
                return null;
            }

            // Get fee per color - prioritize VendorFees (real-time) over decoration.color_mix_fee
            let feePerColor = 0;

            // First, try to get from VendorFees (real-time update from API)
            if (
                item.main_new_product &&
                item.main_new_product.VendorFees &&
                Array.isArray(item.main_new_product.VendorFees)
            ) {
                const vendorFees = item.main_new_product.VendorFees;
                let targetService = null;

                const colorType = this.getNormalizedColorTypeFromDecoration(
                    decoration
                );
                const isThread = colorType === "thread";
                const isInk = colorType === "ink";
                if (!isThread && !isInk) return null;

                if (isThread) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("thread mix fee")))
                    );
                } else if (isInk) {
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("ink mix fee")))
                    );
                } 

                if (targetService && targetService.retail_cost) {
                    feePerColor = parseFloat(targetService.retail_cost) || 0;
                }
            }

            // NO FALLBACK - Only use VendorFees with rollup_fee_id
            // If VendorFees not available or fee is 0, feePerColor remains 0

            if (!feePerColor || feePerColor <= 0 || mixColorCount <= 0) {
                return null;
            }

            // Calculate total
            const total = mixColorCount * feePerColor;

            // Determine label
            let feeLabel = "Custom Color Fee";
            let breakdownLabel = "Custom Color Ink Fee";

            const colorType =
                this.getNormalizedColorTypeFromDecoration(decoration);
            if (colorType === "thread") {
                breakdownLabel = "Custom Color Thread Fee";
            }

            const result = {
                label: feeLabel,
                breakdownLabel: breakdownLabel,
                mixColorCount: mixColorCount,
                unitPrice: feePerColor,
                total: total
            };

            return result;
        },

        // Check if grouped items have color mix fee services
        hasCombinedColorMixFeeServices(item) {
            if (!item || !item.subItems || item.subItems.length === 0) {
                return false;
            }
            const cartComponent = this.resolveCartVueComponent();
            if (
                cartComponent &&
                cartComponent.hasCombinedColorMixFeeServices
            ) {
                return cartComponent.hasCombinedColorMixFeeServices(item);
            }
            if (this.isAssemblyGroup(item)) {
                const groupedItems = this.getAssemblyGroupedItems(item);
                return groupedItems.some((groupItem, idx) => {
                    const services =
                        this.getColorMixFeeServicesFromItem(groupItem);
                    if (!services || services.length === 0) return false;
                    if (idx === 0) return true;
                    return services.some((s) =>
                        this.isPrimaryCustomColorRollupService(s)
                    );
                });
            }
            return item.subItems.some((subItem) => {
                const services =
                    this.getColorMixFeeServicesFromItem(subItem);
                return services && services.length > 0;
            });
        },

        // Get combined color mix fee total for grouped items
        getCombinedColorMixFeeTotal(item) {
            if (!item || !item.subItems || item.subItems.length === 0) {
                return 0;
            }

            const cartComponent = this.resolveCartVueComponent();
            if (
                cartComponent &&
                cartComponent.getCombinedColorMixFeeTotal
            ) {
                return cartComponent.getCombinedColorMixFeeTotal(item);
            }

            let total = 0;
            const mixFeeData = this.getCombinedColorMixFeeData(item);
            if (mixFeeData && mixFeeData.total > 0) {
                total += parseFloat(mixFeeData.total);
            }

            const addServicesTotal = (groupItem, isParentLine) => {
                const services =
                    this.getColorMixFeeServicesFromItem(groupItem);
                if (!services || services.length === 0) return;
                const quantity = this.getTotalItemQuantity(groupItem);
                services.forEach((service) => {
                    if (
                        !isParentLine &&
                        !this.isPrimaryCustomColorRollupService(service)
                    ) {
                        return;
                    }
                    const servicePrice =
                        service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === "Per Item") {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            };

            if (this.isAssemblyGroup(item)) {
                this.getAssemblyGroupedItems(item).forEach((groupItem, idx) => {
                    addServicesTotal(groupItem, idx === 0);
                });
            } else if (item.subItems && item.subItems.length > 0) {
                item.subItems.forEach((subItem) => {
                    addServicesTotal(subItem, true);
                });
            }

            return parseFloat(total.toFixed(2));
        },

        // Get item subtotal excluding color mix fee (for grouped items)
        // This matches Cart.vue's getItemSubTotalExcludingColorMixFee logic
        getItemSubTotalExcludingColorMixFee(item, parentItem = null) {
            const cartComponent = this.resolveCartVueComponent();
            if (
                cartComponent &&
                cartComponent.getItemSubTotalExcludingColorMixFee
            ) {
                const cartValue =
                    cartComponent.getItemSubTotalExcludingColorMixFee(
                        item,
                        parentItem
                    );
                if (cartValue !== undefined && cartValue !== null) {
                    return parseFloat(cartValue || 0);
                }
            }

            // Fallback: calculate locally using same logic as Cart.vue
            const displayData = this.getItemDisplayData(item, parentItem);
            if (!displayData) return 0;

            let excludedTotal =
                displayData.baseFeeTotal +
                displayData.runChargeTotal +
                displayData.setupFeeTotal +
                displayData.rushFeeTotal; // Include rush fee

            excludedTotal += this.getDynamicPatchCostTotal(item);

            // Name/Number fees (only for decoration type 1 and 2, as type 0 includes them in run charge)
            if (item.decoration_type != 0) {
                const itemPrices = item.item_prices || {};
                excludedTotal +=
                    parseFloat(itemPrices.front_number_fees || 0) +
                    parseFloat(itemPrices.back_name_fees || 0) +
                    parseFloat(itemPrices.back_number_fees || 0) +
                    parseFloat(itemPrices.front_name_fees || 0) +
                    parseFloat(itemPrices.front_number_decor_up_fees || 0) +
                    parseFloat(itemPrices.back_name_decor_up_fees || 0) +
                    parseFloat(itemPrices.back_number_decor_up_fees || 0);
            }

            return parseFloat(excludedTotal.toFixed(2));
        },

        // Get subItem Item Sub Total (without discount)
        // For grouped items, excludes color mix fee
        // For non-grouped items, includes all fees
        getSubItemSubTotal(subItem, parentItem) {
            const cartComponent = this.resolveCartVueComponent();
            if (cartComponent && cartComponent.getItemSubTotal) {
                return parseFloat(
                    cartComponent.getItemSubTotal(subItem, parentItem) || 0
                );
            }

            // Fallback: use local calculation
            if (this.isGroupedDecorationType0(parentItem)) {
                let sub = this.getItemSubTotalExcludingColorMixFee(
                    subItem,
                    parentItem
                );
                if (parentItem && this.isAssemblyGroup(parentItem)) {
                    sub += this.getOtherColorMixFeeRollupTotalFromItem(subItem);
                }
                return sub;
            } else {
                const displayData = this.getItemDisplayData(subItem, parentItem);
                return displayData
                    ? displayData.itemSubTotal
                    : parseFloat(subItem.total_price || 0);
            }
        },

        // Get subItem total (Item Sub Total - Discount)
        // This method handles both grouped and non-grouped items correctly
        getSubItemTotal(subItem, parentItem) {
            const cartComponent = this.resolveCartVueComponent();
            if (cartComponent && cartComponent.getItemSubTotal) {
                const subItemSubTotal = parseFloat(
                    cartComponent.getItemSubTotal(subItem, parentItem) || 0
                );
                const subItemDiscount = this.getItemDiscount(
                    subItem,
                    parentItem
                );
                return subItemDiscount > 0
                    ? subItemSubTotal - subItemDiscount
                    : subItemSubTotal;
            }

            let subItemSubTotal = 0;
            if (this.isGroupedDecorationType0(parentItem)) {
                subItemSubTotal = this.getItemSubTotalExcludingColorMixFee(
                    subItem,
                    parentItem
                );
                if (parentItem && this.isAssemblyGroup(parentItem)) {
                    subItemSubTotal += this.getOtherColorMixFeeRollupTotalFromItem(
                        subItem
                    );
                }
            } else {
                const displayData = this.getItemDisplayData(subItem, parentItem);
                subItemSubTotal = displayData
                    ? displayData.itemSubTotal
                    : parseFloat(subItem.total_price || 0);
            }

            const subItemDiscount = this.getItemDiscount(subItem, parentItem);
            return subItemDiscount > 0
                ? subItemSubTotal - subItemDiscount
                : subItemSubTotal;
        },

        // Get Item Sub Total for grouped parent item (includes combined color mix fee)
        getItemSubTotalForGroupedParent(item) {
            if (!this.isGroupedDecorationType0(item)) {
                const displayData = this.getItemDisplayData(item);
                return displayData ? displayData.itemSubTotal : 0;
            }

            const cartComponent = this.resolveCartVueComponent();
            if (
                cartComponent &&
                cartComponent.getItemSubTotalForGroupedParent
            ) {
                const cartValue =
                    cartComponent.getItemSubTotalForGroupedParent(item);
                if (cartValue && cartValue > 0) {
                    return parseFloat(cartValue);
                }
            }

            let parentSubTotal = 0;
            let combinedColorMixFee = 0;

            const cartComp2 = this.resolveCartVueComponent();
            if (cartComp2) {
                if (cartComp2.getItemSubTotalExcludingColorMixFee) {
                    parentSubTotal = parseFloat(
                        cartComp2.getItemSubTotalExcludingColorMixFee(item) ||
                            0
                    );
                }
                if (cartComp2.getCombinedColorMixFeeTotal) {
                    combinedColorMixFee = parseFloat(
                        cartComp2.getCombinedColorMixFeeTotal(item) || 0
                    );
                }
            }

            if (parentSubTotal === 0) {
                parentSubTotal = this.getItemSubTotalExcludingColorMixFee(item);
            }
            if (combinedColorMixFee === 0) {
                combinedColorMixFee = this.getCombinedColorMixFeeTotal(item);
            }

            return parentSubTotal + combinedColorMixFee;
        },

        // Get item total (Item Sub Total - Discount)
        // For grouped parent items, uses getItemSubTotalForGroupedParent
        // For single items, uses getItemSubTotal
        getItemTotal(item) {
            const cartComponent = this.resolveCartVueComponent();
            if (cartComponent) {
                let itemSubTotal = 0;
                if (
                    this.isGroupedDecorationType0(item) &&
                    item.subItems &&
                    item.subItems.length > 0
                ) {
                    if (cartComponent.getItemSubTotalForGroupedParent) {
                        itemSubTotal = parseFloat(
                            cartComponent.getItemSubTotalForGroupedParent(
                                item
                            ) || 0
                        );
                    }
                } else {
                    if (cartComponent.getItemSubTotal) {
                        itemSubTotal = parseFloat(
                            cartComponent.getItemSubTotal(item) || 0
                        );
                    }
                }
                if (itemSubTotal > 0) {
                    return itemSubTotal;
                }
            }

            // Fallback: use local calculation
            const displayData = this.getItemDisplayData(item);
            if (!displayData) {
                return parseFloat(item.total_price || 0);
            }

            let itemSubTotal = 0;
            if (
                this.isGroupedDecorationType0(item) &&
                item.subItems &&
                item.subItems.length > 0
            ) {
                // For grouped parent items, use getItemSubTotalForGroupedParent
                itemSubTotal = this.getItemSubTotalForGroupedParent(item);
            } else {
                // For single items, use displayData.itemSubTotal
                itemSubTotal = parseFloat(displayData.itemSubTotal || 0);
            }

            // Discount removed - no longer subtracting discount
            return itemSubTotal;
        },

        // Get group subtotal (all items + combined color mix fee)
        getGroupSubTotal(item) {
            if (!this.isGroupedDecorationType0(item)) {
                const displayData = this.getItemDisplayData(item);
                return displayData ? displayData.itemSubTotal : 0;
            }

            // Try to get from Cart component if available
            if (this.$root && this.$root.$children) {
                const cartComponent = this.$root.$children.find(
                    (comp) =>
                        comp.$options.name === "CartV3" || comp.getGroupSubTotal
                );
                if (cartComponent && cartComponent.getGroupSubTotal) {
                    return cartComponent.getGroupSubTotal(item);
                }
            }

            // Fallback: calculate group subtotal
            let total = 0;

            // Add parent item's subtotal (excluding color mix fee)
            const parentSubTotal = this.getItemSubTotalExcludingColorMixFee(
                item
            );
            total += parentSubTotal;
            // Add subtotal for each subItem (excluding individual color mix fees)
            if (item.subItems && item.subItems.length > 0) {
                item.subItems.forEach((subItem) => {
                    const subItemSubTotal =
                        this.getItemSubTotalExcludingColorMixFee(
                            subItem,
                            item
                        );
                    total += subItemSubTotal;
                });
            }

            // Add combined color mix fee (only once for the group)
            const combinedColorMixFee = this.getCombinedColorMixFeeTotal(item);
            total += combinedColorMixFee;

            const finalTotal = parseFloat(total.toFixed(2));
            return finalTotal;
        },

        // Get vendors list (same as Cart.vue)
        getVendorsList() {
            return new Promise((resolve, reject) => {
                ApiService.get(`/vendors`)
                    .then(({ data }) => {
                        if (data.error) {
                            console.error(
                                "Error fetching vendors:",
                                data.error
                            );
                            this.vendors_list = [];
                            resolve([]);
                        } else {
                            this.vendors_list = data.vendors || data || [];
                            // Also expose to window for access from other components
                            if (
                                typeof window !== "undefined" &&
                                window.CartV3Component
                            ) {
                                window.CartV3Component.vendors_list =
                                    this.vendors_list;
                            }
                            resolve(this.vendors_list);
                        }
                    })
                    .catch((error) => {
                        console.error("Error fetching vendors list:", error);
                        this.vendors_list = [];
                        reject(error);
                    });
            });
        },

        // Fetch holidays from admin options (same as Cart.vue)
        async fetchHolidays() {
            try {
                const { data } = await ApiService.get("/get-socialLinks");
                const holidaysLink =
                    data.links &&
                    data.links.find((link) => link.option_key === "holidays");

                if (holidaysLink && holidaysLink.option_value) {
                    try {
                        this.holidays = JSON.parse(holidaysLink.option_value);
                        // Also expose to window for ToolTip access
                        if (
                            typeof window !== "undefined" &&
                            window.CartV3Component
                        ) {
                            window.CartV3Component.holidays = this.holidays;
                        }
                    } catch (e) {
                        console.error("Error parsing holidays:", e);
                        this.holidays = [];
                    }
                } else {
                    this.holidays = [];
                }
            } catch (error) {
                console.error("Error fetching holidays:", error);
                this.holidays = [];
            }
        },

       // Calculate estimated date with holidays excluded (same as ToolTip)
         calculateEstimatedDateWithHolidays(baseDate, daysToAdd, holidays = []) {
            // Helper: get YYYY-MM-DD date string in New York timezone
            // This makes holiday comparison universal across all timezones
            var toNYDateString = function(date) {
                return new Intl.DateTimeFormat("en-CA", {
                    timeZone: "America/New_York",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }).format(date);
            };

            // Build a Set of NY holiday date strings
            // API returns "YYYY-MM-DD" strings — treat them as NY calendar dates directly
            // (no Date parsing needed, avoids UTC-shift problem entirely)
            var holidaySet = new Set(
                holidays.map(function(h) {
                    if (typeof h === "string" && /^\d{4}-\d{2}-\d{2}$/.test(h)) {
                        return h; // Already a NY calendar date string, use as-is
                    }
                    return toNYDateString(new Date(h)); // Fallback for other formats
                })
            );

            // Start from base date
            var currentDate = new Date(baseDate);
            var daysAdded = 0;

            // Add days one by one, skipping holidays (compared in NY timezone)
            while (daysAdded < daysToAdd) {
                currentDate.setDate(currentDate.getDate() + 1);
                if (!holidaySet.has(toNYDateString(currentDate))) {
                    daysAdded++;
                }
            }

            // Ensure final date is not a holiday (push forward if needed)
            while (holidaySet.has(toNYDateString(currentDate))) {
                currentDate.setDate(currentDate.getDate() + 1);
            }

            return currentDate;
        },

    // Ensure final date not holiday
  

        // Get estimated shipping date at runtime (same as Cart.vue)
        // _fromSibling: internal flag to avoid recursion when resolving date from same-product sibling
        getEstimatedShippingDate(item, _fromSibling = false) {
            if (!item) return null;

            // Check if rush option is selected
            let rushFeeBreakdown = item.rush_fee_breakdown;
            if (rushFeeBreakdown && typeof rushFeeBreakdown === "string") {
                try {
                    rushFeeBreakdown = JSON.parse(rushFeeBreakdown);
                } catch (e) {
                    console.error("Error parsing rush_fee_breakdown:", e);
                    rushFeeBreakdown = null;
                }
            }

            if (
                rushFeeBreakdown &&
                rushFeeBreakdown.services &&
                Array.isArray(rushFeeBreakdown.services)
            ) {
                const rushService = rushFeeBreakdown.services.find(
                    (service) => service.is_rush_option === true
                );

                if (rushService && rushService.service_id) {
                    // Calculate date based on rush option type (EXACT same as ToolTip)
                    let daysToAdd = 0;
                    switch (rushService.service_id) {
                        case "rush1":
                        case "rush_package":
                            daysToAdd = 1;
                            break;
                        case "rush3":
                            daysToAdd = 3;
                            break;
                        case "rush5":
                            daysToAdd = 5;
                            break;
                        case "rush7":
                            daysToAdd = 7;
                            break;
                        default:
                            daysToAdd = 0;
                    }

                    if (daysToAdd > 0) {
                        // Get holidays EXACTLY like ToolTip does (from window.CartV3Component first)
                        let holidays = [];
                        if (
                            typeof window !== "undefined" &&
                            window.CartV3Component
                        ) {
                            holidays = window.CartV3Component.holidays || [];
                        }
                        // Fallback to this.holidays if window not available
                        if (holidays.length === 0) {
                            holidays = this.holidays || [];
                        }

                        // If holidays not loaded yet, return null (will recalculate once loaded)
                        if (holidays.length === 0) {
                            return null;
                        }

                        // EXACT same calculation as ToolTip
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const estimatedDate =
                            this.calculateEstimatedDateWithHolidays(
                                today,
                                daysToAdd,
                                holidays
                            );
                        // Format date same as ToolTip - use local timezone methods
                        const localDate = new Date(
                            estimatedDate.getFullYear(),
                            estimatedDate.getMonth(),
                            estimatedDate.getDate()
                        );
                        const mm = String(localDate.getMonth() + 1).padStart(
                            2,
                            "0"
                        );
                        const dd = String(localDate.getDate()).padStart(2, "0");
                        const yyyy = localDate.getFullYear();
                        // Return in MM/DD/YYYY format (same as ToolTip displays)
                        return `${mm}/${dd}/${yyyy}`;
                    }
                }
            }

            // If no rush option, calculate using standard_shipping_days from decorator vendor
            const decoratorId =
                item.main_new_product &&
                item.main_new_product.default_decorator_id
                    ? item.main_new_product.default_decorator_id
                    : null;

            // Get vendors_list - try from this.vendors_list first, then window.CartV3Component
            let vendors_list = this.vendors_list || [];
            if (
                vendors_list.length === 0 &&
                typeof window !== "undefined" &&
                window.CartV3Component
            ) {
                vendors_list = window.CartV3Component.vendors_list || [];
            }

            if (decoratorId && vendors_list && vendors_list.length > 0) {
                const vendor = vendors_list.find((v) => v.id === decoratorId);
                if (
                    vendor &&
                    vendor.standard_shipping_days !== null &&
                    vendor.standard_shipping_days !== undefined
                ) {
                    // Get holidays - use same source as ToolTip
                    let holidays = [];
                    if (
                        typeof window !== "undefined" &&
                        window.CartV3Component
                    ) {
                        holidays = window.CartV3Component.holidays || [];
                    }
                    // Fallback to this.holidays if window not available
                    if (holidays.length === 0) {
                        holidays = this.holidays || [];
                    }

                    // If holidays not loaded yet, return null (will recalculate once loaded)
                    if (holidays.length === 0) {
                        return null;
                    }

                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const estimatedDate =
                        this.calculateEstimatedDateWithHolidays(
                            today,
                            vendor.standard_shipping_days,
                            holidays
                        );
                    // Format date same as ToolTip - use local timezone methods
                    const localDate = new Date(
                        estimatedDate.getFullYear(),
                        estimatedDate.getMonth(),
                        estimatedDate.getDate()
                    );
                    const mm = String(localDate.getMonth() + 1).padStart(
                        2,
                        "0"
                    );
                    const dd = String(localDate.getDate()).padStart(2, "0");
                    const yyyy = localDate.getFullYear();
                    // Return in MM/DD/YYYY format (same as ToolTip displays)
                    return `${mm}/${dd}/${yyyy}`;
                }
            }

            // Same product different color (sub): use parent's date so both show Est. Ship Date on cart
            if (!_fromSibling && this.cart_items && this.cart_items.length > 0 && item && item.main_new_product && item.main_new_product.id) {
                const productId = item.main_new_product.id;
                const sibling = this.cart_items.find(
                    (i) => i !== item && i.main_new_product && i.main_new_product.id === productId
                );
                if (sibling) {
                    const parentDate = this.getEstimatedShippingDate(sibling, true);
                    if (parentDate) return parentDate;
                }
            }
            return null;
        },

        // Format estimated shipping date for display (kept for backward compatibility)
        formatEstimatedShippingDate(dateString) {
            if (!dateString) return "";
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;
                const mm = String(date.getMonth() + 1).padStart(2, "0");
                const dd = String(date.getDate()).padStart(2, "0");
                const yyyy = date.getFullYear();
                return `${mm}/${dd}/${yyyy}`;
            } catch (e) {
                return dateString;
            }
        }
    }
};
</script>

<style>
.drawer_option .fixed_b_order_total_block .order-total-container {
    max-width: 1600px;
}
.drawer_option .fixed_b_order_total_block {
    z-index: 999;
}
.drawer_option .order-summary-drawer {
    width: 485px;
    height: 72.5vh;
}
.drawer_option .order-summary-drawer .drawer-header .drawer-close-btn {
    right: 470px;
}
.drawer_option .order_prod_item {
    margin-bottom: 20px;
    flex-direction: column;
}
.drawer_option .order_prod_item .order_prod_item_img_flex {
    justify-content: space-between;
    width: 100%;
}
.drawer_option
    .order_prod_item
    .order_prod_item_img_flex
    .order_prod_item_details {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    max-width: 100%;
}
.drawer_option
    .order_prod_item
    .order_prod_item_img_flex
    .order_prod_item_details
    .order_prod_name_content {
    width: 100%;
    max-width: 300px;
}

.order_prod_item_details
    .order_prod_item_cost_breakdown
    .cost-breakdown
    .cost-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    max-width: 100%;
    padding: 0px;
    margin-bottom: 12px;
    border: none;
}
.order_prod_item_details
    .order_prod_item_cost_breakdown
    .cost-breakdown
    .cost-separator {
    border-top: 0.3px solid #c1c1c1;
    margin-bottom: 4px;
}
.order_prod_item_details
    .order_prod_item_cost_breakdown
    .cost-breakdown
    .cost-item.cost-total
    .cost-label
    span {
    font-weight: bold;
}
.drawer_option .sub-items-wrapper {
    width: 100%;
}

.drawer_option .sub-items-wrapper .order_prod_item {
    border-bottom: none;
}
.drawer_option
    .order_prod_item
    .order_prod_item_img_flex
    .order_prod_item_details
    .order_prod_item_title {
    max-width: 190px;
}

.sub-items-wrapper .sub-items-container {
    margin-top: 15px;
}
.sub-items-wrapper .order_prod_item {
    margin-bottom: -20px;
}
.sub-items-wrapper .order_prod_item_title {
    max-width: 200px;
    margin-top: 18px;
}
.sub-items-wrapper .order_prod_item_cost_breakdown {
    margin-top: 20px;
}
/* .sub-items-wrapper .order_prod_item_cost_breakdown .cost-breakdown {
    width: 265px;
} */
.sub-items-wrapper .sub-items-container .hover-zoom-image {
    margin-top: 15px;
}
.sub-items-wrapper .sub-items-container .order_prod_item_title {
    margin-top: 15px !important;
}
.sub-items-wrapper .sub-items-container .discount-value {
    color: red !important;
}
.color-boxes {
    display: flex;
    flex-wrap: wrap;
    padding: 0px;
    margin-top: 8px;
    margin-bottom: 0px;
    align-items: center;
    gap: 2px;
}
.color-box {
    width: 12px;
    height: 12px;
    border: 1px solid #d9d9d9;
    display: block;
    margin-right: 2px;
    cursor: pointer;
}
.color-box-inner {
    width: 100%;
    height: 100%;
    border-radius: 0;
}
.color-box-inner-inner {
    width: 100%;
    height: 100%;
}
.drawer_option .order-summary-drawer .order-breakdown-section {
    padding-top: 0px !important;
}
.drawer_option .order-summary-drawer .drawer-content {
    max-height: 62vh;
    overflow-x: hidden;
}
/* k_k */
.sub-items-container .inner_order_prod_item_imp:last-child {
    margin-bottom: 0px;
    padding-bottom: 0px;
}

@media (max-width: 991px) {
    .drawer_option .fixed_b_order_total_block .order-total-container {
        padding: 0 16px;
    }

    .drawer_option .fixed_b_order_total_block .order-total-container .left-section,
    .drawer_option .fixed_b_order_total_block .order-total-container .right-section {
        min-width: 0;
    }

    .drawer_option .order-summary-drawer {
        width: min(460px, calc(100vw - 24px));
        right: 12px;
        height: 74vh;
    }

    .drawer_option .order-summary-drawer .drawer-header .drawer-close-btn {
        right: 12px;
        top: 12px;
        position: absolute;
    }

    .drawer_option .order_prod_item .order_prod_item_img_flex .order_prod_item_details {
        gap: 14px;
    }

    .drawer_option .order_prod_item .order_prod_item_img_flex .order_prod_item_details .order_prod_name_content {
        max-width: 100%;
    }

    .drawer_option .order-summary-drawer .drawer-content {
        max-height: 64vh;
    }
}

@media (max-width: 767px) {
    .drawer_option .fixed_b_order_total_block .order-total-container {
        padding: 0 10px;
    }

    .drawer_option .fixed_b_order_total_block .order-total-container .order-total-info {
        min-width: 0;
    }

    .drawer_option .fixed_b_order_total_block .order-total-container .order-total-label {
        width: auto !important;
    }

    .drawer_option .fixed_b_order_total_block .order-total-container .order-total-amount {
        white-space: nowrap;
    }

    .drawer_option .order-summary-drawer {
        width: 100vw;
        right: 0;
        left: 0;
        height: 78vh;
        border-radius: 12px 12px 0 0;
    }

    .drawer_option .order-summary-drawer .drawer-header .drawer-close-btn {
        right: 12px;
        top: 12px;
    }

    .drawer_option .order-summary-drawer .drawer-header {
        padding-right: 52px;
    }

    .drawer_option .order_prod_item {
        margin-bottom: 16px;
    }

    .drawer_option .order_prod_item .order_prod_item_img_flex {
        align-items: flex-start;
        gap: 10px;
    }

    .drawer_option .order_prod_item .order_prod_item_img_flex .order_prod_item_details {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .drawer_option .order_prod_item .order_prod_item_img_flex .order_prod_item_details .order_prod_name_content,
    .drawer_option .order_prod_item .order_prod_item_img_flex .order_prod_item_details .order_prod_item_cost_breakdown {
        max-width: 100%;
        width: 100%;
    }

    .drawer_option .order-summary-drawer .drawer-content {
        max-height: calc(78vh - 64px);
    }

    .sub-items-wrapper .order_prod_item_title {
        max-width: 100%;
    }
}

@media (max-width: 575px) {
    .drawer_option .fixed_b_order_total_block .order-total-container {
        padding: 0 8px;
    }

    .drawer_option .fixed_b_order_total_block .order-total-container .btn.btn-back,
    .drawer_option .fixed_b_order_total_block .order-total-container .btn.btn-next,
    .drawer_option .fixed_b_order_total_block .order-total-container .btn.btn_orange {
        min-width: 88px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .drawer_option .order-summary-drawer {
        height: 82vh;
    }

    .drawer_option .order-summary-drawer .drawer-content {
        max-height: calc(82vh - 64px);
        padding-left: 12px;
        padding-right: 12px;
    }
}
</style>
